var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect3, _rect4, _path18, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path19, _path20, _path21, _rect11, _rect12, _rect13, _rect14, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _g2, _rect15, _rect16, _text, _path34, _path35, _path36, _g3, _path37, _path38, _path39, _g4, _path40, _path41, _path42, _g5, _g6, _g7, _path43, _polygon, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g8, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _polygon2, _path91, _path92, _path93, _path94, _path95, _polygon3, _path96, _path97, _polygon4, _path98, _path99, _polygon5, _path100, _path101, _path102, _path103, _path104, _path105, _g9, _circle2, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _polygon6, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g10, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _g11, _path135, _path136, _path137, _path138, _path139, _path140, _polygon7, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g12, _g13, _g14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 800",
    enableBackground: "new 0 0 1200 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg_2_",
    fill: "#FFFFFF",
    width: 1200,
    height: 800
  })), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 896,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1EBEE4",
    width: 185,
    height: 651.76
  })), /*#__PURE__*/React.createElement("g", {
    id: "landscape"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M891.17,558.64c-10.27-1.14-11.62-8.87-21.86-6.57c-8.12,1.82-11.86-4.09-18.88,0.04 c-1.18,0.7-2.09,1.53-2.55,2.01c1.56,0.52,2.42,1.51,2.84,2.15c1.86-0.31,3.49,0.28,3.49,0.28c1.64-1.73,3.97-1.55,3.97-1.55 c-3.2,0.52-3.89,2.5-3.89,2.5c-4.32-1.99-7.6,1.64-7.6,1.64c0.98-1.72,2.34-2.49,3.64-2.79c-2.58-1.81-5.66-2.73-10-1.58 c-1.82,0.61-4.15,1.66-7.24,3.37c-5.12,2.84-19.76,4.4-30.53,4.7l103.82-1.49C906.39,561.34,907,560.4,891.17,558.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1067.43,465.88c-3.3-4.85-10.38-10.62-18.44-6.97c-1.54,0.76-3.25,1.85-5.06,3.42 c0.14,0.03,0.28,0.07,0.42,0.12c2.23,0.7,3.27,2.21,3.27,2.21s6.93-0.56,9.1,5.33c0,0-3.48-5.51-9.51-4.43 c0,0-2.67-4.32-9.76-1.89c0,0,2.94-2.08,6.27-1.38c0.63-0.85,2.03-2.49,4.37-3.97c-3.84-4.96-8.39-6.47-11.63-6.98 c-8.76-1.38-18.14,1.58-25.8,6.1c-15.33,9.06-29.14,9.9-45.53,14.86l123.73-1.65C1076.96,470.41,1072.08,463.05,1067.43,465.88z "
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M909.25,595.44c0.25,0.1,1.24,0.19,1.51,0.2c0.62,0.01,0.35,1.26,0.95,1.43 c3.1,0.86,3.12,2.97,2.8,5.19c0.85-0.51,2.49-0.37,3.16,0.36c0.67,0.73,1.26,2.16,1.41,3.14c-0.11-0.66,0.56-1.5,1.21-1.65 c0.65-0.15,1.21,0.43,1.39,1.07c0.89-0.78,2.03-0.13,1.99,1.05c0.76-0.16,1.39,0.1,1.75,0.8c0.37,0.73,0.51,2.04,0.62,2.82 c1.53-0.25,2.98-0.5,3.86,0.87c0.19,0.29,0.67,1.02,0.8,1.33c0.39-0.4,0.9-0.62,1.45-0.6c0.8,0.04,1.53,1.23,1.17,1.95 c0.36-0.31,1.12-1.01,1.59-1.05c0.47-0.05,0.68,0.28,0.62,0.76c0.14-0.43,0.93-0.33,1.29-0.06c0.41,0.3,0.85,0.97,1.25,1.27 c1.14-1.5,2.41-2.3,4.14-1.53c1.78,0.79,1.74,2.29,2.33,4.18c0.28-0.37,0.3-1.3,0.7-1.05c0.3,0.19-0.02,0.74,0.14,1.05 c0.47,0.96,2.62-0.62,2.9,1.99c0.17-0.02,0.91-0.12,1.07-0.14c0.94-0.02,1.89,0.89,2.27,1.25c0.69-2.01,3.39-3.87,5.46-4.4 c-0.42-2.11-0.34-4.4,1.38-5.69c1.72-1.29,3.34-0.62,5.25,0.37c0.97-1.91,4.23-2.95,6.05-1.8c0.95-2.88,3.6-5.37,6.56-5.99 s4.95,1.2,6.99,3.45c0.82,0.91,1.89,1.5,3.02,1.96c0.57,0.23,0.96,0.87,1.56,1.01c1.4,0.32,1.49,1.51,2.23,2.74 c0.26,0.44,1.76-0.9,2.14-0.57c0.09,0.08,1.89,1.64,1.99,1.7c1.79-4.93,6.57-5.67,7.05-6.63c0.5-1,1.11-2.37,1.43-3.45 c1.12-3.87,4.63-4.92,8.6-5.78c3.97-0.86,5.3-0.55,7.95,2.49c0.44,0.5,1.82,0.82,2.44,1.01c2.02-1.22,4.91-1,7.26-0.51 c0.72,0.15,0.96,0.29,1.64,0.57c0.97,0.35,1.46-0.03,2.28,0.6c0.33,0.26,0.09,1.21,0.42,1.52c0.68,0.6-0.51,0.04,0.05,0.74 c-8.81,4.51-17.6,13.68-17.6,13.68c8.37-5.72,19.15-8.3,23.33-9.97c1.53-0.56,3.95-1.53,5.62-2.07 c15.81-5.11,30.45-7.35,43.37-5.73c-30.59-24.23-47.37-48.09-20.62-64.1c38.86-23.26-21.09-39.6-18-41.64 c-12.29,1.61-23.56,10.26-40.71,24.78c-36.12,30.59-66.91,60.61-99.38,75.48c0.02,0.02-0.82,0.66-0.8,0.68 C908.86,594.81,908.87,595.29,909.25,595.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M866.95,583.64c10.01,0.7,14.72,8.8-0.75,18.25c-15.47,9.45-18.62,15.12-7.16,20.28 s3.61,11.17,5.73,16.14c1.6,3.77,13.14,8.36,19.76,9.15c1.5,0,3.33-1.39,4.81-1.39c2.16-0.54,4.02-0.91,5.57-1.35 c0.06-0.07,0.7-0.31,0.77-0.37c0.44-0.38,0.89-0.69,1.35-1.04c0.45-0.35,0.25-0.79,0.82-0.76c0.3,0.02,0.85,0.43,1.13,0.31 c0.3-0.13,0.82-0.76,0.94-1.07c0.35-0.88,0.96-0.99,1.86-0.68c0.23-0.76,0.81-1.16,1.43-1.64c0.62-0.49,0.82-0.88,1.59-0.69 c0.86,0.22,0.73,0.41,1.11,1.22c0.3,0.63,0.79,1.46,0.9,2.15c0.45-0.04,1.83-0.13,2.39-0.13c-0.04-0.26,0.17-1.23,0.21-1.48 c0.06-0.41,0.22-1.05,0.13-1.46c-0.18-0.9-0.58-0.57-0.74-1.48c-0.1-0.55,0.75-0.89,0.87-1.19c0.23-0.53-0.68-1.84-0.98-2.33 c-0.3-0.49-0.05-0.7-0.24-1.25c-0.34-0.98-0.73-1.69-0.34-2.65c0.07-0.17,0.62-0.4,0.61-0.58c-0.02-0.38-0.19-1.16-0.42-1.46 c-0.74-0.97-0.97-1.42,0.08-2.04s2.33-1.2,2.33,1.91c0,0.53-0.15,3.58-0.13,6.31c0.1-0.06,1.05-0.13,1.17-0.13h0.76l0.34-0.44 c-0.01-0.8,0.37-1.07,1.1-1.41c0.73-0.34,1.64,0.22,2.25,0.74c0.26-1.14,1.47-2.59,2.63-2.71s2.06,0.68,3.04,1.31 c0.2,0.13,1.45,0.53,1.67,0.44c0.14-0.06,0.2-0.98,0.28-1.11c0.55-0.91,1.22-1.53,1.91-2.35c0.69-0.81,0.66-1.02,1.71-1.17 s1.95,0.44,2.39,1.41c0.7-0.54,1.76-0.94,2.62-1.13c0.86-0.19,1.56-0.83,2.09-0.12c0.42,0.57,0.55,1.62,1.01,2.15 c1.5-0.64,3.25-1.3,4.75-0.68c0.92,0.38,1.68,1.08,2.6,1.43c1.14,0.43,2.35,0.51,3.57,0.56c0.49,0.02,1.41-0.15,1.86,0.08 c0.25-0.77,0.67-1.96,0.84-2.76c0.29-1.37,0.95-2.38,2.29-2.78c0.43-0.13,1.46-0.41,1.9-0.34c-1.05-1.12-1.45-2.96-1.5-4.49 c-0.02-0.73-1.12-1.4-0.88-2.09c-0.37-0.36-0.94-0.6-1.89-0.58c-0.17,0.02-0.33,0.03-0.5,0.05c-0.28-2.61-1.98-0.88-2.46-1.84 c-0.16-0.32-0.15-0.75-0.45-0.94c-0.39-0.25-0.86,0.17-1.14,0.54c-0.59-1.89-0.19-3.21-1.97-4c-1.72-0.76-3.26-0.1-4.39,1.4 c-0.41-0.3-0.81-0.61-1.22-0.91c-0.36-0.27-1.02-0.47-1.16-0.03c0.07-0.47-0.48-0.84-0.95-0.8c-0.47,0.05-0.87,0.37-1.23,0.68 c0.36-0.71-0.35-1.62-1.15-1.66c-0.55-0.03-1.06,0.25-1.45,0.65c-0.12-0.32-0.28-0.63-0.47-0.92 c-0.88-1.38-2.38-1.77-3.91-1.53c-0.11-0.78-0.06-1.54-0.43-2.27c-0.36-0.69-1.13-1.24-1.89-1.08c0.04-1.19-1.65-1.99-2.54-1.2 c-0.19-0.64-0.92-1.07-1.57-0.92c-0.65,0.15-1.12,0.86-1.01,1.52c-0.15-0.98-0.43-1.98-1.1-2.71 c-0.67-0.73-1.84-1.07-2.68-0.56c0.31-2.21,0.16-4.9-2.93-5.76c-0.6-0.17-0.94-0.92-1.56-0.93c-0.27,0-0.56,0.08-0.81-0.02 c-0.37-0.16-0.38-0.69-0.68-0.97c-0.02-0.02-0.04-0.03-0.06-0.05c-1.71-1.58-2.25-0.31-2.96-1.28 c-0.58-0.79-0.75-1.42-1.4-2.16c-2.18-2.49-5.55-1.53-7.48-0.41c-0.45-0.01-0.84-0.28-1.27-0.43c-0.9-0.31-1.99,0.01-2.58,0.76 c-1.73-1.12-2.25-1.8-3.83-2.38c-1.39-0.51-4.01-0.33-5.14,0.63c-0.78-0.92-2.13-1.3-3.29-0.97 c-5.67-2.53-10.74-4.03-15.93-4.03c-2.25,0-4.46,0.34-6.68,0.97C861.87,583.7,864.5,583.46,866.95,583.64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M782.02,645.41c20.67,0,64.94,0.04,102.72,0.06c-6.62-0.79-17.33-3.99-18.93-7.76 c-2.11-4.98,5.73-10.53-5.73-15.69c-11.46-5.16-7.45-10.03,8.02-19.48c15.47-9.45,8.86-18.2-1.15-18.91 c-2.45-0.17-5.08,0.07-8.13,0.91c-8.09,2.23-19.03,8.69-36.86,22.92c-25.27,20.17-60.28,37.99-60.28,37.99l20.73,0.03 C782.16,645.44,782.02,645.41,782.02,645.41z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M997.89,614.1c0.95-1.3,2.26-2.33,3.76-2.91c2.4-0.92,5.23-0.66,7.42,0.7 c-1.33-2.06-3.96-3.19-6.37-2.75c-0.08-2.33,1.35-4.65,3.47-5.62c2.12-0.98,4.81-0.55,6.53,1.02c3.59-2.35,8.64-2.22,12.1,0.33 c-0.93-1.92-2.7-3.41-4.76-3.99c0.53-0.68,1.18-1.23,1.9-1.67c-0.62-0.18-1.08-0.76-1.52-1.26c-2.65-3.05-7.05-4.49-11.01-3.63 c-3.97,0.86-7.34,4-8.46,7.87c-0.31,1.07-0.46,2.2-0.97,3.2c-0.48,0.96-5.27,0.14-7.07,5.07c0.33,0.2,0.72,0.31,1.09,0.44 C995.6,611.49,996.98,612.65,997.89,614.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1064.14,534.94c-26.74,16.01-8.38,39.37,22.21,63.6c-12.91-1.62-27.46-0.79-43.27,4.32 c-1.67,0.54-3.26,1.09-4.79,1.66c-4.18,1.66-11.94,5.14-20.31,10.87c0,0,9.81-7.76,18.62-12.27c-0.57-0.7-1.19-1.37-1.87-1.97 c-0.36-0.32-0.73-0.63-1.12-0.9c-0.8-0.58-1.67-1.05-2.58-1.43c-0.68-0.28-1.39-0.5-2.11-0.65c-2.35-0.49-4.97-0.18-6.99,1.05 c-0.72,0.44-1.37,0.99-1.9,1.67c2.05,0.58,3.83,2.07,4.76,3.99c-3.46-2.54-8.51-2.68-12.1-0.33c-1.72-1.58-4.41-2-6.53-1.02 c-2.12,0.98-3.55,3.29-3.47,5.62c2.41-0.44,5.04,0.69,6.37,2.75c-2.19-1.36-5.02-1.63-7.42-0.7c-1.5,0.58-2.81,1.61-3.76,2.91 c-0.91-1.45-2.29-2.61-3.89-3.2c-0.37-0.14-0.75-0.25-1.09-0.44c-0.1-0.06-0.2-0.13-0.29-0.21c-0.38-0.33-0.59-0.82-0.85-1.25 c-0.74-1.23-1.99-2.14-3.39-2.46c-0.6-0.14-1.22-0.17-1.79-0.4c-1.14-0.46-1.83-1.59-2.65-2.5c-2.03-2.25-5.29-3.31-8.25-2.68 c-2.96,0.62-5.52,2.91-6.47,5.78c-1.82-1.14-4.55-0.39-5.52,1.52c-1.9-0.99-4.37-0.79-6.08,0.49c-1.72,1.29-2.6,3.59-2.19,5.7 c-2.07,0.53-3.76,2.22-4.45,4.23c-0.24,0.69-0.36,1.42-0.33,2.15c0.05,1.54,0.73,3.01,1.78,4.13c0.93,0.14,1.8,0.7,2.19,1.55 c0.02,0.01,0.04,0.02,0.06,0.03c0.35-0.08,1.13-0.31,1.47-0.4l1.12-1.84l0.03-0.53l7.21-7l12.09-0.08l0.74-0.05l5.49-0.13h0.85 l5.52,0.45l1.13-0.5l5.17,0.19l1.35,0.16l4.66,0.37l0.83-0.32l4.76,0.3l-0.92,4.06c0.01,0,0.55,0.13,0.56,0.13 c-0.01,0.04-0.55-0.17-0.56-0.13c-0.02,0.14,0.58-0.01,0.56,0.13c-0.99-0.17-2.59,0.11-2.52,1.11c-0.24,0,0.07,0.43-0.16,0.5 c-0.02,0.01,0.02-0.01,0,0c-0.77,0.28-1.15,1.08-1.33,1.88c-0.02,0.07-0.74,0.62-0.76,0.69c-0.03,0.18,0.35,0.31,0.26,0.48 c-0.13,0.23-0.49,0.39-0.69,0.56c-0.49,0.41-0.17,0.49-0.45,1.07c-0.1-0.1,0,0-0.11-0.09c-0.15-0.12-0.09-0.49-0.26-0.59 c-0.69-0.4-1.79-0.81-2.58-0.68c-0.75,0.12-1.95,0.74-2.47,1.3c-0.18,0.2-1.18,0.47-1.32,0.7c-0.02,0.04,0.19,0.56,0.16,0.6 c-0.08,0.15,0,0-0.06,0.16c-0.06,0.18-0.13,0.72-0.16,0.91c-1.5-0.03-3.07,1.16-2.84,2.64c-0.35,0.07-0.56,0.03-0.87,0.19 c-0.77,0.39-0.39,0.83-0.8,1.59c-0.66-0.78-1.53-1.41-2.51-1.62c-0.34-0.07-1.22-0.13-1.57-0.08c-0.62,0.08-2,0.86-2.41,1.33 c-0.13,0.15-0.38,0.68-0.48,0.85c-0.27,0.48-0.89,0.42-0.72,0.95c-0.25-0.09,0.26,0.39,0,0.45c-0.17,0.04,0.02,0.31-0.13,0.4 c-0.4,0.23-0.88,0.25-0.93,0.72c-0.92,0.45-1.68,0.02-2.47,0.66c-0.19,0.15-0.71,0.51-0.89,0.67 c-0.13,0.11,0.02,0.96-0.11,1.08c-0.16,0.16-0.03,0.52-0.19,0.69c-0.05,0.06-0.69-0.06-0.74,0c-1.23,0.34-0.81-0.19-2.15,0.11 c-1.93,0.42-2.18,0.83-4.37,1.15c-0.01-2.66-1.55-4.1-1.7-5.31c-0.53-4.43-2.3-7.91-3.15-12.28c-0.04,0.3-0.72,1.6-0.74,1.91 c-0.18,3.12-0.83,4.25-1.33,6.65c-0.49,2.37-2.06,5.64-1.21,7.87c0.32,0.83-0.23,1.46,0,2.43c-0.35,0.04-0.84-0.65-1.2-0.62 c-2.39,0.22-3.73,0.2-6.43,0.31c-0.16,0.01-0.68,0.75-0.84,0.76c-2.34,0.09-4.28-0.08-6.88-0.08c-0.04,0-0.32,0.32-0.36,0.32 c-0.12,0-0.16-0.04-0.28-0.04c-2.43-0.01-4.79-0.14-7.28-0.28c-0.16-0.01-0.36-0.27-0.52-0.28c-2.49-0.15-4.85-0.49-7.28-0.72 c-0.16-0.01-0.83,0.05-0.99,0.04c-2.37-0.22-4.6-0.36-6.8-0.6c-4.66-0.49-7.58-0.43-10.78-0.6c-0.01-1.43-1.07-4.54-1.09-7.58 c-0.01-2.73-0.02-5.19-0.02-5.72c0-3.11-2.52-3.13-3.57-2.51c-1.05,0.62-1.32,2.22-0.57,3.19c0.23,0.3,0.55,0.58,0.57,0.96 c0.01,0.19-0.06,0.37-0.13,0.54c-0.38,0.96-0.79,2.02-0.45,3c0.19,0.54,0.58,0.98,0.89,1.47c0.3,0.49,0.51,1.1,0.28,1.63 c-0.13,0.3-0.39,0.81-0.29,1.36c0.16,0.91,0.89,0.95,1.08,1.86c0.08,0.41-0.08,0.82-0.14,1.24c-0.04,0.26-0.03,0.52,0.02,0.78 c-0.56,0-1.06,0.02-1.51,0.06c-0.11-0.69-0.26-1.37-0.55-2c-0.38-0.81-1.05-1.52-1.91-1.74c-0.77-0.19-1.61,0.04-2.23,0.53 c-0.62,0.49-1.05,1.2-1.27,1.96c-0.89-0.31-1.99,0.19-2.34,1.07c-0.12,0.3-0.2,0.67-0.5,0.8c-0.28,0.12-0.59-0.05-0.9-0.07 c-0.57-0.04-1.02,0.44-1.47,0.79c-0.46,0.36-1,0.61-1.44,0.99c-0.07,0.06-0.13,0.12-0.2,0.19c-1.54,0.44-3.25,0.93-5.41,1.48 c-1.91,0.48-4.18,1.01-7.01,1.58c-0.88,0.18,150.22,11.34,150.22,11.34l112.96-10.42V544.93 c-11.78-8.36-50.17-35.47-61.28-41.51c-13.18-7.16-22.92-10.89-33.8-10.03c-0.42,0.03-0.69,0.1-0.84,0.19 C1046.37,495.62,1103,511.68,1064.14,534.94z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M978.56,640.1c0.12-0.12,0.24-0.24,0.37-0.35h-0.37V640.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 978.7498,
    y1: 625.6273,
    x2: 978.7498,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M978.56,640.1c0.12-0.12,0.24-0.24,0.37-0.35h-0.37V640.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1001.49,615.7v-0.03l-6.12,0.03v-0.03l-6.19,0.03v-0.03L983,615.7v-0.03l-6.06,0.03v-0.03l-14.09,0.07 l-6.98,7.9h-0.17l-0.16,3.33c0.14-0.04,0.5,0.07,0.64,0.04c0.96-0.17,0.86-0.17,1.59,0.48c0.73,0.65,1.25,1.46,1.19,2.44 c-0.01,0.17,0.95,0.39,1.07,0.51c0.13,0.13,0.46,0.42,0.64,0.4c0.87-0.1,0.92-0.19,1.31,0.6c0.34,0.69-0.16,0.98-0.22,1.75 l-4.94-0.68l-1.08,0.4l-34.83-0.12l-8.41,0.76h-0.89c-0.12,0-0.23,0.03-0.33,0.09c0.01,3.04,0.03,6.42,0.04,7.85 c3.2,0.17,7.38,0.62,12.04,1.11v-0.02c2.2,0.23,4.51,0.47,6.88,0.69v0.02c0.16,0.01,0.32,0.03,0.48,0.04 c2.43,0.22,4.92,0.42,7.4,0.57c0.16,0.01,0.32,0.02,0.48,0.03c2.49,0.14,4.97,0.23,7.4,0.24c0.12,0,0.23,0,0.35,0 c0.04,0,0.08,0,0.13,0c2.6,0,5.06-0.05,7.4-0.14c0.16-0.01,0.32-0.01,0.48-0.02c2.7-0.11,5.24-0.28,7.63-0.51 c0.36-0.03,0.71-0.07,1.06-0.1c-0.23-0.98-0.21-2.09-0.21-2.99c-0.01-2.43,0.89-5.44,1.39-7.81c0.5-2.41,0.79-3.51,0.97-6.64 c0.02-0.31,0.09-0.61,0.13-0.91c0.86,4.37,1.73,7.26,2.26,11.69c0.15,1.2,0.32,3.4,0.33,6.06c2.19-0.32,4.25-0.69,6.17-1.11 c1.34-0.29,2.62-0.61,3.84-0.94c0.05-0.06,0.1-0.12,0.16-0.17c0.16-0.17,0.32-0.33,0.48-0.49v-0.35h0.37 c0.18-0.16,0.37-0.32,0.56-0.48c0.79-0.64,1.65-1.2,2.57-1.64c0.05-0.46,0.36-0.86,0.75-1.09c0.15-0.09,0.31-0.15,0.48-0.19 c0.26-0.06,0.53-0.05,0.78,0.05c-0.17-0.54-0.07-1.09,0.2-1.57c0.09-0.17,0.21-0.33,0.34-0.48c0.42-0.47,1-0.8,1.62-0.88 c0.36-0.05,0.71-0.02,1.05,0.05c0.98,0.21,1.89,0.85,2.55,1.63c0.41-0.76,1.07-1.38,1.84-1.77c0.32-0.16,0.65-0.28,1-0.36 c-0.24-1.48,1.09-3,2.58-2.97c0.03-0.19,0.08-0.37,0.14-0.54h-3.7v-0.48h3.9c0.02-0.04,0.05-0.08,0.07-0.13 c0.13-0.23,0.3-0.45,0.48-0.64c0.52-0.56,1.21-0.96,1.96-1.08c0.78-0.13,1.6,0.05,2.29,0.44c0.17,0.1,0.33,0.21,0.48,0.33 c0.11,0.09,0.21,0.18,0.31,0.29c0.28-0.58,0.67-1.11,1.16-1.52c0.2-0.17,0.42-0.33,0.55-0.56c0.09-0.16,0.12-0.35,0.16-0.53 c0.01-0.07,0.03-0.15,0.04-0.22c0.18-0.8,0.81-1.47,1.58-1.76l0.05-0.02c0.23-0.08,0.46-0.12,0.7-0.13 c-0.07-1,0.95-1.92,1.93-1.75c0.02-0.14,0.04-0.28,0.07-0.42v-0.13v-5.53L1001.49,615.7z M930.24,641.3h-6.88v-0.02h6.88V641.3 z M930.24,638.2h-6.88v-0.02h6.88V638.2z M938.12,641.3h-7.4v-0.02h7.4V641.3z M938.12,638.2h-7.4v-0.02h7.4V638.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 993.6662,
    y1: 625.6273,
    x2: 993.6662,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M991.67,625.63v7.75c0.32-0.16,0.65-0.28,1-0.36c-0.24-1.48,1.09-3,2.58-2.97 c0.03-0.19,0.08-0.37,0.14-0.54h-3.7v-0.48h3.9c0.02-0.04,0.05-0.08,0.07-0.13v-3.27H991.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.2698,
    y1: 625.6273,
    x2: 998.2698,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M996.14,625.63v2.63c0.52-0.56,1.21-0.96,1.96-1.08c0.78-0.13,1.6,0.05,2.29,0.44v-1.99H996.14z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1001.9618,
    y1: 625.6273,
    x2: 1001.9618,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M1000.87,625.63v2.32c0.11,0.09,0.21,0.18,0.31,0.29c0.28-0.58,0.67-1.11,1.16-1.52 c0.2-0.17,0.42-0.33,0.55-0.56c0.09-0.16,0.12-0.35,0.16-0.53H1000.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 985.2851,
    y1: 625.6273,
    x2: 985.2851,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M987.28,625.63h-3.98v3.4h3.97v0.48h-3.97v4.84h1.31c0.42-0.47,1-0.8,1.62-0.88 c0.36-0.05,0.71-0.02,1.05,0.05V625.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 976.0862,
    y1: 625.6273,
    x2: 976.0862,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M974.11,639.75v-0.48h3.98v-4.45h-3.98v-0.48h3.98v-4.84h-3.98v-0.48h3.98v-3.4h-4v16.07 c1.34-0.29,2.62-0.61,3.84-0.94c0.05-0.06,0.1-0.12,0.16-0.17v-0.84H974.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 980.6898,
    y1: 625.6273,
    x2: 980.6898,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M978.56,634.82v4.45h0.93c0.79-0.64,1.65-1.2,2.57-1.64c0.05-0.46,0.36-0.86,0.75-1.09v-1.71 H978.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.7807,
    y1: 625.6273,
    x2: 983.7807,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M983.29,636.35c0.26-0.06,0.53-0.05,0.78,0.05c-0.17-0.54-0.07-1.09,0.2-1.57h-0.97V636.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 980.6898,
    y1: 625.6273,
    x2: 980.6898,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 978.56,
    y: 625.63,
    fill: "url(#SVGID_9_)",
    width: 4.25,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 980.6898,
    y1: 625.6273,
    x2: 980.6898,
    y2: 643.7404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 978.56,
    y: 629.5,
    fill: "url(#SVGID_10_)",
    width: 4.25,
    height: 4.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 926.7933,
    y1: 635.4149,
    x2: 926.7933,
    y2: 645.4094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M923.35,641.79v0.82c2.2,0.23,4.51,0.47,6.88,0.69v-1.51H923.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.4167,
    y1: 635.405,
    x2: 934.4167,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 930.72,
    y: 635.4,
    fill: "url(#SVGID_12_)",
    width: 7.4,
    height: 2.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.2981,
    y1: 635.405,
    x2: 942.2981,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 938.6,
    y: 638.67,
    fill: "url(#SVGID_13_)",
    width: 7.4,
    height: 2.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 950.1794,
    y1: 635.405,
    x2: 950.1794,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 946.48,
    y: 638.67,
    fill: "url(#SVGID_14_)",
    width: 7.4,
    height: 2.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.2981,
    y1: 635.405,
    x2: 942.2981,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 938.6,
    y: 635.4,
    fill: "url(#SVGID_15_)",
    width: 7.4,
    height: 2.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.4167,
    y1: 635.405,
    x2: 934.4167,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 930.72,
    y: 638.67,
    fill: "url(#SVGID_16_)",
    width: 7.4,
    height: 2.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 926.7933,
    y1: 635.405,
    x2: 926.7933,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 923.35,
    y: 638.67,
    fill: "url(#SVGID_17_)",
    width: 6.88,
    height: 2.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.4135,
    y1: 635.4149,
    x2: 934.4135,
    y2: 645.4094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M930.71,641.79v1.56c2.43,0.22,4.92,0.42,7.4,0.57v-2.13H930.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.2981,
    y1: 635.4149,
    x2: 942.2981,
    y2: 645.4094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M938.6,641.79v2.16c2.49,0.14,4.97,0.23,7.4,0.24v-2.4H938.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 950.1794,
    y1: 635.4145,
    x2: 950.1794,
    y2: 645.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M946.48,641.79v2.4c2.6,0,5.06-0.05,7.4-0.14v-2.26H946.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 926.7966,
    y1: 635.405,
    x2: 926.7966,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 923.36,
    y: 635.4,
    fill: "url(#SVGID_21_)",
    width: 6.88,
    height: 2.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.1728,
    y1: 635.405,
    x2: 958.1728,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 954.36,
    y: 635.4,
    fill: "url(#SVGID_22_)",
    width: 7.63,
    height: 2.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 950.1794,
    y1: 635.405,
    x2: 950.1794,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 946.48,
    y: 635.4,
    fill: "url(#SVGID_23_)",
    width: 7.4,
    height: 2.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.1728,
    y1: 635.405,
    x2: 958.1728,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 954.36,
    y: 638.67,
    fill: "url(#SVGID_24_)",
    width: 7.63,
    height: 2.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.1728,
    y1: 635.405,
    x2: 958.1728,
    y2: 645.3995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M954.36,641.78v2.24c2.7-0.11,5.24-0.28,7.63-0.51v-1.74H954.36z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M949.21,632.12c0.94-0.49,2.24-0.07,2.72,0.88c0.4-0.33,0.86-0.58,1.38-0.65 c0.92-0.12,2.14,0.73,1.84,1.15l0.57,0l7.24,0.01c0.06-0.77,0.12-1.58-0.22-2.27c-0.39-0.78-1.3-1.27-2.16-1.17 c-0.18,0.02-0.39,0.06-0.52-0.07c-0.12-0.12-0.11-0.31-0.1-0.47c0.06-0.98-0.35-1.97-1.08-2.62c-0.73-0.65-1.76-0.94-2.73-0.77 c-0.15,0.03-0.29,0.06-0.44,0.1c-0.35,0.1-0.69,0.22-1.04,0.3c-0.01,0-0.03,0.01-0.04,0.01c-0.01-0.01-0.01-0.02-0.02-0.04 c-0.39-0.85-1.26-1.4-2.19-1.55c-0.44-0.07-0.9-0.05-1.33,0.08c-1.34,0.4-2.33,1.65-2.62,3.02c-0.17,0.8-0.14,1.65-0.39,2.42 C948.74,630.84,949.24,631.39,949.21,632.12z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M955.15,633.51C955.15,633.51,955.15,633.5,955.15,633.51c0.3-0.43-0.93-1.28-1.84-1.16 c-0.51,0.07-0.97,0.32-1.38,0.65c-0.48-0.94-1.78-1.36-2.72-0.88c0.03-0.73-0.47-1.28-1.13-1.63 c-0.45-0.23-0.97-0.37-1.47-0.39c-1.22-0.05-2.49,0.28-3.63-0.16c-0.93-0.35-1.62-1.16-2.54-1.54c-1.5-0.62-3.2,0.03-4.7,0.67 c-0.47-0.53-0.52-1.31-0.94-1.88c-0.52-0.71-1.54-0.93-2.4-0.73c-0.86,0.19-1.61,0.72-2.32,1.25c-0.44-0.97-1.62-1.45-2.67-1.3 c-1.05,0.15-1.97,0.83-2.65,1.64c-0.69,0.81-1.18,1.76-1.73,2.68c-0.08,0.13-0.17,0.27-0.32,0.33 c-0.22,0.09-0.47-0.06-0.67-0.19c-0.98-0.64-2.14-1.09-3.31-0.97c-1.16,0.12-2.31,0.91-2.57,2.05 c-0.61-0.52-1.53-0.65-2.26-0.31c-0.73,0.34-1.41,1.05-1.4,1.85v0.03L955.15,633.51z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M991.69,629.5h3.7c0.06-0.16,0.13-0.32,0.21-0.48h-3.9V629.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEE7F5",
    d: "M1156.45,678.53v-5.82c0-2.68,0,0,0-2.68v-0.1c0,0-0.04-15.47,0-25.26c0,0-58.8,1.99-68.59,1.68 c-43.28,0-93.8,0.77-106.1,0.77c-35.6,0-25.76-2.12-41.02-2.12c-11.42,0-11.66,1.34-14.3,1.34c-1.46,0-5.78-1.71-12.41-1.71 c-8.05,0-25.21-0.55-48.47-0.55c-14.76,0-30.81,0.47-42.68,0.47c-12.54,0-25.21-1.75-28.79-2.28l-21.33-0.12 c0,0,41.07,5.41,82.09,55.55c31.63,38.65,46.34,50.38,55.66,56.87c86.64,60.33,204.04,33.18,245.94,20.3v-90.89 C1156.45,678.53,1156.45,683.98,1156.45,678.53z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 939.44,
    cy: 515.89,
    r: 20.03
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    opacity: 0.3,
    d: "M957.46,638.15h-7.35h-33.74c0.36,0,0.65,0.29,0.65,0.65v7.98 c0.54,0.06,1.09,0.11,1.64,0.17v-0.8h6.68v1.47c0.15,0.01,0.31,0.03,0.46,0.04v-1.51h7.19v2.07c0.15,0.01,0.31,0.02,0.46,0.03 v-2.1h7.19v2.33c0.11,0,0.23,0,0.34,0c0.04,0,0.08,0,0.12,0v-2.33h7.19v2.19c0.15-0.01,0.31-0.01,0.46-0.02v-2.18h7.41v1.69 c0.35-0.03,0.69-0.07,1.03-0.1c-0.22-0.95-0.2-2.03-0.2-2.9c-0.01-1.98,0.61-4.35,1.09-6.42 C957.93,638.26,957.71,638.15,957.46,638.15z M925.34,645.69h-6.68v-2.55h6.68V645.69z M918.66,642.67v-2.71h6.68v2.71H918.66z  M932.99,645.69h-7.19v-2.55h7.19V645.69z M925.81,642.67v-2.71h7.19v2.71H925.81z M940.65,645.69h-7.19v-2.55h7.19V645.69z  M933.46,642.67v-2.71h7.19v2.71H933.46z M948.3,645.69h-7.19v-2.55h7.19V645.69z M941.11,642.67v-2.71h7.19v2.71H941.11z  M948.76,645.69v-2.55h7.41v2.55H948.76z M956.17,642.67h-7.41v-2.71h7.41V642.67z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M912.3,635.29v6.26c2.24,0.15,4.89,0.41,7.8,0.71v-6.97H912.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M970.69,623.67h0.03v18.7c1.16-0.21,2.29-0.43,3.37-0.66v-16.07h4v3.4h-3.98v0.48h3.98v4.84h-3.98v0.48 h3.98v4.45h-3.98v0.48h3.98v0.84c0.16-0.17,0.32-0.33,0.48-0.49v-0.35h0.37c0.18-0.16,0.37-0.32,0.56-0.48h-0.93v-4.45h4.25 v1.71c0.15-0.09,0.31-0.15,0.48-0.19v-1.53h0.97c0.09-0.17,0.21-0.33,0.34-0.48h-1.31v-4.84h3.97v-0.48h-3.97v-3.4h3.98v7.88 c0.98,0.21,1.89,0.85,2.55,1.63c0.41-0.76,1.07-1.38,1.84-1.77v-7.75h4v3.27c0.13-0.23,0.3-0.45,0.48-0.64v-2.63h4.25v1.99 c0.17,0.1,0.33,0.21,0.48,0.33v-2.32h2.18c0.01-0.07,0.03-0.15,0.04-0.22c0.23-1.06,1.25-1.88,2.33-1.9 c-0.07-1,0.95-1.92,1.93-1.75c0.01-0.07,0.02-0.13,0.03-0.2l-0.01-5.89v0l0,0l-5.88,7.58v0.38l-0.03,0l-0.02-7.95v0l0,0 l-6.07,7.82v0.13l-0.03,0l-0.02-7.95v0l0,0l-6.14,7.91v0.05l-0.03,0l-0.02-7.95v0l0,0l-6.14,7.91v0.05l-0.03,0l-0.02-7.95v0l0,0 l-6.01,7.74v0.21l-0.03,0l-0.02-7.95v0l0,0L970.69,623.67z M982.82,634.35h-4.25v-4.84h4.25V634.35z M982.82,629.03h-4.25v-3.4 h4.25V629.03z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M981.46,668.76c-7.79,0-17.75,0-27.28,0s-2.47,3.41,7.12,3.41c0.43,0,0.77,0,1.03,0c0.02,0,0.22,0,0.76,0 c0.82,0,2.42,0,5.38,0C985.79,672.17,989.25,668.76,981.46,668.76z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M991.88,687.28c12.39,0,131.55,0,153.5,0v-5.46c-21.38,0-136.13,0-151.47,0 C976.98,681.83,978.23,687.28,991.88,687.28z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1038.15,676c11.39,0,89.73,0,107.23,0v-2.68c-16.9,0-91.23,0-105.32,0 C1024.13,673.33,1025.31,676,1038.15,676z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M882.2,647.05c2.83-0.57,5.1-1.1,7.01-1.58c-1.48,0-2.97,0-4.47,0c-37.78-0.02-82.05-0.06-102.72-0.06 c0,0,0.14,0.02,0.4,0.06c0.16,0.02,0.35,0.05,0.59,0.09c3.58,0.53,16.25,2.28,28.79,2.28c11.87,0,27.67,1.66,42.43,1.66 c23.26,0,41.17,0,49.23,0c6.63,0,16,2.11,9.46,2.11c-2.91,0-6.14,0.13-10.51,0.13c-11.02,0-10.6,3.01,0.81,3.01 c15.26,0,38.59,0,74.19,0c12.3,0,7.78,2.97,3.27,2.97c-4.7,0-11.87,0.21-15.88,0.21c-6.36,0-13.01,1.9-9,2.91 c2.41,0.6,12.84,0.52,17.77,0.52c6.76,0,53,0,96.29,0c19.58,0.63,11.38,3.21,1.77,3.21c-10.94,0-14.28,0.52-18.23,0.52 c-3.95,0-9.42,3.87,5.47,3.87c7.5,0,30.27,0,51.03,0c7.47,0.74,5.65,4.07-3.44,4.27h38.92v-25.26l-111.09-0.91 C1034.28,647.05,881.31,647.23,882.2,647.05z M935.88,651.64c-7.38,0-9.73-0.86,1.68-0.86 C947.29,650.78,943.26,651.64,935.88,651.64z M948.11,653.16c-2.92,0-3.86-0.54,0.66-0.54 C952.63,652.62,951.04,653.16,948.11,653.16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M883.66,662.2c0,0.19-0.01,0.38-0.02,0.58c0.39-0.47,0.8-0.95,1.23-1.43c-0.38,0.1-0.78,0.2-1.2,0.32 C883.67,661.83,883.67,662.01,883.66,662.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M884.21,764.37c-0.68-0.42-1.36-0.85-2.02-1.28c1.04,0.83,2.11,1.65,3.22,2.48 C885,765.17,884.6,764.78,884.21,764.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M891.44,667.69c0.97,1.69,1.96,3.62,2.24,4.16c1.34,0.83,2.56,1.26,3.73,1.63 c-1.78-3.23-4.51-4.53-4.97-7.62C892.44,665.85,892.13,666.54,891.44,667.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M799.01,517.4c-0.21,1.87-0.41,3.82-0.6,5.82C798.67,521.49,798.86,519.79,799.01,517.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M813.23,707.22c-6.15-0.91-12.03-1.69-16.71-2.82C800.18,705.47,805.4,706.42,813.23,707.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M842.22,715.51c1.55,1.23,3.01,2.62,4.58,4.21C845.59,718.11,844.04,716.72,842.22,715.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M969.99,764.15c14.35,1.94,28.49,3.53,41.94,4.74c-15.71-1.94-34.71-5.45-48.23-11.76 c-16.55-7.72-12.11-20.9-6.43-29.99c0,0-0.03,0.03-0.08,0.09c-2.51,4.24-7.4,9.1-12.09,16.22 C938.29,753.78,948,760.03,969.99,764.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M762.66,670.28c13.9,2.62,14.16,18.22,24.41,28.63c2.04,2.07,4.1,3.92,9.44,5.49 c4.68,1.13,10.57,1.91,16.71,2.82c0.46,0.05,0.93,0.09,1.41,0.14c15.58,1.49,22.09,3.79,27.59,8.16 c1.81,1.21,3.37,2.6,4.58,4.21c0.18,0.18,0.35,0.36,0.53,0.54c5.06,5.19,11.73,24.4,34.86,42.83c0.66,0.43,1.34,0.86,2.02,1.28 c-21.77-22.88,10.34-50.81-8.07-67.23c-1.54-1.81-2.21-4.26-2.56-6.65c-0.01-0.05-0.08-0.05-0.08,0 c-0.12,1.02-0.21,2.05-0.25,3.08c0,0.04-0.06,0.05-0.08,0.02c-0.87-1.42-1.31-3.05-1.72-4.67c-0.01-0.04-0.08-0.04-0.08,0.01 c-0.12,1.13-0.17,2.27-0.16,3.41c0,0.04-0.07,0.06-0.08,0.02c-0.78-2.75-1.72-4.14-1.93-4.05c-0.09,0.04,0.58,1.63,0.6,2.79 c0,0.04-0.05,0.06-0.07,0.03c-0.77-0.7-1.19-1.98-1.4-2.85c-0.01-0.05-0.08-0.04-0.08,0.01c-0.02,1.15,0.12,2.3,0.43,3.4 c0.01,0.04-0.04,0.07-0.07,0.04c-0.58-0.75-1.06-1.57-1.44-2.44c-0.02-0.04-0.08-0.03-0.08,0.01c-0.05,0.89,0.09,1.76,0.36,2.6 c-3.37-1.44-7.44-2.73-12.35-3.84c-16.3-3.7-27.42-8.9-34.62-14.8c-0.42-0.74-0.66-1.61-0.77-2.46c-0.2-1.46-0.12-2.97-0.48-4.4 c-0.01-0.05-0.09-0.05-0.11,0c-0.33,1.19-0.54,2.41-0.64,3.64c0,0.06-0.09,0.07-0.1,0.01c-0.34-1.16-0.59-2.35-0.74-3.54 c-0.01-0.06-0.1-0.06-0.1,0l-0.16,1.73c-0.01,0.06-0.08,0.07-0.1,0.02c-0.57-1.38-0.83-2.87-0.78-4.36 c0-0.06-0.09-0.08-0.1-0.01c-0.37,1.31-0.47,2.7-0.3,4.05c0.01,0.06-0.08,0.08-0.1,0.03c-0.4-1.05-0.71-2.13-0.94-3.23 c-0.01-0.06-0.11-0.05-0.1,0.01l0.06,1.77c0,0.05-0.07,0.08-0.1,0.03c-0.67-0.98-1.05-2.14-1.1-3.32c0-0.06-0.09-0.07-0.11-0.01 c-0.19,0.85-0.21,1.71-0.11,2.57c-4.32-6.48-5.07-13.36-3.59-19.8c5.4-23.5-20.33-23.82-8.37-23.53c2.86,0.07,5.6,0.24,8.23,0.5 c8.71,1.12,15.27,2.7,19.93,4.14c1.89,0.63,3.72,1.32,5.47,2.05c0.01-0.03,0.02-0.07,0.03-0.1c2.48,1.01,3.64,1.71,3.64,1.71 c-0.51-2.66-1.38-4.72-2.43-6.32c1.97-8.42,2.89-17.56,2.69-24.63c-0.38-13.41-1.43-32.46-6.37-53 c-3.09-12.85-3.24-22.39-4.36-28.8c-0.67-3.84-0.67-6.53-1.34-2.69c-0.67,3.84-4.93,9.29-4.69,22.28 c0.17,9.27-1.36,12.96-2.41,20.1c-0.35-4.01-0.76-7.68-1.24-10.83c-3.6-23.83-4.7-24.08-7.6-41.7 c-3.66-22.22-2.59-26.06-4.21-27.89c-1.9,3.36-5.33,16.47-7.95,40.15c-0.15,2.38-0.34,4.09-0.6,5.82 c-1.85,18.93-3.13,43.79-2.89,74.91c-0.26,0.01-0.52,0.03-0.78,0.05c0,0.03,0-0.03,0,0c-1.24,0.06-2.58,0.4-4.02,0.86 c-10.19,3.21-8.97,15.11-8.97,15.11s-5.6,0.11-7.46,7.39c0,0-8.66-3.5-16.53,3.92c-4.5,4.24-5.12,11.6-5.12,11.6 s-7.06,2.17-9.11,13.98c-8.55,10.08-17.05,21.58-29.29,32.34c-0.59,0.52-1.9,2.23,3.66,0.91 C749.13,674.91,751.44,668.16,762.66,670.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M909.18,692.94c0.03,0.1,0.07,0.21,0.1,0.31c-0.01-0.26,0-0.45-0.13-0.58c0,0.01-0.01,0.02-0.01,0.04 C909.13,692.79,909.15,692.87,909.18,692.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M909.5,693.82c-0.02-0.01-0.04-0.02-0.05-0.04c0,0.01,0.01,0.02,0.01,0.03 C909.47,693.81,909.49,693.81,909.5,693.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M908.75,694.25c0.02-0.01,0.04-0.03,0.06-0.05c0.02-0.02,0.03-0.05,0.05-0.07 c-0.05,0-0.11-0.01-0.15-0.04C908.72,694.15,908.74,694.2,908.75,694.25z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0DAC7",
    points: "908.77,693.55 908.77,693.55 908.77,693.55  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M908.3,692.83c-0.07-0.04-0.15-0.08-0.23-0.12c-0.04-0.02-0.08-0.06-0.11-0.08 c0.01,0.05,0.02,0.1,0.06,0.15C908.09,692.87,908.2,692.89,908.3,692.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B4A",
    d: "M833.14,662.64c0,0-0.34-1.59-1.06-3.44c-0.7-1.8-1.77-3.85-3.26-4.95c-3.07-2.27,0.02,0.99,0.98,4.93 c0.13,0.55,0.23,1.1,0.26,1.66L833.14,662.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M870.73,660.94c0.5,3.62-0.68,5.65-1.08,8.16c-0.34,1.35-0.35,2.69,0.17,3.91c0,0,0,0.01,0,0.01 c1.97,0.9,5.6,2.6,9.28,4.49c0.17,1.34,0.28,2.19,0.72,3.12c0.03,0.06,0.06,0.13,0.09,0.19c0.34,0.67,1.27,0.42,1.89,0.16 c0.07-0.03,0.13-0.07,0.19-0.11c0.24-0.17,0.38-0.43,0.36-0.72c-0.02-0.28-0.02-0.59-0.02-0.93c0.01-0.58,0.04-1.25,0.09-1.98 c0.91-0.38,1.81-0.97,2.77-1.83c0.01,0.01,0.02,0.02,0.02,0.02c0.6-0.51,1.12-0.96,1.57-1.34c0.04-0.06,0.09-0.11,0.14-0.16 c0.75-0.69,1.7-2.28,3.09-2.62c1.61-0.39,3.62,0.54,3.6,0.52c0.02,0.01,0.04,0.02,0.06,0.03c-0.28-0.54-1.27-2.46-2.24-4.16 c0.69-1.15,1-1.84,1-1.84c0.46,3.09,3.19,4.39,4.97,7.62c1.49,0.46,2.9,0.82,4.41,1.74c0.06,0.03,0.12,0.05,0.16,0.06 c-2.23-3.48-3.69-13.02-6.58-17.09c-0.74-1.04-1.58-1.73-2.54-1.86c-1.22-0.16-2.49,0.3-3.73,1.12 c-0.06-0.03-0.13-0.06-0.21-0.08c-1.38-0.3-3.24-0.19-5.19,0.02c-0.03-3-0.27-3.87-0.98-4.9c0.01-0.01,0.01-0.02,0.01-0.02 c-0.1-0.11-0.19-0.23-0.27-0.33c-0.1-0.13-0.21-0.27-0.32-0.42c-0.02-0.02-0.04-0.04-0.06-0.07c-0.55-0.72-1.04-1.35-2-2.04 c-0.08,0.13-0.15,0.27-0.22,0.43c-0.16,0.43-0.34,0.97-0.51,1.8c-0.31,1.54-0.15,2.72-0.15,2.72s-0.38-1.44,0.31-3.78 c-0.08,0.24-1.08,3.06-0.72,4.56c0,0-0.2-0.28-0.3-0.89c-0.04,0.56-0.01,0.94-0.01,0.94s-0.26,0-0.68-0.04 c-0.01-0.37,0.01-1.6,0.41-2.75c0,0-0.58,1.01-0.56,2.74c-0.19-0.02-0.4-0.05-0.64-0.09c-1.47-0.25-3.65-0.94-4.73-2.82 c-1.29-1.38-0.79-3.74,0.87-4.42c0.6-0.25,0.99-0.61,1.22-1.05c-2.14-0.47-3.77,0.15-4.43,3.15c-0.31,1.41-0.43,2.34-0.42,3.21 C869.56,655.01,870.11,656.5,870.73,660.94z M883.65,662.77c0.01-0.19,0.01-0.39,0.02-0.58c0-0.18,0.01-0.36,0.01-0.54 c0.42-0.12,0.82-0.22,1.2-0.32C884.45,661.82,884.04,662.3,883.65,662.77z M890.34,658.56c0.86,0.59,0.86,0.84,1.03,1.43 s0.46,1.22,0.43,1.52c-0.02,0.2-0.15,0.43-0.24,0.56c0.02,0.33-0.06,0.63-0.26,0.92c0,0-0.6,0.76-0.66,0.48 c-0.06-0.27,0.3-0.82,0.21-1.21c-0.08-0.36-0.6-2.15-0.54-1.75c0.06,0.39,0.36,1.21,0.3,1.63c-0.04,0.27-0.05,0.75-0.1,1.2 c-0.03,0.26-0.06,0.52-0.12,0.71c-0.15,0.51-0.49,0.21-0.52,0.07c-0.04-0.24,0-0.13-0.03-0.77c-0.03-0.63-0.3-2.84-0.3-2.84 s0.12,1.03,0.15,1.81c0.03,0.79-0.1,1.47-0.25,1.59c-0.11,0.09-0.24,0.17-0.32-0.1c0-0.01,0-0.03-0.01-0.04 c-0.08-0.44-0.01-1.18-0.08-1.54c-0.05-0.26-0.11-1.06-0.16-1.58c-0.02-0.45-0.07-0.68-0.21-0.42 c-0.21,0.39-0.18,1.15-0.18,1.78s-0.57,1.03-0.51,0.51c0.06-0.51,0-0.94-0.24-1.54s0-1.39,0.06-1.87 c0.06-0.48,0.67-1.51,1.39-1.45C889.7,657.72,889.49,657.97,890.34,658.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M902.1,675.38c-0.01-0.03-0.02-0.05-0.04-0.08c0,0-0.03-0.01-0.08-0.03c-0.04-0.02-0.09-0.04-0.16-0.06 C901.91,675.26,902,675.32,902.1,675.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M910.16,678.83c0,0,0,0.01,0.01,0.01c0-0.05,0-0.1,0-0.15C910.16,678.74,910.16,678.78,910.16,678.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M882.36,680.14c0.02,0.29-0.12,0.55-0.36,0.72c0.08,0.25,0.18,0.42,0.26,0.55 c0.17,0.27,0.32,0.32,0.45,0.62c0.12,0.29,0.33,0.7,0.69,0.82c0.68,0.22,1.14,0.16,0.83,0.4c-0.3,0.23-0.8,0.24-1.47,0.08 c-0.67-0.17-0.83-0.33-1.08-0.22c-0.49,0.35-0.56,0.59-0.69,1.1c-0.21,0.79-0.24,1.16-0.57,1.93c-0.1,0.23-0.13,0.66-0.44,0.62 c-0.42-0.09-0.06-0.71-0.01-0.93c0.22-0.9,0.24-1.16,0.46-2.06c-0.54,0.25-0.6,1.76-1.53,2.98c-0.11,0.05-0.39,0-0.41-0.2 c-0.02-0.2,0.21-0.75,0.28-0.95c0.42-1.14,0.42-1.08,0.84-2.22c-0.46,0.8-0.72,0.99-1.19,1.8c-0.21,0.36-0.41,0.85-0.74,0.65 c-0.22-0.26,0.06-0.66,0.2-0.9c0.49-0.86,0.41-0.74,0.91-1.6c-0.64,0.77-1.32,1.84-1.62,1.28c-0.11-0.35,1.2-1.34,1.81-2.49 c0.19-0.36,0.3-0.74,0.52-1.09c0.09-0.14,0.2-0.27,0.33-0.38c-0.43-0.93-0.55-1.78-0.72-3.12c-3.68-1.89-7.32-3.59-9.28-4.49 c0,0,0-0.01,0-0.01c-10.76-4.9-19.09-8.16-28.1-11.38c-4.22-1.51-7.37-2.22-9.65-2.43c0.73,1.86,1.06,3.44,1.06,3.44l-3.09-1.8 c-0.03-0.56-0.12-1.12-0.26-1.66c-1.45,0.14-2.22,0.62-2.44,1.22c-0.01-0.01-0.02-0.01-0.02-0.01 c-0.71,0.97-0.38,4.13,5.35,8.42c4.29,3.22,13.73,7.85,26.71,13.4c9.1,1.94,16.79,3.82,22.65,7.2c2.84,1.64,5.58,3.48,8.21,5.22 c0.18,0.07,0.35,0.14,0.53,0.21c9.98,3.84,13.45,3.81,13.54,2.32c0.03-0.17,0.01-0.37-0.06-0.61 c-1.59-5.33-12.35-12.14-21.37-17.04c-0.18-0.1-0.37-0.2-0.55-0.3C882.33,679.55,882.34,679.86,882.36,680.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M879.49,681c-0.22,0.35-0.33,0.73-0.52,1.09c-0.61,1.15-1.92,2.14-1.81,2.49 c0.31,0.57,0.98-0.5,1.62-1.28c-0.49,0.86-0.41,0.74-0.91,1.6c-0.14,0.24-0.42,0.64-0.2,0.9c0.34,0.2,0.54-0.29,0.74-0.65 c0.46-0.8,0.73-0.99,1.19-1.8c-0.42,1.14-0.42,1.08-0.84,2.22c-0.07,0.2-0.31,0.75-0.28,0.95c0.02,0.2,0.3,0.25,0.41,0.2 c0.93-1.22,0.99-2.73,1.53-2.98c-0.22,0.9-0.24,1.16-0.46,2.06c-0.05,0.21-0.41,0.84,0.01,0.93c0.31,0.04,0.34-0.39,0.44-0.62 c0.33-0.77,0.36-1.14,0.57-1.93c0.14-0.51,0.21-0.75,0.69-1.1c0.25-0.11,0.42,0.06,1.08,0.22c0.67,0.17,1.17,0.15,1.47-0.08 c0.31-0.24-0.15-0.17-0.83-0.4c-0.36-0.12-0.57-0.52-0.69-0.82c-0.13-0.3-0.28-0.35-0.45-0.62c-0.08-0.13-0.18-0.3-0.26-0.55 c-0.06,0.04-0.12,0.08-0.19,0.11c-0.62,0.26-1.55,0.51-1.89-0.16c-0.03-0.06-0.06-0.13-0.09-0.19 C879.69,680.73,879.58,680.86,879.49,681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M882.79,643.47c-0.09,0.16-0.17,0.31-0.25,0.45c-0.19-0.31-0.44-0.34-0.59-0.15 c-0.14,0.16-0.24,1.02-0.01,1.72c-0.02,0.11-0.03,0.21-0.04,0.33c-0.1,1.5-0.75,2.21-1.37,3.11c1.23,0.06,1.69-0.38,1.91-1.39 c0.14-0.63,0.5-1.17,0.58-1.8s-0.02-0.85,0.24-1.99c0.09-0.4,0.11-0.69,0.1-0.94C883.22,643.03,883.04,643.26,882.79,643.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M889.18,657.67c-0.72-0.06-1.33,0.97-1.39,1.45c-0.06,0.48-0.3,1.27-0.06,1.87s0.3,1.03,0.24,1.54 c-0.06,0.51,0.51,0.12,0.51-0.51s-0.03-1.39,0.18-1.78c0.14-0.26,0.19-0.04,0.21,0.42c0.05,0.51,0.11,1.31,0.16,1.58 c0.07,0.35,0,1.1,0.08,1.54c0,0.02,0,0.03,0.01,0.04c0.08,0.27,0.21,0.19,0.32,0.1c0.15-0.12,0.28-0.8,0.25-1.59 c-0.03-0.79-0.15-1.81-0.15-1.81s0.27,2.21,0.3,2.84c0.03,0.63-0.01,0.53,0.03,0.77c0.02,0.14,0.36,0.44,0.52-0.07 c0.06-0.19,0.09-0.44,0.12-0.71c0.04-0.45,0.06-0.93,0.1-1.2c0.06-0.42-0.24-1.24-0.3-1.63c-0.06-0.39,0.46,1.39,0.54,1.75 c0.09,0.39-0.27,0.94-0.21,1.21c0.06,0.27,0.66-0.48,0.66-0.48c0.2-0.29,0.28-0.59,0.26-0.92c0.09-0.13,0.22-0.36,0.24-0.56 c0.03-0.3-0.25-0.94-0.43-1.52s-0.17-0.84-1.03-1.43C889.49,657.97,889.7,657.72,889.18,657.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M873.16,647.98c-1.66,0.67-2.16,3.04-0.87,4.42c1.08,1.88,3.27,2.57,4.73,2.82 c0.23,0.04,0.45,0.07,0.64,0.09c-0.01-1.72,0.56-2.74,0.56-2.74c-0.4,1.15-0.42,2.38-0.41,2.75c0.42,0.04,0.68,0.04,0.68,0.04 s-0.02-0.38,0.01-0.94c0.1,0.61,0.3,0.89,0.3,0.89c-0.36-1.49,0.64-4.32,0.72-4.56c-0.69,2.34-0.31,3.78-0.31,3.78 s-0.16-1.18,0.15-2.72c0.17-0.84,0.35-1.37,0.51-1.8c0.07-0.15,0.14-0.29,0.22-0.43c0.14-0.24,0.28-0.46,0.42-0.67 c0.62-0.89,1.27-1.61,1.37-3.11c0.01-0.12,0.02-0.22,0.04-0.33c-0.23-0.7-0.12-1.56,0.01-1.72c0.15-0.18,0.4-0.16,0.59,0.15 c0.08-0.14,0.16-0.29,0.25-0.45c0.24-0.21,0.43-0.44,0.56-0.67c0.55-0.94,0.32-2.03,0.06-2.68c-0.01-0.04-0.03-0.08-0.05-0.13 c0,0-0.59-1.65-2.3-2.19c-0.61-0.19-0.95-0.33-1.87-0.32c-3.71,0.02-5.1,2.77-4.63,6.83l0,0c0,0.02,0.01,0.04,0.01,0.06 c0.02,0.19,0.05,0.39,0.08,0.59c0.07,0.69,0.03,1.39-0.29,1.98C874.14,647.36,873.76,647.73,873.16,647.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1071.99,771.46c-9.52,0.22-20.5,0-32.48-0.61c-2.28-0.22-4.66-0.41-7.16-0.55 c-4.59-0.26-9.04-0.53-13.33-0.82c-2.34-0.19-4.71-0.39-7.1-0.6c-13.45-1.2-27.59-2.79-41.94-4.74 c-21.98-4.12-31.69-10.37-24.89-20.7c4.69-7.12,9.58-11.98,12.09-16.22c1.98-3.35,2.47-6.32,0.16-9.7 c-3.79-7.21-13.73-16.57-21.55-19.43c-6.37-2.33-8.09-1.73-10.24-2.46c-0.36-0.23-0.72-0.47-1.08-0.71 c0,0.02,0.01,0.03,0.01,0.04c-11.17-7.14-15.65-11.92-16.73-13.17c-0.78-1.2-1.61-2.45-2.81-3.85 c-1.01-1.18-1.95-1.99-2.86-2.59c-0.09-0.06-0.19-0.12-0.28-0.18c-1.5-0.92-2.92-1.28-4.41-1.74c-1.17-0.36-2.39-0.8-3.73-1.63 c-0.02-0.01-0.04-0.02-0.06-0.03c0.02,0.01-1.99-0.91-3.6-0.52c-1.39,0.33-2.35,1.92-3.09,2.62c-0.06,0.05-0.1,0.11-0.14,0.16 c-0.45,0.38-0.97,0.83-1.57,1.34c0,0-0.01-0.01-0.02-0.02c-0.96,0.86-1.86,1.45-2.77,1.83c-0.05,0.74-0.08,1.4-0.09,1.98 c0.18,0.1,0.37,0.2,0.55,0.3c9.02,4.9,18.88,11.39,20.71,15.65c0.1,0.23,0.09,1.78,0.06,1.95c-0.1,1.49-2.9,1.57-12.88-2.26 c-0.18-0.07-0.35-0.14-0.53-0.21c-2.63-1.74-5.36-3.58-8.21-5.22c-5.85-3.38-13.55-5.26-22.65-7.2 c-12.98-5.55-22.42-10.19-26.71-13.4c-5.73-4.29-6.06-7.45-5.35-8.42c0,0,0.01,0,0.02,0.01c0.22-0.61,0.99-1.08,2.44-1.22 c-0.96-3.94-4.05-7.2-0.98-4.93c1.49,1.1,2.55,3.15,3.26,4.95c2.27,0.2,5.43,0.92,9.65,2.43c9.01,3.22,17.33,6.48,28.1,11.38 c-0.51-1.21-0.5-2.55-0.17-3.91c0.39-2.5,1.58-4.54,1.08-8.16c-0.62-4.44-1.17-5.93-1.2-7.65 c-9.17-8.43-19.33-17.95-34.27-24.17c-1.76-0.73-3.58-1.41-5.47-2.05c-4.66-1.44-11.22-3.02-19.93-4.14 c-2.63-0.26-5.37-0.43-8.23-0.5c-11.97-0.29,13.77,0.03,8.37,23.53c-1.48,6.43-0.73,13.31,3.59,19.8 c-0.1-0.86-0.08-1.73,0.11-2.57c0.01-0.06,0.1-0.05,0.11,0.01c0.05,1.18,0.44,2.34,1.1,3.32c0.03,0.04,0.1,0.02,0.1-0.03 l-0.06-1.77c0-0.06,0.09-0.08,0.1-0.01c0.23,1.1,0.55,2.18,0.94,3.23c0.02,0.06,0.11,0.04,0.1-0.03 c-0.17-1.35-0.07-2.74,0.3-4.05c0.02-0.06,0.11-0.05,0.1,0.01c-0.06,1.49,0.21,2.98,0.78,4.36c0.02,0.05,0.1,0.04,0.1-0.02 l0.16-1.73c0.01-0.06,0.1-0.06,0.1,0c0.15,1.2,0.4,2.38,0.74,3.54c0.02,0.06,0.1,0.05,0.1-0.01c0.1-1.23,0.32-2.45,0.64-3.64 c0.01-0.05,0.09-0.05,0.11,0c0.36,1.43,0.29,2.94,0.48,4.4c0.11,0.85,0.35,1.72,0.77,2.46c7.2,5.9,18.32,11.1,34.62,14.8 c4.91,1.11,8.98,2.4,12.35,3.84c-0.27-0.84-0.41-1.71-0.36-2.6c0-0.04,0.06-0.05,0.08-0.01c0.38,0.87,0.86,1.69,1.44,2.44 c0.03,0.04,0.08,0.01,0.07-0.04c-0.31-1.11-0.45-2.26-0.43-3.4c0-0.05,0.07-0.06,0.08-0.01c0.2,0.87,0.63,2.15,1.4,2.85 c0.03,0.02,0.07,0,0.07-0.03c-0.02-1.16-0.69-2.75-0.6-2.79c0.2-0.09,1.15,1.31,1.93,4.05c0.01,0.04,0.08,0.02,0.08-0.02 c-0.01-1.14,0.04-2.28,0.16-3.41c0-0.05,0.07-0.05,0.08-0.01c0.41,1.62,0.85,3.25,1.72,4.67c0.02,0.03,0.07,0.02,0.08-0.02 c0.05-1.03,0.13-2.06,0.25-3.08c0.01-0.05,0.08-0.05,0.08,0c0.34,2.39,1.02,4.84,2.56,6.65c18.41,16.43-13.7,44.35,8.07,67.23 c0.38,0.4,0.78,0.8,1.2,1.2c5.5,4.09,11.86,8.11,19.24,11.9l-0.15-0.27c9.05,4.71,53.65,22.8,120.87,22.8 c104.31,0,130.01-19.38,136.34-28.55C1153.9,771.36,1102.09,770.78,1071.99,771.46z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M844.61,660.73c-1.08,0.2-0.67,1.57-0.18,1.9l4.86,1.78c0,0,4.45,3.16,6.24,4.45 c1.78,1.3,15.64,16.08,15.88,16.24c0.24,0.16,2.31,0.61,2.58,0.85c0.53,0.45,10.37,10.45,10.85,11.66 c0.49,1.21-0.89,0.81-0.49,1.78s2.27,0.49,3.89,0.24c1.62-0.24,1.38-1.46,0.16-1.46c-1.21,0-1.86-1.94-1.86-1.94l-26-24.46 l-7.77-6.8L844.61,660.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M858.26,668.83c-0.57-0.55-0.97-1.19-1.38-2.41s-2.36-5.58-4.09-7.35c-1.73-1.76-3.9-1.82-5.86-1.5 s-4.66,1.12-2.32,3.15c2.34,2.03,9.06,6.05,10.85,7.26c1.79,1.21,2.91,2.35,4.02,3.49c1.12,1.14,12.8,12.17,15.07,14.41 c2.27,2.23,12.68,11.95,12.68,11.95s-1.15,0.23-0.76,0.75c0.39,0.52,0.9,0.29,1.9,0.11c1-0.18,1.96-0.44,1.54-0.92 s-1.32,0.12-1.55-0.21C888.36,697.56,859.8,670.33,858.26,668.83z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M820.85,610.65c3.72,2.22,5.18,6.5,5.31,8.32c0,0,2.17-0.15,4.76,0.88c0.78-6.26,1.3-15.08,0.72-26.89 c-0.6-12.23-4.58-19.94-4.58-27.28c0-7.34,3.36-13.29,2.14-22.38c-1.2-8.93-2.37-25.17-1.42-29.57c0.02-0.08,0.04-0.16,0.05-0.23 c0,0-0.02,0.07-0.07,0.19c-0.12,0.35-0.4,1.16-0.78,2.2c-0.63,1.75-1.53,4.13-2.37,6.07c-0.68,1.56-1.24,4.01-1.62,7 c-0.33,2.6-0.53,5.59-0.57,8.74c-0.01,0.74-0.01,1.48,0,2.23c0.01,0.65,0.02,1.31,0.05,1.96c0.18,4.93-0.8,8.05-1.82,11.98 c-0.24,0.93-0.49,1.91-0.72,2.97C821.38,572.93,821.75,594.86,820.85,610.65z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M885.54,691.56c3.72,2.37,7.25,4.88,10.58,6.77c4.47,1.83,6.87,0.48,7.37-0.34 c0.32-0.47,0.08-2.44,0.1-2.83C903.07,697.05,895.44,695.35,885.54,691.56z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M833.14,662.64l-3.09-1.8l-1.8,1.76c-0.46-0.56-0.87-1.08-0.95-1.66c-0.02-0.19-0.01-0.37,0.06-0.54 c-0.01-0.01-0.02-0.01-0.02-0.01c-0.12,0.17-0.21,0.4-0.25,0.69c-2.29,1.79,2.13,10.94,15.27,17.14c2.31,0.72,4.77,1.4,7.36,1.95 c5.35,1.15,11.76,2.5,16.32,3.55c-16.48-6.81-30.34-14.04-35.67-19.12L833.14,662.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M836.18,629.4c-0.5-2.03-1.3-6.51-5.18-8.37c-6.4-3.08-11.97,2.43-11.09,0.49 c0.64-1.41,1.69-2.36,2.21-2.76c0.18-0.14,0.2-0.38,0.11-0.59c-0.88-2.28-2.89-5.64-8.06-5.61c-5.64,0.03-8.6,5.75-8.6,5.75 c0.83-3.63,2.53-5.75,3.19-6.47c0,0.01,0.01,0.02,0.01,0.04c1.21-1.26,2.86-2.21,5.1-2.5c1.88-0.24,3.51-0.08,4.9,0.36 c-0.02-15.05-1.77-33.99-3.3-48.95c-2.5-24.42-6.91-51.48-7.89-59.09c-1.57-12.11-0.79-20.77-0.46-24.24c0-0.01,0-0.03,0-0.04 c-0.02-0.01-0.04-0.02-0.05-0.03c-0.05-0.02-0.09-0.04-0.14-0.05c-1.97,3.58-5.53,17.41-8.16,42.36 c-0.05,0.57-0.11,1.15-0.18,1.74c-1.94,19.15-3.32,44.59-3.07,76.72c11.96-0.69,13.03,6.92,13.12,7.17 c0.05,0.16-2.5-3.49-7.58-4.6c-2.68-0.59-6.49-0.51-9.92,1.73c-6.07,3.94-5.5,11.54-5.5,11.54c4.01,0.5,6.22,2.43,7.48,3.62 c0.11,0.1-0.03,0.27-0.16,0.19c-3.23-2.16-6.51-2.31-8.27-2.18c-8.86,0.92-10.61,9.09-10.84,10.44 c-13.51,5.69-23.47,16.43-27.4,21.52c-1.82,2.36-5.15,6.33-8.95,10.73c-6.15,7.14-13.53,15.44-17.73,19.94 c-1.4,1.5-2.44,2.57-2.98,3.05c-1.74,1.56-3.17,2.64-3.12,3.12c0.01,0.06,0.04,0.12,0.11,0.16c0.31,0.21,1.34,0.15,3.44-0.23 c0.72-0.13,1.63-0.35,2.68-0.64c29.34-9.06,31.79-15.47,42.76-13.4c13.9,2.62,14.16,18.22,24.41,28.63 c3.52,3.58,7.11,6.49,27.56,8.45c-29.51-12.97-19.5-26.74-25.03-38.04c-5.54-11.3-6.8-16.09,5.43-24.63 c12.23-8.54,7.91-21.55-0.21-22.23c-0.11-0.01-0.21-0.01-0.32-0.02c4.83-0.11,7.13,0,7.13,0c15.1,0.41,28.12,4.64,32.76,6.33 c0.34,0.12,0.63,0.23,0.88,0.33c0.61,0.23,0.93,0.36,0.93,0.36C836.19,629.44,836.18,629.42,836.18,629.4z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M801.63,622.45C801.62,622.45,801.62,622.46,801.63,622.45C801.62,622.46,801.62,622.45,801.63,622.45z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M801.63,622.44c0,0,0,0.01,0,0.01C801.63,622.44,801.63,622.44,801.63,622.44z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M801.61,622.48C801.61,622.49,801.61,622.49,801.61,622.48L801.61,622.48z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M801.61,622.48c0-0.01,0.01-0.01,0.01-0.02C801.62,622.47,801.61,622.48,801.61,622.48z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M869.81,655.59c0.05,0.31,0.11,0.63,0.18,0.94c0.18,0.84,0.4,1.66,0.65,2.43 c1.22,3.83,0.49,7.21-0.26,9.94c-0.72,2.63-0.44,2.98-0.22,4.16c-0.13-0.05-0.26-0.1-0.38-0.15c-0.05-0.02-0.1-0.04-0.15-0.06 c0,0-0.01,0.02-0.03,0.06c-0.21,0.41-1.37,3.01,2.03,5.45c2.41,1.73,5.29,2.15,8.14,2.16c-0.39-0.89-0.51-1.73-0.67-3.05 c-0.73-0.39-1.5-0.8-2.28-1.2l2.33,1.07c0,0,0.3,3.78,1.43,3.86c0.19,0.01,0.37,0.01,0.52,0c-0.48,0.1-0.97,0.06-1.19-0.39 c-0.03-0.06-0.06-0.13-0.09-0.19c-0.13,0.11-0.24,0.25-0.33,0.38c-0.22,0.35-0.33,0.73-0.52,1.09c-0.61,1.15-1.92,2.14-1.81,2.49 c0.06,0.1,0.12,0.15,0.2,0.16c-0.27,0.46-0.28,0.73-0.12,0.86c0.27,0.21,0.55,0.58,0.87,0.84c0.32,0.26,0.6,0.72,1.11,0.55 c0.5-0.17,1.14-0.03,1.38-0.49c0.23-0.46,0.89-2.5,1.18-2.78c0.3-0.28,1.63-0.03,2.08-0.14c0.45-0.12,0.64-0.26,0.36-0.33 c0.09-0.07,0.1-0.08,0.07-0.07c-0.08,0.02-0.5,0.21-0.99,0.05c-0.36-0.12-0.71-0.67-0.84-0.96c-0.13-0.3-0.31-0.5-0.48-0.77 c-0.08-0.12-0.12-0.3-0.14-0.55c-0.02,0.01-0.04,0.02-0.06,0.03c-0.01,0-0.02,0.01-0.03,0.01c0.31-0.22,0.48-0.61,0.54-1.24 c0.01-0.08,0.02-0.2,0.03-0.36c0,0.27,0.01,0.53,0.02,0.76c0.01,0.1-0.01,0.19-0.04,0.28c0.65-0.04,1.29-0.09,1.92-0.13 c0.84,0.44,1.86,1,2.9,1.62c0.03,0.02,0.05,0.03,0.07,0.03c0.08,0,0.11-0.11,0.27-0.28c0.92-0.98,7.66-7.92,14.45-6.38 c0.04,0.01,0.08,0.01,0.12,0.02c0,0,0,0,0,0c0,0-0.04-0.02-0.1-0.07c-0.25-0.16-0.96-0.6-1.86-1.02 c-0.07-0.56-0.36-2.52-1.29-6.2c-2.47-9.75-4.05-10.9-5.1-11.38c-0.98-0.45-2.5,0.19-4.03,1.31c-0.02-0.02-0.04-0.04-0.06-0.06 c-0.09-0.08-0.16-0.14-0.22-0.17c-0.16-0.1-0.22-0.05-0.22-0.05s-0.19-0.04-0.27,0.03c-0.01,0.01-0.02,0.02-0.02,0.03 c0,0-0.01,0-0.03-0.01c-0.14-0.04-0.78-0.22-2.31-0.15c-1.61,0.07-2.84,0.22-2.84,0.22l0.02,3.85c0,0,1.47-0.41,2.66-0.62 c-0.39,0.46-0.75,0.91-1.06,1.35c-0.86,1.23-1.52,2.3-1.52,2.3L882.86,677c-0.13,0.06-0.27,0.11-0.39,0.14 c0.2-3.8,0.53-10.57,0.67-13.47c0.19-3.9,0.03-6.55-0.69-9.03c-0.66-2.27-2.05-3.96-2.54-4.52c-0.02-0.02-0.03-0.03-0.05-0.05 c0.01-0.02,0.02-0.04,0.02-0.06c0.07-0.15,0.14-0.29,0.22-0.43c0.14-0.24,0.28-0.46,0.42-0.67c0.62-0.89,1.27-1.61,1.37-3.11 c0.01-0.12,0.02-0.22,0.04-0.33c-0.23-0.7-0.12-1.56,0.01-1.72c0.15-0.18,0.4-0.16,0.59,0.15c0.08-0.14,0.16-0.29,0.25-0.45 c0.24-0.21,0.43-0.44,0.56-0.67c0.55-0.94,0.32-2.03,0.06-2.68c-0.01-0.04-0.03-0.08-0.05-0.13c0,0-0.59-1.65-2.3-2.19 c-0.61-0.19-6.39,0.05-6.41,7.16c0.07,0.69,0.03,1.39-0.29,1.98c-0.1,0.18-0.21,0.34-0.36,0.49c-1.66-0.16-2.38-0.5-3.08,0.42 c-0.22,0.29-0.41,0.6-0.57,0.93c-0.52,1.05-0.76,2.28-0.8,3.59C869.53,653.41,869.63,654.5,869.81,655.59z M878.44,665.7 c0.54-1.56,0.91-3.05,1.09-4.56l0.02,0.42c0,0-0.48,4.19-0.5,4.62c-0.05,0.98,0.09,3.56,0.19,5.06c0.03,0.26,0.06,0.53,0.08,0.81 c0.04,0.68-0.01,0.16-0.08-0.81C878.93,668.83,877.95,667.1,878.44,665.7z M892.89,667.36c0.23,0.47,0.58,1.04,1.1,1.66 c0.34,0.4,0.65,0.78,0.94,1.16c1.05,1.35,1.81,2.49,2.38,3.18c-0.07-0.01-0.13-0.02-0.2-0.02c0,0-0.04,0-0.1,0.01 c-0.71,0.08-5.22,0.65-8.81,3.4c0.9-1.45,2.57-3.07,5.56-4.75c0.05-0.03,0.03-0.07-0.04-0.13c-0.01-0.01-0.02-0.02-0.03-0.02 c-0.25-0.17-0.93-0.4-1.71-0.53c-0.46-0.08-0.95-0.12-1.41-0.09c-0.18,0.01-0.34,0.03-0.48,0.06c-0.51,0.1-0.86,0.29-1.27,0.65 c-0.25,0.22-0.52,0.5-0.87,0.85c0.09-0.1,0.18-0.2,0.27-0.3c0.02-0.03,0.04-0.06,0.06-0.09c1.59-2.26,2.9-4.21,3.69-5.61 c0.15-0.27,0.28-0.52,0.39-0.74c0.03-0.06,0.06-0.13,0.09-0.19C892.44,665.85,892.44,666.43,892.89,667.36z M891.8,661.51 c-0.01,0.05-0.02,0.1-0.04,0.15c0.02-0.07,0.03-0.13,0.03-0.2C891.8,661.48,891.8,661.5,891.8,661.51z M889.6,661.01 c-0.03-0.29-0.05-0.5-0.05-0.5s0,0,0,0C889.55,660.53,889.57,660.72,889.6,661.01z M889.7,662.32c0.03,0.69-0.07,1.3-0.19,1.52 c-0.02,0.03-0.04,0.06-0.06,0.07c-0.03,0.03-0.07,0.05-0.1,0.07c0.03-0.02,0.07-0.04,0.1-0.07c0.02-0.02,0.04-0.04,0.06-0.07 C889.63,663.62,889.72,663.01,889.7,662.32z M889.13,663.83c0.01,0.04,0.03,0.08,0.04,0.1 C889.15,663.9,889.14,663.87,889.13,663.83z M889.31,663.99c-0.01,0-0.03,0.01-0.04,0.01C889.29,664,889.3,664,889.31,663.99z  M887.71,660.91c0.01,0.03,0.01,0.05,0.02,0.08c0.02,0.05,0.04,0.11,0.06,0.16c-0.02-0.05-0.04-0.1-0.06-0.16 C887.72,660.97,887.72,660.94,887.71,660.91L887.71,660.91z M889.86,663.87c0,0.07,0,0.13,0.01,0.18 C889.85,663.98,889.86,663.94,889.86,663.87z M890.99,663.33c-0.14,0.14-0.28,0.24-0.34,0.18 C890.71,663.58,890.85,663.47,890.99,663.33z M890.8,662.75c-0.03,0.1-0.06,0.19-0.09,0.29 C890.74,662.94,890.77,662.85,890.8,662.75z M890.63,663.36C890.63,663.36,890.63,663.36,890.63,663.36 C890.63,663.36,890.63,663.36,890.63,663.36z M890.84,662.58c0.02-0.11,0.02-0.21,0-0.3 C890.87,662.37,890.86,662.47,890.84,662.58z M890.3,660.51c0.03,0.2,0.12,0.5,0.2,0.8C890.42,661.01,890.33,660.71,890.3,660.51 c0-0.02-0.01-0.04,0-0.05C890.3,660.47,890.3,660.49,890.3,660.51z M891.59,662.02c0,0,0-0.01,0-0.01 c0.06-0.08,0.1-0.16,0.13-0.23C891.68,661.87,891.64,661.95,891.59,662.02z M891.59,660.63c0.07,0.19,0.13,0.38,0.17,0.53 C891.69,660.97,891.64,660.79,891.59,660.63z M891.77,661.67c-0.01,0.03-0.02,0.07-0.04,0.1 C891.74,661.74,891.76,661.7,891.77,661.67z M889.88,664.12c0.01,0.04,0.03,0.08,0.07,0.12 C889.91,664.2,889.88,664.15,889.88,664.12z M889.85,663.36C889.85,663.36,889.85,663.35,889.85,663.36c0-0.01,0-0.01,0-0.01 C889.85,663.35,889.85,663.35,889.85,663.36C889.85,663.35,889.85,663.36,889.85,663.36z M887.54,660.9c-0.05,0-0.1,0-0.15,0 c-0.02,0-0.04,0-0.06,0C887.4,660.89,887.47,660.89,887.54,660.9z M890.25,658.5c-0.13-0.08-0.24-0.16-0.31-0.25 c0,0-0.01-0.01-0.01-0.01C890.02,658.31,890.12,658.4,890.25,658.5z M884.01,676.32c-0.34,0.24-0.66,0.44-0.96,0.59 C883.24,676.8,883.58,676.6,884.01,676.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M911.28,691.76c-0.06,0.09-0.12,0.18-0.18,0.27c0.17-0.14,0.31-0.25,0.36-0.39 c-0.02-0.01-0.04-0.01-0.06-0.02C911.35,691.67,911.31,691.71,911.28,691.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M915.63,693.97c0.01,0,0.02,0,0.03,0C915.65,693.98,915.64,693.97,915.63,693.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M909.98,692.23c0.02,0.01,0.05,0.02,0.08,0.02c0.03,0,0.06,0,0.09-0.01c-0.03-0.04-0.05-0.09-0.07-0.14 C910.05,692.14,910.02,692.19,909.98,692.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M915.56,693.99c0.02-0.01,0.04-0.01,0.06-0.01c-0.04,0-0.07,0.01-0.1,0.03 C915.54,694,915.55,693.99,915.56,693.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M910.8,690.98c0.01-0.01,0.02-0.02,0.02-0.02c-0.01-0.07-0.03-0.14-0.04-0.21c-0.01-0.05,0-0.09,0-0.14 c-0.03,0.04-0.07,0.08-0.08,0.14C910.67,690.85,910.71,690.94,910.8,690.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M910.79,692.55c0-0.02,0-0.04,0-0.07c-0.01,0.01-0.01,0.02-0.02,0.03 C910.77,692.53,910.78,692.54,910.79,692.55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "910.55,691.81 910.55,691.81 910.55,691.81  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M915.43,680.96c0.02-0.04,0.05-0.09,0.08-0.13c0,0,0,0,0,0c-0.04,0.02-0.08,0.04-0.11,0.07 C915.4,680.91,915.42,680.94,915.43,680.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M914.1,682.06c0.39-1.01,1.06-1.44,1.25-1.23c0.05-0.02,0.1-0.03,0.15-0.03c-0.01-0.1,0-0.19,0.07-0.28 c0.46-0.61,1.21-0.89,1.21-0.89s0,0,0.01,0.01c1-0.65,1.83-0.9,2.62-0.95c0-0.01,0-0.01,0-0.01s-0.28-0.43-0.46-0.85 c-0.72,0.37-1.85,0.61-3.5,0.62c-0.39,0-0.75-0.01-1.09-0.02c0,0.03,0,0.05,0,0.08c-0.04,0.4-0.16,0.57-0.27,0.64 c0.01,0.04,0.01,0.08,0.01,0.13c0,0.51-0.04,1.34-0.07,2.06c-0.15-0.02-0.29-0.06-0.38-0.15c-0.09-0.09-0.16-0.12-0.22-0.15 c0.01,0.54-0.08,1.14-0.34,1.78c0.33,0.07,0.62,0.13,0.89,0.15C913.95,682.66,913.98,682.36,914.1,682.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M929.2,696.33c0.04-1.3-0.82-1.06-1.33-1.5c-0.5-0.43-0.28-0.58-1.5-1.47 c-0.54,0.71-1.33,1.29-2.58,1.58c-0.53,0.12-0.99,0.17-1.4,0.16c1.83,0.68,3.81,1.24,4.2,1.5c0.59,0.39,1,2.92,1.69,3.93 c0.69,1.01,0.82,0.64,1.22,0.18c0.26-0.31,0.6-0.39,0.63-1.12C930.17,698.86,929.14,698.13,929.2,696.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M911.41,678.28c0,0,0,0.01,0.01,0.01c0-0.05,0-0.1,0-0.15C911.41,678.18,911.41,678.23,911.41,678.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M914.03,681.34c0.04-0.72,0.07-1.55,0.07-2.06c0-0.05-0.01-0.09-0.01-0.13 c0.11-0.07,0.23-0.24,0.27-0.64c0-0.03,0-0.05,0-0.08c-0.4-0.02-0.77-0.04-1.11-0.08c0.04,0.29,0.15,0.58,0.26,0.86 c-0.17-0.19-0.32-0.41-0.44-0.65c0,0.23,0.05,0.47,0.16,0.67c-0.28-0.34-0.63-0.62-1.02-0.83c0.01,0.05,0.01,0.11,0.02,0.16 c-0.17-0.08-0.32-0.19-0.45-0.32c0.05,0.11,0.05,0.24,0.02,0.35c-0.08-0.13-0.16-0.25-0.27-0.36c0,0.07,0,0.15,0.01,0.22 c0.17,0.24,0.35,0.49,0.43,0.67c0.15,0.33,0.33,0.35,0.46,0.44c0.13,0.09,0.33,0.99,0.6,1.26c0.18,0.18,0.27,0.16,0.4,0.21 c0.06,0.02,0.13,0.06,0.22,0.15C913.74,681.27,913.88,681.32,914.03,681.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M924.65,682.51c0.08,0.56,0.31,1.06,0.51,1.38l0.02-0.01c0,0,0.4,0.61,1.19,1.67 c0.31-0.62,0.3-0.96-0.18-1.83c-0.54-0.98-1.88-2.97-2.61-3.9c-0.01-0.02-0.03-0.04-0.04-0.06c-0.06-0.07-0.11-0.14-0.16-0.2 c0,0,0,0.01,0,0.01c-0.26-0.26-0.56-0.45-0.93-0.53c-0.23-0.05-0.44-0.09-0.64-0.13C922.4,680.3,924.5,681.51,924.65,682.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M916.78,679.64c0.12,0.2,2.26,3.73,4.3,2.58c2.1-1.18-1.51-3.53-1.51-3.53c0.13-0.01,0.28-0.01,0.44,0 c-0.2-0.01-0.4-0.02-0.61,0C918.62,678.73,917.78,678.99,916.78,679.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M919.18,689.96c-0.18-2.15-0.41-1.55-1.13-2.55c-0.33-0.35-0.61-0.7-0.86-1.04 c-0.15-1.15-0.5-2.36-0.76-3.25c0-0.02,0.01-0.04,0.01-0.06c0.19-0.94-0.82-1.69-0.93-2.23c-0.03,0.04-0.05,0.09-0.08,0.13 c-0.01-0.02-0.03-0.05-0.04-0.07c0.04-0.02,0.07-0.04,0.11-0.07c0-0.01,0-0.01,0-0.02c-0.05,0-0.1,0.01-0.15,0.03 c-0.19-0.21-0.86,0.22-1.25,1.23c-0.12,0.3-0.15,0.6-0.13,0.91c0.03,0.55,0.21,1.14,0.34,1.82c-0.31,0.06-0.56,0.33-0.69,0.99 c-0.09,0.48-0.01,1.23,0.2,2.12c-0.48,0.59-1.23,1.35-1.88,1.98c0.18,0.1,0.35,0.21,0.51,0.34c0.06,0.05,0.13,0.1,0.17,0.17 c0.09,0.18-0.03,0.39-0.15,0.55c-0.2,0.27-0.46,0.56-0.8,0.6c-0.08,0.01-0.17,0.01-0.24,0.04c-0.02,0.01-0.03,0.02-0.04,0.04 c0.02,0.01,0.04,0.01,0.06,0.02c-0.05,0.14-0.19,0.25-0.36,0.39c-0.1,0.15-0.2,0.3-0.3,0.45c0,0.02,0,0.04,0,0.07 c0.05,0.08,0.09,0.15,0.14,0.23c0.04,0.01,0.08-0.01,0.12-0.07c0.19-0.26,0.62-0.61,1.12-0.72c0.5-0.11,0.53-0.33,0.84-0.78 l-0.05-0.02c0.1-0.07,0.2-0.14,0.31-0.23c0.28-0.22,0.76-0.39,1.3-0.58c0.49,1.33,1.1,2.68,1.72,3.73 c-0.09,0-0.14,0.01-0.14,0.01c-0.09-0.02-0.22-0.08-0.34-0.12c-0.04-0.01-0.07-0.02-0.09-0.02c-0.02,0-0.03-0.01-0.04-0.01 c-0.01,0-0.02,0-0.03,0c0,0-0.01,0-0.01,0c-0.02,0-0.04,0-0.06,0.01c-0.02,0.01-0.03,0.01-0.04,0.02 c-0.01,0.01-0.02,0.01-0.03,0.02c-0.07,0.05-0.06,0.21-0.01,0.28c-0.11-0.03-0.31-0.01-0.34,0.1c-0.01,0.02-0.02,0.05-0.02,0.07 c0.02,0.11-0.07,0.12-0.06,0.15c-0.08,0.05-0.04,0.17-0.08,0.24c-0.04,0.09-0.15,0.14-0.17,0.26c0.01-0.04,0.01-0.07,0-0.11 c-0.01,0.05-0.01,0.1-0.02,0.16c-0.02,0.35-0.09,0.19,0.57,0.44c0.69,0.27,1.58,0.47,2.39,0.62c0.78,0.14,1.27,0.01,0.78-0.98 c-0.11-0.51-0.31-1.43-0.38-2.07l0,0.02c0,0-1.75-1.91-2.42-3.23c-0.01-0.01-0.01-0.02-0.02-0.03c0.1-0.05,0.2-0.1,0.29-0.15 c0.1,0.14,0.2,0.28,0.29,0.43c0.71,1.12,1.55,1.58,1.88,2.27c0,0,0.92,1.12,2.2,1.79C919.37,693.19,919.29,691.27,919.18,689.96 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M916.02,689.78c-0.09,0.05-0.19,0.1-0.29,0.15c0.01,0.01,0.01,0.02,0.02,0.03 c0.67,1.32,2.42,3.23,2.42,3.23l0-0.02l0.03-0.69c-0.34-0.69-1.18-1.15-1.88-2.27C916.21,690.06,916.11,689.92,916.02,689.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M911.79,678.6c0.03-0.11,0.03-0.24-0.02-0.35c0.13,0.13,0.29,0.24,0.45,0.32 c-0.01-0.05-0.01-0.11-0.02-0.16c0.39,0.2,0.74,0.48,1.02,0.83c-0.11-0.21-0.16-0.44-0.16-0.67c0.12,0.23,0.27,0.45,0.44,0.65 c-0.11-0.28-0.22-0.56-0.26-0.86c-0.88-0.09-1.6-0.25-2.18-0.45c0.04,0.09,0.08,0.18,0.12,0.27c0.08,0.23,0.15,0.46,0.23,0.69 c-0.03-0.19-0.03-0.38-0.02-0.57c0-0.05,0-0.09,0.01-0.14c0,0.05,0,0.1,0,0.15c0.01,0.16,0.05,0.31,0.13,0.45 c0-0.09-0.01-0.19-0.01-0.28c0-0.07,0-0.15-0.01-0.22C911.63,678.35,911.72,678.47,911.79,678.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M913.25,678.34c0.34,0.04,0.71,0.06,1.11,0.08c0.34,0.01,0.71,0.02,1.09,0.02 c1.65-0.01,2.78-0.25,3.5-0.62c1.71-0.89,1.06-2.54-0.5-3.62c-0.07-1.13-0.29-2.27-0.82-2.63c-1.12-0.74-3.23-0.73-4.71-0.69 c-1.51,0.04-1.99,1.53-2.13,2.84c-0.32,0.18-0.57,0.36-0.8,0.51c-1.21,0.81-1.64,2.71,1.09,3.66 C911.65,678.09,912.37,678.25,913.25,678.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M926.37,693.37c0.66-0.87,0.94-1.94,1.22-2.9c0.5-1.74,0.09-3.15-0.91-4.48 c-0.11-0.15-0.22-0.29-0.32-0.43c-0.79-1.06-1.19-1.67-1.19-1.67l-0.02,0.01c-0.19-0.32-0.42-0.82-0.51-1.38 c-0.14-1.01-2.25-2.21-2.86-3.59c0,0,0-0.01-0.01-0.01c0,0-0.98-0.19-1.77-0.22c-0.16-0.01-0.31-0.01-0.44,0 c0,0,3.62,2.34,1.51,3.53c-2.05,1.15-4.19-2.39-4.3-2.58c0-0.01-0.01-0.01-0.01-0.01s-0.75,0.29-1.21,0.89 c-0.07,0.09-0.08,0.18-0.07,0.28c0,0.01,0,0.01,0,0.02c0,0,0,0,0,0c0.1,0.55,1.12,1.3,0.93,2.23c0,0.02-0.01,0.04-0.01,0.06 c0.27,0.89,0.61,2.11,0.76,3.25c0.25,0.34,0.54,0.69,0.86,1.04c0.72,1,0.95,0.4,1.13,2.55c0.11,1.3,0.19,3.23,1.21,4.31 c0.45,0.49,1.1,0.81,2.01,0.83c0.41,0.01,0.87-0.04,1.4-0.16C925.05,694.66,925.84,694.08,926.37,693.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M910.77,692.52c0.01-0.01,0.01-0.02,0.02-0.03c0.1-0.15,0.2-0.3,0.3-0.45c0.06-0.09,0.12-0.18,0.18-0.27 c0.03-0.05,0.07-0.09,0.11-0.13c0.01-0.01,0.03-0.03,0.04-0.04c0.07-0.04,0.16-0.03,0.24-0.04c0.34-0.04,0.59-0.32,0.8-0.6 c0.12-0.16,0.23-0.37,0.15-0.55c-0.04-0.07-0.1-0.13-0.17-0.17c-0.16-0.12-0.34-0.23-0.51-0.34c-0.11-0.07-0.23-0.13-0.35-0.19 c-0.08-0.04-0.17-0.08-0.26-0.07c-0.09,0.01-0.17,0.07-0.24,0.14c-0.13,0.13-0.22,0.3-0.27,0.47c-0.02,0.06-0.02,0.11-0.03,0.17 c0.03,0.02,0.06,0.05,0.04,0.09c-0.01,0.03-0.03,0.06-0.05,0.09c0,0.05,0,0.09,0,0.14c0.01,0.07,0.03,0.14,0.04,0.21 c0,0.01,0,0.03,0.01,0.04c0,0,0,0,0,0c0.11,0.03,0.23,0.02,0.33,0.09c0.07,0.05,0.1,0.15,0.08,0.23s-0.11,0.14-0.2,0.14 c0.12,0.01,0.18,0.16,0.13,0.27c-0.05,0.11-0.17,0.16-0.29,0.16c-0.12,0-0.23-0.04-0.34-0.08c0,0,0,0,0,0 c0.06,0.19,0.01,0.41-0.12,0.55c-0.01,0.02-0.03,0.03-0.05,0.04c-0.03,0.01-0.05,0-0.08-0.02c-0.06-0.03-0.11-0.08-0.15-0.14 c-0.03,0.01-0.06,0.01-0.09,0.01c-0.03,0-0.05-0.01-0.08-0.02c-0.04,0.05-0.08,0.1-0.12,0.16c-0.08-0.05-0.15-0.12-0.17-0.22 c-0.01-0.05,0-0.11,0.02-0.16c-0.07-0.07-0.14-0.14-0.23-0.17c-0.16-0.04-0.34,0.07-0.42,0.22c-0.08,0.15-0.09,0.32-0.1,0.49 c-0.01,0.15-0.02,0.31-0.03,0.46c-0.01,0.22-0.02,0.45,0.05,0.66c0.07,0.19,0.21,0.35,0.36,0.49c0.21,0.19,0.4,0.35,0.63,0.5 c0.27,0.18,0.47,0.31,0.79,0.45c0.22-0.34,0.39-0.71,0.53-1.09c0.05-0.13,0.09-0.28,0.07-0.42c-0.02-0.11-0.08-0.21-0.13-0.3 c-0.11-0.18-0.21-0.36-0.32-0.54c-0.05-0.08-0.09-0.15-0.14-0.23C910.78,692.54,910.77,692.53,910.77,692.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M909.7,692.17c0.02,0.09,0.09,0.17,0.17,0.22c0.04-0.05,0.08-0.1,0.12-0.16 c0.03-0.04,0.07-0.09,0.1-0.13c0.01,0.05,0.04,0.1,0.07,0.14c0.04,0.06,0.09,0.11,0.15,0.14c0.02,0.01,0.05,0.02,0.08,0.02 c0.02-0.01,0.04-0.02,0.05-0.04c0.13-0.15,0.18-0.36,0.12-0.55c0,0,0,0,0,0c0,0,0,0,0,0c0.11,0.04,0.22,0.08,0.34,0.08 c0.12,0,0.24-0.06,0.29-0.16c0.05-0.11-0.02-0.26-0.13-0.27c0.09,0,0.17-0.06,0.2-0.14s0-0.18-0.08-0.23 c-0.09-0.07-0.22-0.05-0.33-0.09c0,0,0,0,0,0c0-0.01,0-0.03-0.01-0.04c-0.01,0.01-0.02,0.02-0.02,0.02 c-0.09-0.05-0.13-0.14-0.1-0.24c0.02-0.05,0.05-0.09,0.08-0.14c0.02-0.03,0.04-0.05,0.05-0.09c0.02-0.04-0.01-0.07-0.04-0.09 c-0.04-0.02-0.1-0.03-0.14-0.02c-0.14,0.02-0.21,0.17-0.25,0.29c-0.04,0.13-0.06,0.26-0.05,0.39c0,0.03,0,0.06-0.01,0.08 c-0.02,0.04-0.06,0.05-0.09,0.08c-0.07,0.06-0.09,0.18-0.03,0.25c-0.08-0.02-0.14,0.07-0.16,0.15 c-0.02,0.08-0.02,0.18-0.09,0.23c-0.05,0.04-0.12,0.03-0.17,0.06c-0.03,0.02-0.06,0.05-0.08,0.08 C909.7,692.06,909.69,692.12,909.7,692.17z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M929.29,697.33c0.11,0.51,0.3,0.91,0.48,1.24C929.67,698.17,929.51,697.75,929.29,697.33z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M927.8,699.49c0.41,0.91,0.86,1.8,1.32,1.6c0.15-0.07-0.53-0.56-0.61-1.17 c-0.09-0.62-0.43-2.17-0.71-2.71c-0.78-1.56-0.25-2.01-0.49-1.96c-0.69,0.14-1.54-0.87-1.82-1.02c0.09-0.07,0.17-0.13,0.25-0.21 c0.44-0.39,0.79-0.85,1.05-1.34c0.05-0.1,0.1-0.2,0.15-0.3c0.73-1.52,1-3.15,0.81-4.09c-0.17-0.87-0.37-1.29-0.84-1.97 c-0.07-0.11-0.15-0.22-0.24-0.34c-0.21-0.29-0.27-0.44-0.26-0.56c0.01-0.24,0.29-0.32,0.03-1.1c-0.11-0.34-0.8-1.5-1.48-2.55 c-0.52-0.8-1.03-1.54-1.28-1.81c-0.01-0.01-0.01-0.01-0.02-0.02c-0.27-0.28-0.97-0.53-1.71-0.72c-0.81-0.21-1.65-0.35-2.01-0.38 c-0.06,0-0.11-0.01-0.16-0.02c-0.25-0.03-0.42-0.08-0.52-0.15c-0.33-0.21-0.1-0.54-0.51-0.79c0,0,0,0,0,0 c0.12-0.06,0.18-0.09,0.18-0.09c0.67-1.54-0.51-3.34-0.51-3.34c-0.21,0.44-0.72,0.75-0.72,0.75c0.46-0.44,0.39-0.9,0.39-0.9 c-0.26-2.26-0.96-2.07-3.14-2.22c-2.18-0.15-0.86-0.92-1.83-0.99c-1.31-0.09-1.82,1.04-2,2.18c-0.18,1.13-0.13,2.52-0.13,2.52 s-1.18,1.41-0.64,1.77c0,0,0.01,0.01,0.01,0.01c0.21,0.14,0.47,0.24,0.71,0.31c0.12,0.04,0.23,0.07,0.33,0.09 c0.03,0.01,0.06,0.01,0.09,0.02c0,0,0,0,0,0.01c0.02,0.1,0.06,0.21,0.13,0.34c0.11,0.21,0.29,0.43,0.54,0.59 c0.43,0.27,0.61,0.4,0.72,0.89c0.12,0.49,0.75,0.74,0.77,1.17c0.01,0.16,0.17,0.24,0.36,0.29c0.13,0.04,0.29,0.06,0.41,0.1 c0.39-0.57,0.84-0.76,0.94-0.52c-0.69,0.28-1.08,1.29-0.62,2.91c0.46,1.63,0,2.86,0.23,3.25c0.23,0.39,0.46,0.74,0.46,0.74 s-0.46-0.23-1.01,0.46c-0.47,0.6-1.59,1.48-2.19,1.87c-0.1,0.06-0.18,0.11-0.25,0.15c-0.46,0.23-0.55,0.8-0.86,0.84 s-0.51,0.24-0.61,0.56c-0.1,0.32-0.05,0.17-0.27,0.39c-0.05,0.06-0.12,0.08-0.19,0.1c-0.01,0-0.03,0.01-0.04,0.01 c-0.1,0.03-0.2,0.05-0.3,0.14c-0.08,0.08-0.16,0.23-0.21,0.48c-0.15,0.77-0.18,1.41-0.18,1.41s0.06,0.05,0.15,0.14c0,0,0,0,0,0 c0.28,0.24,0.86,0.72,1.27,0.81c0,0,0.46-0.67,0.53-1.09c0.03-0.21,0.04-0.4,0.01-0.59c-0.04-0.19-0.12-0.38-0.26-0.57 c-0.03-0.04-0.06-0.08-0.08-0.11c-0.14-0.21,0.07-0.06,0.07-0.06s0.01-0.08,0.18-0.21c0.05-0.04,0.12-0.08,0.22-0.13 c0.35-0.18,0.76-0.32,1.01-0.49c0.03-0.02,0.05-0.03,0.07-0.05c0.09-0.08,0.19-0.19,0.27-0.3c0.12-0.17,0.21-0.32,0.21-0.32 s0.59-0.46,1.4-0.77c0.05-0.02,0.11-0.04,0.16-0.06c0.25-0.09,0.5-0.18,0.74-0.28c-0.15,0.06-0.3,0.12-0.45,0.17 c0.37,0.67,0.8,1.34,1.17,1.96c0.85,1.42,1.04,2.13,1.08,2.4c-0.35-0.32-0.95-0.89-1.33-1.48c-0.01-0.02-0.03-0.04-0.04-0.06 c0.27,0.58,0.43,0.83,0.51,0.93c0.03,0.05,0.05,0.06,0.05,0.06c0.61,0.43,0.56,0.48,0.82,0.65c0,0.03,0,0.04,0,0.04 s-1.84,0.07-2.32,0.44c0-0.02,0-0.04,0-0.06c0-0.04,0.01-0.08,0.01-0.11c-0.27,0.08-0.51,0.15-0.72,0.23 c-1.25,0.44-1.63,1-0.67,1.71c-0.51,0.11-1.2-0.22-1.32-0.53c-0.09-0.24,0.12-0.58-0.41-0.75c-0.53-0.17-1.67-0.51-2.45,0.34 c0,0,0,0,0,0.77c0,1.68,6.13,1.68,9.28,1.25c8.61-0.81,8.41,2.9,10,2.78c-0.07-0.08-0.15-0.19-0.23-0.31 C928.11,700.27,927.95,699.9,927.8,699.49z M916.88,684.77c0.05,0.21,0.1,0.42,0.14,0.63c0.24,0.44,0.54,0.9,0.91,1.35 c1.69,2.08,1.25,1.91,1.2,2.67c0,0.06,0,0.13,0,0.2c0.01,0.15,0.01,0.36,0.02,0.61c-0.03-0.46-0.03-0.78-0.03-0.89 c0-0.03,0-0.04,0-0.04c0,0,0,0-0.01-0.01c-0.65-0.7-1.27-1.39-1.83-1.96c-0.01-0.22-0.03-0.45-0.07-0.69 C917.14,686.2,917.01,685.48,916.88,684.77z M916.83,689.12c-0.05,0.06-0.09,0.12-0.15,0.18c-0.06,0.06-0.12,0.11-0.18,0.17 c0.06-0.05,0.13-0.11,0.18-0.17C916.73,689.24,916.78,689.18,916.83,689.12z M918.41,694.31c-0.12-0.5-0.22-1-0.24-1.4 c-0.01-0.16,0-0.31,0.02-0.43c0,0,0.01,0.01,0.03,0.04c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.01,0.01,0.01,0.02,0.02 c0.22,0.25,0.92,1.01,1.76,1.54C919.47,694.17,918.93,694.24,918.41,694.31z M915.44,690.06c-0.03,0.01-0.06,0.02-0.09,0.04 C915.38,690.08,915.41,690.07,915.44,690.06z M917.76,696.23c-0.15-0.03-0.31-0.06-0.47-0.09c0.95,0.15,1.4,0.15,1.44-0.26 C918.74,696.29,918.33,696.34,917.76,696.23z M920.39,694.28c0,0-0.01,0-0.01-0.01c-0.01-0.01-0.01-0.01-0.01-0.02 c-0.01-0.02-0.03-0.04-0.04-0.06c0.33,0.38,0.77,0.66,1.32,0.79c0.3,0.07,0.59,0.11,0.87,0.12 C921.54,695.11,920.86,694.78,920.39,694.28z M925.3,696.1c-0.77-0.26-1.76-0.58-2.73-0.94 C923.22,695.35,924.38,695.76,925.3,696.1z M926.65,696.66c-0.02-0.02-0.03-0.04-0.05-0.05 C926.62,696.62,926.63,696.63,926.65,696.66z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M914.42,686.12c-0.07,0.06-0.14,0.14-0.2,0.23c-0.31,0.42-0.39,0.92-0.32,1.46 c0.23-0.28,0.38-0.51,0.41-0.66C914.38,686.79,914.41,686.44,914.42,686.12z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "father"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1160.33,662.07c1.89-3.99,8.28-10.65,10.51-7.23c-0.84-2-1.11-0.86-2.78-7.13 c-1.65-6.18-5.75-12.37-9.49-12.63c0.29,9.49,0.53,19.13,0.7,28.83C1159.66,663.33,1160.02,662.73,1160.33,662.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1132.69,629.52c5.83,4.02,12.9,26.72,20.78,42.8c0.35,0.72,0.66,1.38,0.94,2 c1.11-5.68,3.24-7.97,4.86-10.41c-0.17-9.7-0.41-19.34-0.7-28.83c-1.53-49.93-4.6-95.77-7.98-124.58 c-4.27-36.32-14.55-63.02-21.07-77.04c-4.74-10.17-16-8.01-15.67,4.2c0.28,10.46,3.48,74.06,1.55,186.24 C1123.38,623.6,1129.1,625.5,1132.69,629.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1139.09,712.75c-3.62-3.71-6.49-5.84-8.29-7.14c-0.16,0.52-0.33,1.03-0.49,1.56 c-1.31,4.28-2.35,9.02-3.16,13.54c-0.74,8.03-1.2,15.02-1.45,21.03c-0.39,15.45,4.35,44.47,5.03,54.03 c0.08,1.12,0.2,2.46,0.34,3.95c10.31,0,19.05,0,25.22,0c1.91-24.2,2.91-51.7,3.21-80.18 C1152.33,726.31,1145.21,719.01,1139.09,712.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1051.53,575.02l0.07-0.02c-0.33-1.48-0.69-3.04-1.05-4.73c-2.09-9.79-0.55-4.75-4.37-8.53 c-0.25,0.67-0.49,1.35-0.72,2.06c-1.24,3.78-1.8,6.33-1.97,8.16c0.1-0.16,0.21-0.22,0.33-0.12c0,0,0.51-0.11,1.01,0.66 c0.5,0.77,1.34,4.37,1.34,4.37s-1.71-1.17-2.57-2c0,0-0.01-0.01-0.01-0.01c0.5,2.41,1.96,2.9,1.07,7.19 c-0.94,4.52-0.68,9.15-0.15,13.45c0.76-2.6,2.38-7.4,4.2-11.1C1051.24,579.23,1052.3,579.52,1051.53,575.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1106.49,589.76c-0.42,1.31-0.82,2.59-1.19,3.82C1105.74,592.33,1106.14,591.05,1106.49,589.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1046.18,576.87c0,0-0.84-3.6-1.34-4.37c-0.5-0.77-1.01-0.66-1.01-0.66c-0.12-0.1-0.24-0.04-0.33,0.12 c-0.34,0.56-0.45,2.34,0.1,2.9c0,0,0.01,0.01,0.01,0.01C1044.46,575.7,1046.18,576.87,1046.18,576.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1100.25,614.65c0.03-0.89,0.1-1.85,0.21-2.88c-12.5,7.44-25.88,5.33-32.38-8.03 c-2.71-5.56-3.93-10.91-4.73-15.16c0-0.02,0-0.04,0-0.06c0.18-6.77-0.47-10.34-3.48-11.85c-3.29-1.65-5.47,2.87-4.96,7.4 s-0.65,8.5,0,12.5c0.55,3.35,2.81,3.89,4.22,3.04c0.08,0.54,0.16,1.15,0.23,1.86c2.24,22.13-2.68,19.7-2.68,19.7 s-0.06,0.02-0.17,0.04c1.34,0.2,2.83,0.26,4.5,0.14c1.43-0.1,2.54,0.69,3.41,1.99c2.41-0.44,25.43-4.7,33.42-6.75 C1099.2,616.24,1100,615.22,1100.25,614.65z M1057.42,594.96c-0.55,1.17-1.3,0.19-0.79-1.77c0.52-1.95-0.01-2.35-0.45-3.33 c-0.45-0.98-0.11-1.27-0.11-1.27c0.87,1.47,1.81,0.89,2.34,1.58C1058.95,590.86,1057.97,593.79,1057.42,594.96z M1058.36,597.55 c0,0,3.02-5.75,2.81-10.45C1061.16,587.1,1061.64,595.42,1058.36,597.55z M1058.06,579.93c-1.02,0.41-1.61,2.44-0.42,4.01 c1.18,1.57,1.62,2.26,1.98,3.54c0.36,1.27-0.19,2.54-0.19,2.54s-0.25-0.98-0.6-2.16s-1.24,0.58-2.41-0.8 c-1.17-1.38-0.9-5.49-0.6-6.46s0.95-2.54,2.58-2.14c1.63,0.4,2.25,2.95,2.79,4.72C1061.19,583.18,1059.5,579.35,1058.06,579.93z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1043.45,544.73c0,0,0.36-0.36,1.05-0.96C1043.59,544.29,1043.45,544.73,1043.45,544.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1059.37,601.47c-0.07-0.7-0.15-1.32-0.23-1.86c-1.42,0.85-3.68,0.31-4.22-3.04 c-0.65-4,0.51-7.96,0-12.5s1.67-9.05,4.96-7.4c3,1.51,3.66,5.08,3.48,11.85c0,0.02,0,0.04,0,0.06c0.8,4.25,2.03,9.6,4.73,15.16 c6.5,13.37,19.88,15.47,32.38,8.03c0.04-0.03,0.09-0.05,0.13-0.08c0,0,1.44-7.36,4.71-18.11c0.37-1.23,0.77-2.51,1.19-3.82 c0.27-0.83,0.54-1.68,0.83-2.54c2.87-8.62,5.46-17.97,5.42-23.64c0.69-7.65-0.25-13.41-1.58-16.96 c-1.77-4.73-0.89-1.48-0.89-1.48s0.2,4.99,0.43,8.24c-0.84-2.6-2.14-5.32-4.54-8.26c-1.25-2.25-2.75-4.47-4.47-6.19 c-5.05-5.05-3.83-4.89-2.1-0.16c-2.56-2.07-5.35-3.73-7.9-3.82c-8.54-0.3-13.83-3.28-19.18-2.96c-1.84-0.14-5.13,0.45-8.25,1.65 c-0.03-0.07-0.04-0.11-0.04-0.11c-4.38,2.41-9.19,2.8-13.79,5.8c-2.83,1.85-4.83,3.46-5.94,4.43c1.11-0.63,3.38-1.39,7.97-1.62 c-0.87,0.04-1.7,0.23-2.47,0.54c-2.96,0.92-5.35,2.88-6.82,5.87c0,0,0.52-0.85,2.23-1.83c-0.23,0.36-0.44,0.73-0.63,1.12 c-0.44,0.51-0.89,1.11-1.3,1.81c-0.76,0.97-1.36,2.05-1.68,3.26c-1.38,5.07-2.09,4.96,0.55,3.24c0.03,1.48,0.41,3.03,1.26,4.47 c1.85,3.17,1.38,2.2,0.88-0.91c0.23,0.37,0.48,0.73,0.77,1.05c0.34,0.38,0.64,0.7,0.92,0.98c3.81,3.78,2.27-1.26,4.37,8.53 c0.36,1.68,0.72,3.25,1.05,4.73l-0.07,0.02c0.77,4.51-0.29,4.21-2.82,9.37c-1.81,3.7-3.44,8.5-4.2,11.1 c-0.11,0.38-0.2,0.71-0.27,0.99c-0.12,0.45-0.03,1.69,0.11,2.13c0.16,0.49,0.4,1.35,0.74,2.8c0.66,2.86,0.51,2.73,0.51,5.58 s-1.06,9.69,5.71,13.08c2.82,1.41,4.65,1.24,5.2,1.14c0.11-0.02,0.17-0.04,0.17-0.04S1061.61,623.6,1059.37,601.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1058.4,578.47c-1.63-0.4-2.27,1.16-2.58,2.14s-0.58,5.09,0.6,6.46c1.17,1.38,2.05-0.38,2.41,0.8 s0.6,2.16,0.6,2.16s0.55-1.27,0.19-2.54c-0.36-1.27-0.8-1.96-1.98-3.54c-1.18-1.57-0.6-3.6,0.42-4.01 c1.44-0.58,3.13,3.25,3.13,3.25C1060.65,581.42,1060.03,578.87,1058.4,578.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1058.41,590.17c-0.54-0.69-1.47-0.11-2.34-1.58c0,0-0.34,0.29,0.11,1.27c0.45,0.98,0.97,1.38,0.45,3.33 c-0.52,1.95,0.23,2.94,0.79,1.77C1057.97,593.79,1058.95,590.86,1058.41,590.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1058.36,597.55c3.29-2.13,2.81-10.45,2.81-10.45C1061.38,591.8,1058.36,597.55,1058.36,597.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1170.84,654.85c-2.23-3.42-8.61,3.24-10.51,7.23c-0.31,0.66-0.67,1.25-1.07,1.84 c-1.62,2.44-3.75,4.73-4.86,10.41c-0.27-0.62-0.58-1.28-0.94-2c-7.89-16.08-14.95-38.78-20.78-42.8 c-3.59-4.02-9.31-5.92-17.3-5.62c-2.88,0.11-6.05,0.51-9.52,1.19c-2.46-3.4-5.02-7.56-5.53-10.76c0,0.07-0.03,0.18-0.08,0.31 c-0.25,0.58-1.05,1.59-2.41,1.94c-7.99,2.05-31.01,6.31-33.42,6.75c-0.13,0.02-0.21,0.04-0.21,0.04s3.65,5.5-3.25,8.48 c-0.57,0.19-1.16,0.4-1.78,0.64c-3.37,1.28-6.34,2.84-8.95,4.65c-0.9,0.47-1.65,0.88-2.3,1.26 c-11.83,6.9-21.29,15.08-19.38,32.85c1.96,18.32-3.23,18.64-3.23,58.53c0,11.13-13.96,36.83-13.8,69.92c7.61,0,16.48,0,26.05,0 c2.62-9.06,6.42-20.79,10.9-30.26c4.87-10.3,7.86-16.54,9.26-46.94c0-0.02,0-0.04,0-0.04c0-0.02,0-0.05,0.01-0.07 c0.01-0.32,0.03-0.63,0.04-0.96c0.04-0.98,0.11-1.98,0.18-2.98c0.34-9.61-0.71-19.87-0.79-32.25 c-0.09-14.12,3.81-0.29,3.85,6.77c0.02,3.56,0.55,2.6,1.36-0.42c1.47-6.32,2.79-11.33,3.1-13.58c0.1-0.73,0.01-0.05-0.22,1.72 c0.06-0.23,0.11-0.46,0.17-0.69c0.81-3.23,0.78-2.12,0.28,1.49c0.4-2.05,0.64-3.14,0.64-3.14s-1.76,10.38-3.7,23.78 c-0.63,5.5-1.28,11.54-1.87,17.64c-0.24,9.04,0.84,17.97,5.92,25.24c5.08,7.27,22.68,10.93,31.05,14.04 c0.73,0.27,0.67,1.28-0.07,1.53c-21.36,7.18-33.55-4.82-33.44,2.06c0.55,1.23,7.59,6.17,21.35,6.88 c2.25,0.12-16.17,6.05-25.34,9.48c-7.38,2.08-12.28,2.77-15.36,8.65c-0.03-0.04-0.06-0.07-0.09-0.11 c-0.03,0.08-0.06,0.17-0.09,0.25c-0.05,0.15-0.11,0.3-0.16,0.45c0.01,0,0.03,0.01,0.04,0.01c0,0.01-0.01,0.02-0.01,0.02 c-0.01,0-0.03-0.01-0.04-0.01c-0.05,0.15-0.11,0.3-0.16,0.45c-0.16,0.35-0.31,0.72-0.45,1.1c-0.31,0.81-0.56,1.62-0.78,2.43 c-0.93,2.71-1.74,5.19-2.45,7.43c27.88,0,61.04,0,86.24,0c-0.42-17.8-6.03-23.3-6.15-33.48c-0.05-4.48-0.21-8.09-0.51-10.9 l-1.04,6.03c0.45-2.61,0.8-4.91,0.95-6.85c-0.53-4.25-1.42-6.49-2.85-7.1c-1.72-0.34-4.32,0.25-8.11,1.9 c-12.06,5.23-26.62,2.5-15.47,1.59c11.15-0.91,24.35-7.51,27.08-20.25c2.73-12.74,10.01-30.49,12.06-40.27 c0,0,0.06,0.06,0.12,0.23c2.42-11.98,2.2-21.58,1.88-26.04c-0.01-0.21,0.28-0.24,0.33-0.04c3.91,19.07-0.71,29.35-4.43,41.08 c1.81,1.3,4.67,3.43,8.29,7.14c6.11,6.26,13.24,13.56,20.41,6.78c0.34-0.33,0.69-0.68,1.03-1.08c1.83-2.08,3.16-4.33,4.1-6.58 c0.09,0.17,0.14,0.26,0.14,0.26c3.44-9.11,5.51-15.93,6.63-25.63c1.11-9.7,1.39-15.97,2.23-21.68 C1174.46,659.12,1173.07,658.27,1170.84,654.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M1043.16,792.29c0.21-0.8,0.47-1.61,0.78-2.43c0.14-0.39,0.3-0.75,0.45-1.1 c0.05-0.15,0.11-0.3,0.16-0.45c0.01,0,0.03,0.01,0.04,0.01c0-0.01,0.01-0.02,0.01-0.02c-0.01,0-0.03-0.01-0.04-0.01 c0.05-0.15,0.11-0.3,0.16-0.45c0.03-0.09,0.06-0.17,0.09-0.25c0.03,0.04,0.06,0.07,0.09,0.11c3.07-5.88,7.98-6.57,15.36-8.65 c9.16-3.43,27.58-9.36,25.34-9.48c-13.76-0.71-20.8-5.65-21.35-6.88c-0.12-6.88,12.08,5.12,33.44-2.06 c0.74-0.25,0.8-1.26,0.07-1.53c-8.37-3.11-25.96-6.77-31.05-14.04c-5.08-7.26-6.16-16.2-5.92-25.24 c0.59-6.1,1.25-12.14,1.87-17.64c1.93-13.41,3.7-23.78,3.7-23.78s-0.24,1.08-0.64,3.14c0.5-3.62,0.54-4.72-0.28-1.49 c-0.06,0.23-0.11,0.46-0.17,0.69c0.23-1.76,0.32-2.44,0.22-1.72c-0.31,2.25-1.63,7.27-3.1,13.58c-0.82,3.02-1.34,3.97-1.36,0.42 c-0.04-7.06-3.94-20.89-3.85-6.77c0.08,12.38,1.13,22.64,0.79,32.25c-0.08,1-0.14,2-0.18,2.98c-0.01,0.32-0.03,0.64-0.04,0.96 c0,0.02,0,0.05-0.01,0.07c0,0,0,0.01,0,0.04c-1.4,30.41-4.39,36.64-9.26,46.94c-4.47,9.47-8.28,21.19-10.9,30.26 c1.04,0,2.09,0,3.14,0C1041.42,797.47,1042.23,794.99,1043.16,792.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M1130.74,795.77c-0.68-9.56-5.42-38.58-5.03-54.03c0.25-6.01,0.71-13,1.45-21.03 c0.81-4.52,1.85-9.26,3.16-13.54c0.16-0.52,0.32-1.04,0.49-1.56c3.73-11.73,8.34-22.02,4.43-41.08 c-0.04-0.2-0.34-0.16-0.33,0.04c0.31,4.45,0.53,14.05-1.88,26.04c-0.06-0.18-0.12-0.23-0.12-0.23 c-2.05,9.78-9.33,27.53-12.06,40.27c-2.73,12.74-15.93,19.34-27.08,20.25c-11.15,0.91,3.41,3.64,15.47-1.59 c3.8-1.65,6.4-2.23,8.11-1.9c1.42,0.61,2.32,2.85,2.85,7.1c-0.14,1.94-0.5,4.24-0.95,6.85l1.04-6.03 c0.3,2.81,0.46,6.42,0.51,10.9c0.12,10.18,5.73,15.68,6.15,33.48c1.4,0,2.78,0,4.13,0 C1130.93,798.22,1130.82,796.88,1130.74,795.77z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1173.91,660.67c-0.37-3.23-3.07-5.83-3.07-5.83c0.93,3.42,2.04,5.89-1.67,13.88 c-3.71,7.99-7.05,15.97-6.68,24.53c0,0,0.48,3.07,0.44,6.94c-1.25-9.36-4.78-18.03-8.45-26.21c1.4-6.77,4.28-8.59,5.86-11.91 c1.89-3.99,8.28-10.65,10.51-7.23c-0.84-2-1.11-0.86-2.78-7.13c-1.61-6.03-5.55-12.07-9.22-12.6c-0.2-7.9-0.41-15.26-0.64-21.9 c-1.58-46.84-4.47-80.94-8.05-106.16c-0.62-4.35-1.25-8.43-1.91-12.27c-0.26-1.54-0.53-3.03-0.79-4.49 c-5.21-28.56-11.19-42.61-15.56-51.5c-1.21-2.47-2.3-4.54-3.22-6.41c-2.72-5.59-7.37-5.14-6.87-0.25 c1.7,16.58,5.39,93.35,3.66,192.8c-2.8-0.88-5.83-1.14-8.98-1.05c-3.08,0.09-6.27,0.51-9.45,1c-0.39,0.06-0.77,0.12-1.16,0.18 c0,0-0.11-0.13-0.31-0.37c-0.63-0.78-2.11-2.76-3.43-5.47c-0.67-1.37-1.29-2.94-1.74-4.63c0.15-2.04,0.76-6.33,3.03-14.27 c3.5-12.22,8.71-24.96,9.22-33.75c0.38-6.59,0.82-11.07-0.53-16.7c-0.24-1.02-0.55-2.07-0.92-3.18 c-0.29-0.88-0.63-1.79-1.01-2.75c0,0,0.01,0.1,0.01,0.27c0.01,0.18,0.02,0.43,0.04,0.75c0.08,1.63,0.26,4.93,0.42,7.88 c0,0-0.67-2.1-2.54-5.05c-0.02-0.03-0.04-0.07-0.07-0.1c-0.56-0.87-1.22-1.81-2-2.8c-0.05-0.06-0.09-0.11-0.14-0.17 c-3.57-4.44-4.88-4.44-8.28-5.92c-3.4-1.48,0.18,0.53,3.18,3.97c3,3.44-38.82-6.45-43.01,20.72c-1.48,9.6-0.79,13.32-0.79,13.32 c0.03-0.01,0.06-0.02,0.1-0.03c1.95-0.56,5.36,1.29,5.73,8.52c0.2,3.89-0.72,4.26-1.76,10.36c-0.66,3.87-2.63,4.35-4.01,4.18 c-0.21-0.03-0.41-0.07-0.58-0.11c0,0,0.77,0.88,2.5,0.44c-0.18,0.4,1.24,22.55-8.59,19.39c-0.17-0.06-0.35-0.12-0.52-0.19 c0,0,0.95,0.88,3.41,1.5c0.63,0.16,1.37,0.3,2.21,0.4c1.48,0.18,3.3,0.24,5.51,0.08c0.18-0.01,0.36-0.03,0.53-0.04 c0.14,0.03,0.29,0.07,0.45,0.13c0.4,0.13,0.85,0.33,1.25,0.61c0.27,0.19,0.52,0.42,0.72,0.69c0.14,0.19,0.25,0.4,0.33,0.63 c0.03,0.1,0.06,0.2,0.09,0.3c0.02,0.08,0.03,0.16,0.04,0.24l0.08-0.02l0.74-0.16c1.34,3.25,4.29,5.27-0.47,7.33 c0,0,5.77-1.17,12.4-1.35c0.39-0.01,0.48,0.54,0.1,0.65c-4.77,1.38-14.79,3.25-27.59,14.91c-14.81,13.49-2.54,40.94-7.62,57.12 c-5.08,16.18-5.39,25.07-5.39,34.91c0,8.71-10.35,33.21-16.72,62.42c42.53,0,112.2,0,137,0c1.78-22.45,2.56-51.13,2.75-80.36 c-1.29,1.27-2.59,2.07-3.87,2.5c2.32-0.98,4.63-2.97,6.69-5.97c0.78-1.13,1.52-2.41,2.22-3.84c0.14-0.28,0.28-0.57,0.41-0.87 c1.06-2.32,2-5,2.78-8.04c0.25-0.98,0.49-1.98,0.7-3.03c1.97-9.63,2.83-14.87,3.42-19.61c0.24-1.95,0.45-3.82,0.66-5.87 C1173.44,667.59,1174.28,663.91,1173.91,660.67z"
  })))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: -0.13,
    fill: "#C16032",
    width: 320,
    height: 352.13
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "line_2_",
    x: 35,
    y: 183,
    width: 1034,
    height: 7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 880.0742 220.3686)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "Since 2020, the electricity"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.05,
    y: 26,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "for all BMW Group plants"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.99,
    y: 52,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "has been sourced from"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.72,
    y: 78,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "100% RENEWABLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.73,
    y: 104,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "ENERGIES."))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M374.99,482.37c0.14-4.58-1.94-11.99-13.81-17.53c-0.32-0.15-0.66,0.13-0.58,0.47l4.54,19.21 c0.03,0.11,0.01,0.22-0.05,0.31l-5.63,9.31c-0.1,0.17-0.07,0.38,0.07,0.51c8.43,8.2,14.67,19.61,14.58,35.41 C374.23,522.7,374.79,489.22,374.99,482.37z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M340.85,459.24c-4.97-0.75-10.65-1.29-17.13-1.56c-0.5-0.02-0.88,0.46-0.73,0.94l2.59,8.54 c0.06,0.18,0.04,0.38-0.05,0.55l-3.71,7.02c-0.22,0.42,0.01,0.94,0.48,1.05c4.61,1.07,11.24,2.97,18.21,6.18 c0.35,0.16,0.76,0.03,0.94-0.31l4.12-7.42c0.1-0.17,0.12-0.38,0.06-0.56l-4.18-13.92C341.35,459.48,341.13,459.28,340.85,459.24z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M322.32,458.43c-0.15-0.49-0.59-0.82-1.09-0.84c-0.21-0.01-0.43-0.01-0.65-0.02l-9.03-0.1 c-0.81-0.01-1.39,0.79-1.13,1.56l4.99,14.84c0.14,0.42,0.5,0.72,0.94,0.79c0.71,0.11,1.94,0.32,3.56,0.65 c0.52,0.11,1.04-0.14,1.29-0.6l3.63-6.87c0.15-0.28,0.18-0.6,0.09-0.9L322.32,458.43z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M336.69,467.81c0.02-3.18-0.52-6.29-1.57-9.19l3.42-3.61l-4.72-7.87l-5.05,1.51 c-2.23-2.21-4.86-4.04-7.82-5.37l-0.13-4.74l-8.9-2.22l-2.48,4.61c-2.75,0.05-5.43,0.53-7.97,1.39l-4.23-3.8l-7.87,4.72 l1.68,5.56c-1.84,1.85-3.43,3.98-4.68,6.35l-5.84,0.03l-2.22,8.9l4.88,2.63l0.12-0.32c-0.14,2.86,0.19,5.68,0.93,8.35 l-3.73,4.03l4.72,7.87l4.67-1.4c2.11,2.41,4.66,4.46,7.58,6l0.13,4.97l8.9,2.22l2.21-4.11c3.41,0.16,6.76-0.33,9.88-1.4 l3.47,3.29l7.87-4.72l-1.4-4.65c2.31-2.23,4.24-4.9,5.64-7.92l-0.39,0.47l5.42-0.1l2.22-8.9L336.69,467.81z M305.46,485.75 c-10.01-2.5-16.09-12.63-13.59-22.64c2.5-10.01,12.63-16.09,22.64-13.59s16.09,12.63,13.59,22.64S315.46,488.25,305.46,485.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 749.814,
    y1: -2447.9609,
    x2: 813.1522,
    y2: -2447.9609,
    gradientTransform: "matrix(0.1834 0.983 -0.983 0.1834 -2319.3381 129.5704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M208.31,420.79c0,0,12.69-2.24,24.04,3.84c14.6,7.81,27.66,25.45,18,52.75l-39.46-15.26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -1372.5062,
    y1: 905.1298,
    x2: -1307.8817,
    y2: 905.1298,
    gradientTransform: "matrix(0.752 -0.6591 0.6591 0.752 602.4982 -1110.7278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M178.41,487.73c0,0-7.28-9.36-7.84-22.22c-0.72-16.54,7.86-37.77,36.28-43.38l5.14,39.84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -3214.0801,
    y1: -2435.9949,
    x2: -3149.439,
    y2: -2435.9949,
    gradientTransform: "matrix(-0.9529 -0.3032 0.3032 -0.9529 -2079.1296 -2801.6099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M250.3,477.56c0,0-4.25,11.06-14.97,18.19c-13.79,9.17-36.51,13.06-55.99-8.36l31.56-25.27"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M249.08,474.76c-1.19-0.74-4.29-2.64-7.86-4.83c-5.77-3.53-12.76-7.82-14.91-9.23 c-3.48-2.28-3.32-1.01-5.46-0.32c-1.82,0.58-3.58,0.69-5.13,0.27c0,0.04,0,0.08,0,0.12c-0.03,1.96-1.64,3.52-3.6,3.49 c-1.73-0.03-3.14-1.28-3.43-2.92c-2.46,2.04-13.74,11.39-21.39,17.72c-3.44,2.85-6.14,5.09-6.98,5.78 c-2.28,1.89-0.72,4.33,2.04,2.74c1.23-0.71,4.41-2.58,8.07-4.74c5.92-3.49,13.09-7.71,15.38-8.97c3.7-2.03,2.5-2.48,2.93-4.71 c0.25-1.3,0.69-2.45,1.3-3.44l-1.67,37.21c0,0,1.86,0.21,3.69,0.22c2.9,0.02,3.38-0.28,3.39-0.21 c-0.12-4.37-1.11-30.8-1.41-38.77c2.93,1.19,16.27,6.63,25.32,10.31c4.07,1.66,7.27,2.96,8.26,3.37 C250.33,478.96,251.74,476.42,249.08,474.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M214.16,457.78c-0.7-4.91-2.46-17.29-3.7-26c-0.63-4.42-1.12-7.89-1.28-8.97 c-0.42-2.93-3.31-2.88-3.4,0.3c-0.04,1.42-0.1,5.11-0.18,9.36c-0.12,6.86-0.27,15.19-0.4,17.8c-0.2,4.22,0.81,3.43,2.48,4.96 c0.93,0.86,1.67,1.79,2.2,2.78c0.63-0.54,1.46-0.87,2.36-0.85C212.95,457.18,213.61,457.4,214.16,457.78z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 268.2169,
    cy: 488.9511,
    r: 18.7164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    style: {
      stopColor: "#EDF6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "#D8ECF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    style: {
      stopColor: "#CDE9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5882,
    style: {
      stopColor: "#B0E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    style: {
      stopColor: "#80D3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#3FC1E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M279.81,490.58c-3.61-8.08-11.38-24.94-11.59-25.39l0-0.01c0,0,0,0,0,0.01c0,0,0-0.01,0-0.01 l0,0.01c-0.21,0.45-7.98,17.31-11.59,25.39c-4.04,9.03-1.53,21.4,10.5,22.12l0,0.01c0.28,0.01,0.55,0.02,0.81,0.02 c0.09,0,0.18,0,0.27,0c0.09,0,0.18,0,0.27,0c0.27,0,0.54-0.01,0.81-0.02l0-0.01C281.34,511.98,283.85,499.61,279.81,490.58z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M302.91,457.08l-0.1,6.13c-4.2-5.15-9.38-9.23-15.44-12.14c-22.46-10.78-49.51-1.29-60.29,21.17 c-6.56,13.65-5.85,29.6,1.88,42.64l1.31-0.78c-7.48-12.61-8.16-28.01-1.82-41.21c10.42-21.7,36.56-30.88,58.26-20.46 c5.85,2.81,10.87,6.76,14.92,11.73l-5.74-0.25l-0.07,1.52l8.45,0.36l0.14-8.71L302.91,457.08z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M306.26,468.06l-1.3,0.8c7.85,12.73,8.67,28.38,2.2,41.84c-5.05,10.51-13.89,18.43-24.89,22.3 c-11,3.86-22.85,3.21-33.37-1.84c-5.86-2.81-10.88-6.77-14.94-11.76l5.58,1.35l0.36-1.48l-8.22-1.99l-1.83,8.52l1.49,0.32 l1.28-5.96c4.23,5.26,9.49,9.43,15.63,12.38c6.2,2.98,12.85,4.48,19.53,4.48c5.04,0,10.11-0.86,15.01-2.58 c11.39-4,20.54-12.19,25.76-23.07C315.23,497.42,314.38,481.24,306.26,468.06z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M359.04,463.9c-4.25-1.73-9.6-3.24-16.3-4.36c-0.32-0.05-0.6,0.25-0.5,0.57l4.14,13.76 c0.03,0.11,0.02,0.24-0.04,0.34l-4.39,7.92c-0.12,0.22-0.04,0.5,0.19,0.61c5.45,2.65,11.04,6.11,15.99,10.6 c0.21,0.19,0.53,0.14,0.68-0.1l5.2-8.57c0.06-0.1,0.08-0.22,0.05-0.33l-4.76-20.12C359.27,464.07,359.17,463.96,359.04,463.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M343.57,502.35c-6.02,1.9-13.2,3.74-21.74,5.45c-0.57,0.11-1.04,0.5-1.27,1.03l-17.36,40.61 c-0.22,0.52-0.18,1.11,0.11,1.6l19.94,32.89c0.33,0.54,0.92,0.86,1.55,0.84c3.61-0.1,16.07-1.07,27.58-9.18 c0.76-0.54,0.96-1.59,0.46-2.37l-18.7-29.14c-0.28-0.44-0.35-0.97-0.2-1.47l11.82-38.06 C346.18,503.19,344.92,501.92,343.57,502.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M371.04,544.9c0.25,0.43,0.9,0.34,1.02-0.15c1.18-5.04,1.93-10.71,2.12-17.09c0,0,0.53-35.64,0.79-44.68 c0.15-5.02-1.71-9.48-5.49-12.65c0,0,6.71,5.88,2.99,13.63c-0.25,0.52-0.34,1.02-0.37,1.19l-7.55,47.69 c-0.08,0.5,0.02,1.01,0.27,1.45L371.04,544.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M370.97,547.44l-7.71-13.2c-0.14-0.25-0.2-0.54-0.15-0.82l6.65-41.99c0.18-1.15-1.19-1.9-2.05-1.12 c-3.66,3.33-9.46,6.77-18.37,10.07c-0.36,0.13-0.64,0.43-0.76,0.79l-12.86,41.4c-0.11,0.35-0.06,0.73,0.14,1.04l18.44,28.74 c0.41,0.64,1.29,0.77,1.86,0.27c6.13-5.36,11.65-13.08,14.94-24.21C371.19,548.09,371.14,547.74,370.97,547.44z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M369.49,470.33c0.25,0.22,6.63,6.02,2.98,13.62c-0.25,0.52-0.34,1.02-0.37,1.19l-3.42,21.63 c3.33,6.31,5.39,13.81,5.43,22.72c0.01-0.15,0.01-0.29,0.02-0.44c0.07-4.3,0.23-13.61,0.39-22.9 c0.16-9.32,0.33-19.03,0.46-23.17c0.06-2.1-0.23-4.1-0.87-5.95c-0.72-1.96-1.96-4.06-3.98-6.13 C369.92,470.7,369.71,470.51,369.49,470.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M369.49,470.33C369.49,470.32,369.49,470.32,369.49,470.33C369.49,470.32,369.49,470.33,369.49,470.33z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M367.7,490.32c-1.86,1.69-4.27,3.41-7.37,5.13c2.73,2.77,5.21,5.9,7.29,9.42l2.13-13.43 C369.93,490.28,368.56,489.53,367.7,490.32z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.9,
    fill: "#C16032",
    points: "269.09,401.66 270.37,381.3 270.36,401.7 272.92,381.46 271.64,401.82 275.46,381.78 272.9,402.02 277.98,382.26 274.15,402.3 280.46,382.9 275.38,402.66 282.89,383.69 276.59,403.09 285.27,384.63 277.76,403.6 287.59,385.72 278.9,404.18 289.84,386.96 280.01,404.84 292,388.33 281.07,405.55 294.07,389.83 282.08,406.34 296.04,391.47 283.04,407.19 297.91,393.22 283.94,408.09 299.66,395.09 284.79,409.05 301.29,397.06 285.57,410.06 302.8,399.13 286.29,411.12 304.17,401.29 286.95,412.23 305.41,403.54 287.53,413.37 306.5,405.85 288.04,414.54 307.44,408.24 288.47,415.75 308.23,410.67 288.83,416.98 308.87,413.15 289.11,418.23 309.35,415.67 289.31,419.49 309.67,418.21 289.43,420.76 309.83,420.76 289.47,422.04 309.83,423.32 289.43,423.32 309.67,425.88 289.31,424.6 309.35,428.42 289.11,425.86 308.87,430.94 288.83,427.11 308.23,433.42 288.47,428.34 307.44,435.85 288.04,429.55 306.5,438.23 287.53,430.72 305.41,440.55 286.95,431.86 304.17,442.79 286.29,432.97 302.8,444.96 285.57,434.02 301.29,447.03 284.79,435.04 299.66,449 283.94,436 297.91,450.87 283.04,436.9 296.04,452.62 282.08,437.75 294.07,454.25 281.07,438.53 292,455.76 280.01,439.25 289.84,457.13 278.9,439.91 287.59,458.37 277.76,440.49 285.27,459.46 276.59,440.99 282.89,460.4 275.38,441.43 280.46,461.19 274.15,441.79 277.98,461.83 272.9,442.07 275.46,462.31 271.64,442.27 272.92,462.63 270.36,442.39 270.37,462.79 269.09,442.43 267.8,462.79 267.81,442.39 265.25,462.63 266.53,442.27 262.71,462.31 265.27,442.07 260.19,461.83 264.02,441.79 257.71,461.19 262.79,441.43 255.28,460.4 261.58,440.99 252.9,459.46 260.41,440.49 250.58,458.37 259.27,439.91 248.33,457.13 258.16,439.25 246.17,455.76 257.1,438.53 244.1,454.25 256.09,437.75 242.13,452.62 255.13,436.9 240.26,450.87 254.23,436 238.51,449 253.38,435.04 236.88,447.03 252.6,434.02 235.37,444.96 251.88,432.97 234,442.79 251.22,431.86 232.76,440.55 250.64,430.72 231.67,438.23 250.13,429.55 230.73,435.85 249.7,428.34 229.94,433.42 249.34,427.11 229.3,430.94 249.06,425.86 228.82,428.42 248.86,424.6 228.5,425.88 248.74,423.32 228.34,423.32 248.7,422.04 228.34,420.76 248.74,420.76 228.5,418.21 248.86,419.49 228.82,415.67 249.06,418.23 229.3,413.15 249.34,416.98 229.94,410.67 249.7,415.75 230.73,408.24 250.13,414.54 231.67,405.85 250.64,413.37 232.76,403.54 251.22,412.23 234,401.29 251.88,411.12 235.37,399.13 252.6,410.06 236.88,397.06 253.38,409.05 238.51,395.09 254.23,408.09 240.26,393.22 255.13,407.19 242.13,391.47 256.09,406.34 244.1,389.83 257.1,405.55 246.17,388.33 258.16,404.84 248.33,386.96 259.27,404.18 250.58,385.72 260.41,403.6 252.9,384.63 261.58,403.09 255.28,383.69 262.79,402.66 257.71,382.9 264.02,402.3 260.19,382.26 265.27,402.02 262.71,381.78 266.53,401.82 265.25,381.46 267.81,401.7 267.8,381.3  "
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M212.12,464.26c1.96,0.03,3.57-1.53,3.6-3.49c0-0.04,0-0.08,0-0.12c-0.02-1.19-0.63-2.24-1.55-2.87 c-0.55-0.37-1.21-0.6-1.93-0.61c-0.9-0.01-1.72,0.31-2.36,0.85c-0.75,0.64-1.23,1.58-1.25,2.64c0,0.23,0.02,0.46,0.06,0.68 C208.97,462.98,210.39,464.23,212.12,464.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M85.01,424.95c0.13-0.01,0.26-0.01,0.39-0.02c0.15-0.12,0.32-0.25,0.5-0.39 C85.53,424.69,85.15,424.79,85.01,424.95z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.9,423.5c0.04,0,0.07,0,0.11,0C95.97,423.51,95.94,423.5,95.9,423.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M91.3,421.43c0.14-0.02,0.27-0.03,0.4-0.04c-0.01,0-0.01,0-0.02,0c-0.91-0.14-1.22,0.09-1.51,0.41 C90.59,421.61,90.97,421.48,91.3,421.43z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95,422.56c0.01,0.01,0.02,0.02,0.03,0.03C95.01,422.58,95.01,422.57,95,422.56z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.38,423.34c0,0.01,0,0.02,0,0.03c0-0.01,0.01-0.02,0.02-0.02C95.39,423.35,95.39,423.35,95.38,423.34 C95.38,423.34,95.38,423.34,95.38,423.34z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M93.99,422.05c0.41,0.09,0.7,0.24,0.9,0.42c-0.29-0.25-0.72-0.47-1.33-0.66 C93.71,421.88,93.85,421.96,93.99,422.05z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M87.11,428.73c0.63-0.11,1.6-0.29,2.57-0.48c0-0.15,0-0.3,0-0.45c-0.03,0-0.05-0.01-0.09-0.01 c-1.35,0.42-2.58,0.82-3.16,1.06C86.44,428.86,86.7,428.81,87.11,428.73z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M87.49,423.37c-0.24,0.14-0.48,0.3-0.7,0.49C87.02,423.7,87.26,423.54,87.49,423.37z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.86,540.68l-0.06-0.01c-0.13-0.49-0.26-0.97-0.37-1.43c-1.54-4.99-2.08-4.36-2.87-3.2l-3.08,4.02 L8.86,540.68L8.86,540.68z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M86.8,427.62c-0.27,0.32-0.43,0.53-0.43,0.53L86.8,427.62z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M93.66,422.75c-0.57,0.21-1.5,1.48-2,4.43c-0.14,0.82-0.25,1.78-0.31,2.89c0.02,0.16,0.05,0.31,0.1,0.45 c-0.04-0.02-0.08-0.04-0.12-0.06c-0.02,0.38-0.03,0.77-0.03,1.18c-0.05,6.23,1.61,11.12,3.15,2.91 C95.99,426.33,95.3,422.15,93.66,422.75z M92.41,431.07C92.41,431.07,92.41,431.07,92.41,431.07l0.03,0 C92.45,431.07,92.43,431.07,92.41,431.07z M92.49,430.92c0.05-0.16,0.09-0.33,0.12-0.5C92.57,430.64,92.53,430.81,92.49,430.92z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.14,422.74c-0.01-0.02-0.02-0.03-0.04-0.05C95.12,422.71,95.13,422.72,95.14,422.74z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M97.97,614.86C97.99,614.86,97.98,614.86,97.97,614.86L97.97,614.86z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M99.66,629.21c0.04,0.01,0.11,0.03,0.2,0.05C99.76,629.23,99.7,629.22,99.66,629.21z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.3,423.04c-0.01-0.02-0.01-0.03-0.02-0.05C95.29,423,95.3,423.02,95.3,423.04z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.8,423.49c-0.02,0-0.05-0.01-0.07-0.02C95.75,423.48,95.78,423.48,95.8,423.49z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.24,422.91c-0.02-0.03-0.03-0.06-0.05-0.09C95.21,422.85,95.23,422.88,95.24,422.91z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M3.16,672.78c0-0.04,0.01-0.09,0.01-0.13C3.17,672.69,3.17,672.73,3.16,672.78z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M28.46,663.88c-6.37-1.62-11.84-3.66-16.37-5.71c0,0,0,0,0,0C15.99,660,21.49,662.15,28.46,663.88z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M6.71,733.7C6.71,733.7,6.71,733.7,6.71,733.7c0.66,8.44,6.61,50.04,7.25,55.5c0,0,0,0,0,0 C13.36,783.01,7.41,741.07,6.71,733.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M3.06,674.02c-0.67,8.16-0.24,16.05,0.57,25C2.66,685.7,2.69,678.89,3.06,674.02z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M60.06,667.08c-7.25,1.43-44.58,9.9-48.96,23.16c-0.02,12.23,0.49,26.62,2.29,40.52 c3.79,29.29,9.93,78.46,10.11,82.18c0,0,0,0,0,0c12.95,8.93,37.43-7.04,59.72-6.11c5.49,0.23,27.9-1,30.26-11.58 c6.29-28.22-3.93-88-12.71-129.81l-32.46,1.05C65.48,666.78,62.73,666.98,60.06,667.08z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M6.45,655.52c-0.07,0.24-0.13,0.47-0.19,0.71c0.11-0.31,0.21-0.54,0.29-0.67 C6.52,655.55,6.48,655.54,6.45,655.52z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M74.32,455.26c-0.13-0.08-0.27-0.17-0.4-0.25C74.05,455.09,74.18,455.17,74.32,455.26z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M77.33,457.18c-0.49-0.31-0.99-0.63-1.5-0.95C76.34,456.55,76.84,456.87,77.33,457.18z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M79.21,458.37c-0.53-0.34-1.08-0.69-1.64-1.05C78.13,457.68,78.67,458.03,79.21,458.37z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M99.46,437.27c-1.38-2.33-1.98-3.19-2.5-4.74c-0.03,0.13-0.05,0.17-0.05,0.17s0.35-1.57,0.06-2.53 c-0.04-0.13-0.24-0.31-0.29-0.45c-0.18-0.5-1.3-1.51-1.38-1.01c-0.2,1.42,0.36,8.76-2.48,10c-2.66,1.15-2.71-5.8-2.49-8.67 c-0.71-0.25-2.13-0.76-2.66-0.9c-0.19-0.12-0.37-0.26-0.56-0.4c-0.41,0.07-0.68,0.12-0.68,0.12c0.59-0.24,1.81-0.65,3.16-1.06 c-0.48-0.06-1.29-0.13-2.62-0.17c-0.2,0.17-0.4,0.34-0.6,0.53c0,0,0.15-0.21,0.43-0.53c-0.25-0.01-0.53-0.01-0.82-0.02 l0.8-2.24c1.4-0.13,2.46-0.32,3.02-0.36c0.07-0.28,0.6-0.44,0.8-0.64c0.98-0.93,1.6-1.97,2.82-1.85 c0.14,0.01,1.51,0.07,1.54,0.1c0.01,0.01,0.02,0.02,0.03,0.03c0.03,0.03,0.06,0.06,0.08,0.1c0.01,0.02,0.03,0.03,0.04,0.05 c0.02,0.03,0.04,0.05,0.05,0.08c0.02,0.03,0.03,0.06,0.05,0.09c0.01,0.03,0.03,0.06,0.04,0.08c0.01,0.02,0.01,0.03,0.02,0.05 c0.05,0.14,0.07,0.25,0.08,0.31c0,0,0,0,0,0c0.01,0,0.01,0.01,0.02,0.01c0.01,0,0.03,0,0.06,0.02 c0.06,0.03,0.32,0.12,0.34,0.12c0.03,0.01,0.17,0.02,0.21,0.02c0.07,0,1.22,0.1,0.92-1.06c0.08-0.79,0.71-1.76,0.75-2.54 c-0.03-1.58,1.62-4.87,0.79-7.79c-0.56-1.97-0.79-6.76-4.35-5.59c0,0,0.01-0.01,0.04-0.01c-0.02-0.04-0.03-0.08-0.05-0.12 c-1.3,1.54-21.49-4.14-21.49-4.14L42,448.51l-0.65,15.71c-3.17,1.5-6.25,2-6.39,2.03c0.05,1.44-0.09,3.19-0.75,4.83 c-0.83,2.07-1.26,2.97-2.98,3.36c0,0,0,0,0.01,0c0.01,0,0.02,0,0.04-0.01c0.04,0.03,0.03,0.03-0.02,0.01 c-2.28,1.15-4.48,1.96-6.03,2.24l3.47,1.82c14.36,12.05,34.51,47.03,34.51,47.03c5.85-9.24,7.79-30.18,8.42-37.22 c0.2-2.22-0.65-3.93-0.65-3.93c0.01,0,0.02,0.01,0.03,0.01c-0.02-0.15-0.04-0.31-0.05-0.49c0.04-1.14-0.18-2.81-0.12-4.29 c0.84-1.59-3.39-11.44,19.88-9.02c5.73-0.16,5.61-3.94,5.07-6.66c-0.55-2.75,0.73-2.89,1.21-4.49 c-2.49-2.28-5.08-5.08-5.41-5.52c0.97-0.64,6.39-2.82,6.6-5.11c0.03,0.03,0.05,0.07,0.08,0.1c-1.22-2.68,1.13-2.76,3.09-3.91 C104.11,443.38,102.68,442.71,99.46,437.27z M95.75,444.33c0.02-0.23,0.05-0.37,0.05-0.37 C95.78,444.09,95.76,444.21,95.75,444.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M31.24,474.44L31.24,474.44c-0.18,0.03-0.36,0.06-0.55,0.08C30.88,474.5,31.06,474.47,31.24,474.44z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M88.01,393.21c-6.49-7.16-15.39-9.33-30.02-7.71c0.14-0.02,0.28-0.04,0.43-0.06c0,0-3.44-0.11-5.99,0.68 c-0.06,0.06-0.12,0.1-0.18,0.14l0.11,0l-1.32,0.24l0.01-0.24c-0.05-0.03-0.11-0.05-0.16-0.09c-0.01-0.01-0.02-0.01-0.03-0.01 c-0.06-0.04-0.14-0.07-0.22-0.09c-1.72-0.08-3.29,0.03-4.73,0.31c-2.04,0.51-4.62,1.56-7.28,3.41 c-0.34,0.24-0.69,0.49-1.03,0.76c-1.36-0.74-3.22-1.28-5.63-1.84c-11.23-2.62-17.53,4.78-19.78,10.78 c-2.16,5.78-1.93,10.92-0.21,14.94c0.74,2.9,1.96,6.15,3.87,9.79c0,0-0.49-2.29-0.89-5.29c2.15,2.23,4.94,3.68,7.99,4.13 c0.1,4.84,0.98,9.29,2.46,12.71c0.15,0.36,0.31,0.7,0.48,1.04c3.36,6.68,5.48,12.84,6.83,17.79c0.71,2.48,1.3,5.01,1.67,7.47 c0.07,0.4,0.13,0.76,0.18,1.11l0,0c0,0,0.34,1.29,0.4,3.06c0.14-0.02,3.21-0.53,6.39-2.03c3.83-1.81,7.8-5.05,6.86-10.62 c-0.28-0.06-0.07-2.62-0.36-2.69c-10.3-2.52-8.68-11.88-8.43-12.03c0.31-6.34,23.95-5.67,23.79,1.19 c-0.02,0.84,1.53,1.25,1.36,2.05c2.21-2.14,5.65-5.11,10.93-9c0.48-0.35,0.95-0.72,1.42-1.1c-3.12,4.29-5.37,8.7-6.08,10.16 c0.73-0.87,2.28-2.63,5.42-6.09c2.6-2.86,4.68-5.75,6.38-8.53c0.53-0.87,1.02-1.72,1.48-2.56c0.03-0.06,0.07-0.12,0.1-0.19 c5.42-6.47,9.01-13.65,9.88-18.41c0.02,0.04,0.03,0.08,0.05,0.12c0.53-0.16,5.97-1.46,2.86,15.33c0,0,0.9-0.56,0.89,1.72 C104.17,409.48,98.99,395.15,88.01,393.21z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M34.97,466.25c0.05,1.44-0.09,3.19-0.75,4.83c-0.84,2.1-1.27,2.99-3.04,3.38c0.03,0,0.06-0.01,0.09-0.01 c0.67,0.47,1.35,1,2.03,1.57c5.19-1.88,7.99-6.57,8.05-11.79C38.18,465.72,35.11,466.23,34.97,466.25z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.41,431.07c0.02,0,0.03,0,0.03,0L92.41,431.07C92.41,431.07,92.41,431.07,92.41,431.07z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.36,430.06c-0.01,0.13-0.02,0.26-0.02,0.39c0.04,0.02,0.08,0.04,0.12,0.06 C91.41,430.37,91.38,430.22,91.36,430.06z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.61,430.42c-0.03,0.17-0.07,0.33-0.12,0.5C92.53,430.81,92.57,430.64,92.61,430.42z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.68,429.13c0.53,0.14,1.19,0.33,1.89,0.58c0.02-0.21,0.04-0.4,0.06-0.56c0.04-0.3,0.06-0.6,0.06-0.89 c-0.97,0.19-1.95,0.37-2.57,0.48C87.3,428.88,87.49,429.01,87.68,429.13z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M86.98,427.62c-0.06,0-0.12,0-0.18-0.01l-0.43,0.53C86.58,427.96,86.78,427.79,86.98,427.62z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M95.8,443.96c0,0-0.03,0.15-0.05,0.37C95.76,444.21,95.78,444.09,95.8,443.96z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#AB7D62",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M95.75,444.33 c0,0.01,0,0.03,0,0.04"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M95.18,453.05c-0.81,0.24-1.47-0.2-2.2-0.19c-0.01,0.03-0.57,0.79-0.57,0.82 c-0.07,0.46,1.26,1.37,2.06,1.79c0.18,0.1,0.3-0.27,0.44-0.2C94.1,454.81,93.86,453.84,95.18,453.05z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M101.2,629.57 c0.01,0,0.02,0.01,0.04,0.01"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M101.4,629.61 c0.02,0,0.04,0.01,0.06,0.01"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M2.75,653.22c-2.99-2.03-6.55-4.63-6.55-4.63S-1.57,650.57,2.75,653.22z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-3.55,646.84c0.04-0.25,0.08-0.52,0.13-0.82C-3.46,646.29-3.5,646.56-3.55,646.84z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-18.35,578.49c0.15-0.59,0.3-1.19,0.44-1.78C-18.04,577.17-18.19,577.79-18.35,578.49z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-15.07,610.41c-0.46,0.21-0.99,0.41-1.61,0.59C-16.09,610.84-15.55,610.65-15.07,610.41z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-16.02,567.47c0,0,0.77-0.8,1.95-2.11C-14.9,566.19-15.6,566.93-16.02,567.47z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-55.5,595.52c-0.15-0.35-0.29-0.71-0.42-1.07C-55.79,594.81-55.65,595.17-55.5,595.52z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-55.48,595.57c2.61,6.17,7.78,11.38,17.18,13.56c4.32,1,8.53,1.8,12.28,2.18 c-6.13-0.7-12.75-2.55-15.83-3.54C-47.06,606.1-52.53,602.33-55.48,595.57z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-12.41,606.59c0.03,0.26,0.09,0.83-0.17,1.5c0.19-0.4,0.33-0.83,0.41-1.31 c-0.06-0.07-0.11-0.14-0.16-0.21C-12.36,606.58-12.39,606.58-12.41,606.59z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#659896",
    points: "8.86,540.68 13.98,541.18 8.86,540.68  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M13.39,730.76c-1.8-13.9-2.32-28.29-2.29-40.52c4.38-13.26,41.71-21.73,48.96-23.16 c-12.19,0.47-22.76-0.96-31.6-3.2c-6.98-1.73-12.47-3.88-16.37-5.71c0,0,0,0,0,0c-2.06-0.94-3.93-1.88-5.6-2.78 c-0.01,0.05-0.02,0.09-0.04,0.14c0.03,0.01,0.07,0.03,0.09,0.04c-0.08,0.13-0.18,0.36-0.29,0.67 c-1.61,5.84-2.58,11.2-3.09,16.42c0,0.04-0.01,0.09-0.01,0.13c-0.04,0.41-0.07,0.83-0.1,1.24c-0.37,4.87-0.4,11.69,0.57,25 c0.77,8.55,1.88,18.06,2.72,29.71c0.12,1.72,0.25,3.37,0.37,4.97c0,0,0,0,0,0c0.7,7.37,6.66,49.32,7.25,55.5c0,0,0,0,0,0 c1.66,14.11,3.06,19.1,3.06,19.1s2.41,1.83,6.48,4.64c0,0,0,0,0,0C23.32,809.22,17.18,760.05,13.39,730.76z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#254354",
    d: "M13.39,730.76c-1.8-13.9-2.32-28.29-2.29-40.52c4.38-13.26,41.71-21.73,48.96-23.16 c-12.19,0.47-22.76-0.96-31.6-3.2c-6.98-1.73-12.47-3.88-16.37-5.71c0,0,0,0,0,0c-2.06-0.94-3.93-1.88-5.6-2.78 c-0.01,0.05-0.02,0.09-0.04,0.14c0.03,0.01,0.07,0.03,0.09,0.04c-0.08,0.13-0.18,0.36-0.29,0.67 c-1.61,5.84-2.58,11.2-3.09,16.42c0,0.04-0.01,0.09-0.01,0.13c-0.04,0.41-0.07,0.83-0.1,1.24c-0.37,4.87-0.4,11.69,0.57,25 c0.77,8.55,1.88,18.06,2.72,29.71c0.12,1.72,0.25,3.37,0.37,4.97c0,0,0,0,0,0c0.7,7.37,6.66,49.32,7.25,55.5c0,0,0,0,0,0 c1.66,14.11,3.06,19.1,3.06,19.1s2.41,1.83,6.48,4.64c0,0,0,0,0,0C23.32,809.22,17.18,760.05,13.39,730.76z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M60.06,667.08c0.19-0.04,0.36-0.07,0.5-0.1c-12.8,0.51-23.56-0.98-32.1-3.1 C37.3,666.12,47.87,667.55,60.06,667.08z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M12.09,658.16c-4.46-7.02-6.04-17.59-6.51-26.15l-4.77-2.27c-1.82,5.7-3.35,11.16-4.22,16.27 c-0.05,0.3-0.09,0.57-0.13,0.82c-0.09,0.59-0.18,1.18-0.26,1.76c0,0,3.57,2.6,6.55,4.63c1.11,0.68,2.35,1.41,3.74,2.16 C8.16,656.29,10.03,657.23,12.09,658.16z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M12.09,658.16c-4.46-7.02-6.04-17.59-6.51-26.15l-4.77-2.27c-1.82,5.7-3.35,11.16-4.22,16.27 c-0.05,0.3-0.09,0.57-0.13,0.82c-0.09,0.59-0.18,1.18-0.26,1.76c0,0,3.57,2.6,6.55,4.63c1.11,0.68,2.35,1.41,3.74,2.16 C8.16,656.29,10.03,657.23,12.09,658.16z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "5.58,632.02 5.58,632.02 0.55,629.62 0.55,629.62 0.81,629.74  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-19.81,583.35c0.01-0.07,0.02-0.15,0.03-0.22C-19.78,583.2-19.79,583.27-19.81,583.35 c0.14-0.1,0.28-0.2,0.44-0.29c0.23-1.22,0.45-2.34,0.52-2.55c-0.01-0.08,0.02-0.23,0.08-0.47c0.14-0.5,0.28-1.02,0.41-1.54 c0.16-0.7,0.31-1.32,0.44-1.78c1.11-4.67,1.89-9.24,1.89-9.24c0.43-0.54,1.12-1.27,1.95-2.11c0.2-0.22,0.41-0.45,0.63-0.69 l-0.27-1.84c-2.19,1.49-4.33,2.45-5.96,1.78c-5.31-2.18-2.58,9.04-2.03,19.1c0.41,0.13,0.72,0.32,0.95,0.55 C-20.5,583.95-20.2,583.64-19.81,583.35z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-19.81,583.35c0.01-0.07,0.02-0.15,0.03-0.22C-19.78,583.2-19.79,583.27-19.81,583.35 c0.14-0.1,0.28-0.2,0.44-0.29c0.23-1.22,0.45-2.34,0.52-2.55c-0.01-0.08,0.02-0.23,0.08-0.47c0.14-0.5,0.28-1.02,0.41-1.54 c0.16-0.7,0.31-1.32,0.44-1.78c1.11-4.67,1.89-9.24,1.89-9.24c0.43-0.54,1.12-1.27,1.95-2.11c0.2-0.22,0.41-0.45,0.63-0.69 l-0.27-1.84c-2.19,1.49-4.33,2.45-5.96,1.78c-5.31-2.18-2.58,9.04-2.03,19.1c0.41,0.13,0.72,0.32,0.95,0.55 C-20.5,583.95-20.2,583.64-19.81,583.35z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "-13.43,564.73 -13.43,564.73 -13.71,562.83 -13.71,562.83 -13.44,564.67  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M119.79,553.13c-7.72-46.29-15.79-53.04-23.36-58.62c0,0-6.01-3.64-25.42-10.12 c-0.01,0-0.02-0.01-0.03-0.01c0,0-0.06,1.35-0.26,3.57c-0.63,7.04-2.66,22.84-8.51,32.08c0,0-14.54-31.98-28.9-44.03 c-0.68-0.57-1.35-1.09-2.03-1.57c-0.03,0-0.06,0.01-0.09,0.01c-0.49,0.11-1.07,0.18-1.79,0.22c0,0,0,0,0,0 c-1.21,0.12-2.54,0.19-3.98,0.25c-1.93,0.07-4.04,0.12-6.26,0.19C7,475.49-8.4,476.72-15.38,488.64 c-9.72,16.6-4.49,15.14-17.95,37.58c-3.46,5.77-6.27,11.04-8.5,15.56c-1.17,1.38-3.05,3.82-5.27,7.59c0,0,0,0,0,0.01 c-3.08,6.18-6.43,18-3.51,25.72c0.09,0.13,0.18,0.33,0.27,0.59c0.04,0.1,0.07,0.21,0.11,0.32c0.31,0.67,0.67,1.31,1.1,1.9 c4.16,5.75,8.41,20.38,12.85,24.7c1.36-0.92,2.58-8.98,3.5-10.28c1.77-5.79,5.03-7.66,6.44-8.13c2.24-0.74,3.69-0.78,4.62-0.48 c-0.55-10.06-3.28-21.28,2.03-19.1c1.63,0.67,5.85,0.1,8.04-1.39l-3.42-20.81c-0.36-2.22-0.59-2.37,0.98-1.73l16.55-0.62 l3.08-4.02c0.8-1.15,1.33-1.78,2.87,3.2c0.14,0.44,0.28,0.91,0.43,1.44l4.98,0.49c0.04,0.49,0.08,0.97,0.14,1.45l10.17,2.95 c1.52,0.62,1.46,1.32,1.53,3.36l11.59,95.03c0.07,2.07-0.99,0.95-2.54,0L3.77,628.41c0.48,8.56,2.87,24.53,7.33,31.55 c4.53,2.06,10.24,4.49,16.61,6.11c8.54,2.12,19.64,2.65,32.85,0.91c-0.15,0.03,0.69,1.9,0.51,1.94c2.67-0.1,4.41-2.14,7.24-2.43 l32.46-1.05l5-0.16c0.45-7.57-7.8-50.42-7.8-50.42c21.25,16.19,25.49-6.06,26.31-12.65 C125.79,590.07,126.93,595.97,119.79,553.13z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M13.98,541.18v1.43c-1.44-12.62,2.58-32.76,1.68-31.25c-1.12,1.87-2.99,14.96-4.49,7.85 c-1.5-7.1-2.62-9.35-2.62-9.35c0,12.71-2.7,18.63-0.12,29.37c0,0,0,0.01,0,0.01c0.14,0.44,0.92,2.74,1.07,3.27L13.98,541.18z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "14.23,541.21 14.23,541.21 13.98,541.18  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-12.41,606.59c-4.35,0.93-8.85-1.1-11.4-4.17c-1.88-2.26-2.6-4.05-2.86-4.91 c-0.73-2.09-0.84-4.22-0.14-6.02c1.71-4.36,3.84-5.1,5.05-5.12c0.02-0.07,0.03-0.15,0.06-0.22c0.03-0.08,0.06-0.16,0.09-0.24 c-0.01-0.72-0.04-1.45-0.08-2.19c-0.93-0.3-2.38-0.26-4.62,0.48c-1.42,0.47-4.67,2.34-6.44,8.13c-0.92,1.3-2.14,9.36-3.5,10.28 c-4.45-4.32-8.7-18.96-12.85-24.7c-0.43-0.59-0.79-1.23-1.1-1.9c-0.04-0.11-0.07-0.22-0.11-0.32c-0.09-0.26-0.18-0.45-0.27-0.59 c-2.92-7.72,0.43-19.54,3.51-25.72c0,0,0,0,0-0.01c-2.33,3.96-5.03,9.38-7.68,16.56c-2.08,5.66-4.94,18.21-1.15,28.52 c0.14,0.36,0.27,0.73,0.42,1.07c0.01,0.02,0.02,0.04,0.02,0.05c2.95,6.76,8.42,10.53,13.63,12.2c3.08,0.99,9.7,2.84,15.83,3.54 c3.69,0.37,6.91,0.34,9.33-0.31c0.62-0.18,1.16-0.37,1.61-0.59c1.13-0.55,1.98-1.31,2.48-2.32 C-12.33,607.41-12.38,606.84-12.41,606.59z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-12.22,606.89c-4.35,0.93-9.08-1.3-11.63-4.36c-1.88-2.26-2.6-4.05-2.86-4.91 c-0.73-2.09-0.84-4.22-0.14-6.02c1.71-4.36,3.84-5.1,5.05-5.12c0.02-0.07,0.03-0.15,0.06-0.22c0.03-0.08,0.06-0.16,0.09-0.24 c-0.01-0.72-0.04-1.45-0.08-2.19c-0.93-0.3-2.38-0.26-4.62,0.48c-1.42,0.47-4.67,2.34-6.44,8.13c-0.92,1.3-2.14,9.36-3.5,10.28 c-4.45-4.32-8.7-18.96-12.85-24.7c-0.43-0.59-0.79-1.23-1.1-1.9c-0.04-0.11-0.07-0.22-0.11-0.32c-0.09-0.26-0.18-0.45-0.27-0.59 c-2.92-7.72,0.43-19.54,3.51-25.72c0,0,0,0,0-0.01c-2.33,3.96-5.03,9.38-7.68,16.56c-2.08,5.66-4.94,18.21-1.15,28.52 c0.14,0.36,0.27,0.73,0.42,1.07c0.01,0.02,0.02,0.04,0.02,0.05c2.95,6.76,8.42,10.53,13.63,12.2c3.08,0.99,9.75,2.73,15.88,3.42 c3.69,0.37,6.82,0.38,9.24-0.28c0.62-0.18,1.18-0.37,1.64-0.58c1.13-0.55,2-1.24,2.5-2.25 C-12.37,607.53-12.19,607.15-12.22,606.89z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-20.74,584.26c-0.23-0.22-0.54-0.42-0.95-0.55c0.04,0.74,0.07,1.47,0.08,2.19 C-21.42,585.39-21.18,584.82-20.74,584.26z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M50.74,387.4l1.39,0c0.08,0,0.16,0.01,0.23,0.03l0-1.18l-0.11,0l-1.2,0l-0.26,0L50.74,387.4z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M53.26,426.2l-0.1-37.72c0-0.51-0.34-0.94-0.8-1.05c-0.07-0.02-0.15-0.03-0.23-0.03l-1.39,0l-0.04,0 c-0.57,0-1.03,0.48-1.03,1.08l-0.19,37.79c0.79-0.13,1.6-0.19,2.43-0.17C52.37,426.11,52.82,426.14,53.26,426.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.4117,
    y1: 393.9371,
    x2: 94.9079,
    y2: 405.1976,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.5156
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.7501
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.9271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M53.26,426.2l-0.1-37.72c0-0.51-0.34-0.94-0.8-1.05c-0.07-0.02-0.15-0.03-0.23-0.03l-1.39,0 l-0.04,0c-0.57,0-1.03,0.48-1.03,1.08l-0.19,37.79c0.79-0.13,1.6-0.19,2.43-0.17C52.37,426.11,52.82,426.14,53.26,426.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M47.85,450.91c0.29,0.07,0.08,2.64,0.36,2.69c3.62,0.73,6.39,0.26,8.51-0.76c0,0,0.01,0,0.01-0.01 c2.17-1.05,3.65-2.68,4.66-4.19c4.21,2.76,14.5,9.51,16.99,10.99c2.08,1.24,3.08,0.78,2.82-0.02 c-0.17-0.09-15.73-10.45-19.12-12.61c-0.27,0.35-18.65-4.18-22.88-6.97C39.02,442.65,39.71,448.92,47.85,450.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M38.34,439.05c0-0.11,0.01-0.22,0.02-0.34c-0.06-0.01-0.1-0.01-0.11-0.01 c-0.25,0.15-1.2,12.2,9.1,14.71c0.29,0.07,0.58,0.13,0.86,0.19c-0.28-0.06-0.07-2.62-0.36-2.69 c-8.14-1.99-8.83-8.26-8.65-10.87C38.65,439.68,38.33,439.34,38.34,439.05z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#41637C",
    cx: 51.56,
    cy: 439.32,
    r: 13.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.3375,
    y1: 439.3568,
    x2: 64.8598,
    y2: 439.3568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M38.34,439.05c-0.06,2.52,0.59,4.89,1.76,6.92c0.32,0.55,0.68,1.08,1.07,1.58 c0.26,0.33,0.54,0.65,0.83,0.96c0.88,0.92,1.89,1.72,3,2.35c0.89,0.51,1.84,0.92,2.84,1.21c1.09,0.32,2.24,0.51,3.44,0.54 c0.25,0.01,0.51,0,0.76-0.01c0.08,0,0.16-0.01,0.24-0.01c0.17-0.01,0.34-0.02,0.51-0.03c0.09-0.01,0.18-0.02,0.27-0.03 c0.16-0.02,0.32-0.04,0.48-0.06c0.09-0.01,0.18-0.03,0.26-0.04c0.17-0.03,0.33-0.06,0.5-0.1c0.07-0.02,0.15-0.03,0.22-0.05 c0.23-0.05,0.47-0.11,0.7-0.18c0,0,0,0,0.01,0c0.24-0.07,0.47-0.14,0.7-0.22c0.05-0.02,0.11-0.04,0.16-0.06 c0.17-0.06,0.35-0.13,0.52-0.2c0.07-0.03,0.13-0.06,0.2-0.08c0.16-0.07,0.32-0.14,0.47-0.21c0.06-0.03,0.13-0.06,0.19-0.09 c0.17-0.08,0.33-0.17,0.49-0.26c0.05-0.03,0.09-0.05,0.14-0.08c0.43-0.24,0.84-0.5,1.24-0.79c0.02-0.01,0.04-0.03,0.06-0.04 c0.17-0.13,0.35-0.26,0.52-0.4c0.04-0.03,0.08-0.06,0.12-0.1c0.15-0.12,0.3-0.25,0.44-0.38c0.04-0.03,0.08-0.07,0.11-0.1 c0.15-0.14,0.3-0.28,0.44-0.43c0.03-0.03,0.05-0.05,0.08-0.08c0.35-0.36,0.67-0.73,0.98-1.12c-2.07-1.32-3.77-2.4-4.84-3.08 c-1.43,1.6-3.52,2.59-5.83,2.53c-4.18-0.1-7.49-3.57-7.39-7.75s3.57-7.49,7.75-7.39c4.18,0.1,7.49,3.57,7.39,7.75 c-0.03,1.1-0.29,2.13-0.73,3.07c1.13,0.76,2.8,1.88,4.77,3.17c0.62-1.13,1.09-2.35,1.36-3.65c0.17-0.79,0.27-1.61,0.29-2.45 c0.16-6.87-4.92-12.64-11.6-13.47c-0.44-0.06-0.89-0.09-1.35-0.1c-0.83-0.02-1.64,0.04-2.43,0.17 c-6.08,0.98-10.82,6.1-11.12,12.44h0C38.35,438.82,38.34,438.93,38.34,439.05z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M58.44,442.6c0.44-0.93,0.71-1.97,0.73-3.07c0.1-4.18-3.21-7.65-7.39-7.75 c-4.18-0.1-7.65,3.21-7.75,7.39s3.21,7.65,7.39,7.75c2.31,0.05,4.4-0.94,5.83-2.53C57.73,443.86,58.13,443.26,58.44,442.6z  M51.52,442.86c-1.93-0.05-3.46-1.65-3.42-3.58c0.05-1.93,1.65-3.46,3.58-3.42c1.93,0.05,3.46,1.65,3.42,3.58 C55.05,441.37,53.45,442.9,51.52,442.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.7776,
    y1: 431.5254,
    x2: 98.6307,
    y2: 431.5254,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M58.44,442.6c0.44-0.93,0.71-1.97,0.73-3.07c0.1-4.18-3.21-7.65-7.39-7.75 c-4.18-0.1-7.65,3.21-7.75,7.39s3.21,7.65,7.39,7.75c2.31,0.05,4.4-0.94,5.83-2.53C57.73,443.86,58.13,443.26,58.44,442.6z  M51.52,442.86c-1.93-0.05-3.46-1.65-3.42-3.58c0.05-1.93,1.65-3.46,3.58-3.42c1.93,0.05,3.46,1.65,3.42,3.58 C55.05,441.37,53.45,442.9,51.52,442.86z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M55.1,439.44c0.05-1.93-1.48-3.53-3.42-3.58c-1.93-0.05-3.53,1.48-3.58,3.42 c-0.05,1.93,1.48,3.53,3.42,3.58C53.45,442.9,55.05,441.37,55.1,439.44z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M80.69,459.32c0.18,0.11,0.35,0.21,0.51,0.3l0,0C81.04,459.53,80.87,459.43,80.69,459.32z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M75.83,456.22c-0.5-0.32-1.01-0.64-1.52-0.97C74.83,455.58,75.33,455.91,75.83,456.22z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M80.69,459.32c-0.47-0.3-0.97-0.62-1.48-0.94C79.72,458.7,80.21,459.01,80.69,459.32z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M77.56,457.32c-0.08-0.05-0.15-0.1-0.23-0.15C77.41,457.23,77.48,457.27,77.56,457.32z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M62.09,447.47L62.09,447.47L62.09,447.47c3.38,2.15,7.73,4.92,11.83,7.53 C69.82,452.39,65.47,449.63,62.09,447.47z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M31,403.98c8.24-17.59,19.59-17.65,19.59-17.65l0.45-0.07c-0.01-0.01-0.18-0.1-0.19-0.1 c-0.06-0.04-0.14-0.07-0.22-0.09c-1.22-0.3-3.29-0.03-4.73,0.31c-2.04,0.51-4.62,1.56-7.28,3.41 C32.25,395.05,31,403.98,31,403.98z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#41637C",
    points: "57.25,444.39 62.09,447.47 63.2,445.77 58.44,442.6  "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M58.44,442.6c-0.31,0.66-0.71,1.26-1.19,1.79c1.06,0.68,2.77,1.76,4.84,3.08l0,0 c3.38,2.15,7.73,4.92,11.83,7.53c0.13,0.08,0.27,0.17,0.4,0.25c0.51,0.33,1.02,0.65,1.52,0.97c0.51,0.32,1.01,0.64,1.5,0.95 c0.08,0.05,0.15,0.1,0.23,0.15c0.56,0.36,1.11,0.71,1.64,1.05c0.51,0.32,1.01,0.64,1.48,0.94c0.18,0.11,0.35,0.21,0.51,0.3l0,0 c3.4,1.89,4.5-0.36,1.67-1.78c-1.63-0.82-2.71-1.57-6.83-3.99c-4.1-2.4-9.01-5.56-12.84-8.08 C61.24,444.48,59.57,443.36,58.44,442.6z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-8.22,604.49c0.02,0.21-0.03-0.07,0.43-0.43l-0.03-0.2C-8.08,604.12-8.23,604.36-8.22,604.49z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-8.84,596.74l-0.03-0.22c-0.17,0.04-0.28,0.06-0.28,0.06C-9.35,596.68-9.21,596.73-8.84,596.74z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-14.07,565.36c-1.18,1.3-1.95,2.11-1.95,2.11c0.13,1.42-0.79,5.37-1.89,9.24c0,0,0,0,0,0 c-0.14,0.6-0.29,1.19-0.44,1.78c-0.33,1.45-0.7,3.22-1.02,4.56c0.32-0.2,0.69-0.39,1.11-0.56c0,0,0.2-0.07,0.55-0.19 c1.09-1.05,5.05-4.83,6-5.31l0.08,0.35l-0.42-2.94l0.01-0.01l-0.67-4.63l-0.73-5.03C-13.65,564.95-13.86,565.16-14.07,565.36 C-14.07,565.36-14.07,565.36-14.07,565.36z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-10.11,587.84l-0.01-0.04c-0.25,0.15-0.64,0.37-1.25,0.7C-10.56,588.06-10.24,587.9-10.11,587.84z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M-6.07,602.02c-0.91,0.2-1.34,1.46-1.75,1.85l0.03,0.2c0.3-0.24,1.38,0.54,2.28,0.34 c2.27-0.51,6.98-1.67,8.73-2.04c1.75-0.38,7.12-3.85,7.12-3.85l-0.16-0.08c0,0-4.79,0.04-7.15,0.88 C0.68,600.15-4.55,601.68-6.07,602.02z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M5.58,632.02L5.58,632.02l31.31,14.92c1.54,0.95,2.82-0.01,2.75-2.08l-9.72-97.48 c-0.07-2.04-1.41-4.3-2.92-4.92l-12.76-1.25l0,0l-0.25-0.02l-5.11-0.5l-6.39-0.62l-17.02-1.66c-1.57-0.64-2.63,0.75-2.27,2.96 l3.11,21.47l0,0l0.28,1.91l0,0l0.73,5.03l0.67,4.63l-0.01,0.01l0.42,2.94l0.26,3.98c3.14-1.11,7.24-2.53,9-3.17 c3.3-1.2,5.7-1.56,7.18,0c0.82,0.69,1.1,1.25,0.38,1.69c-0.01,0-0.72,0.63-0.73,0.63c-1.15,1.39-3.63,1.05-6.49,2.38 c-3.75,1.74-8.1,3.06-8.1,3.06s-0.33,1.74-0.63,1.91l0,0c0.08-0.03-0.42,0-0.42,0l0.27,0.42c0.01,0,0.33,0.11,0.33,0.11 l0.25,1.71c0.31-0.01,1.11,1.01,1.47,0.99c0,0,9.95-1.43,14.72-2.14c3.94-0.59,5.58-1.33,6.64-0.21 c1.06,0.76,0.96,1.69,0.04,2.01c-0.2,0.07-0.29,0.23-0.54,0.31c-1.06,0.71-2.27,0.62-4.1,0.99c-2.42,0.49-10.23,1.63-14.79,2.63 c-1.02,0.22-1.14,0.82-1.68,0.94c-0.14,0.03-0.97,0.92-1.07,0.94l0.19,0.56c0.1,0,0.89,0.16,1.03,0.15 c1.42-0.03,4.55-0.19,6.6-0.6c2.96-0.6,12.98-3.59,15.48-3.56c1.17,0.02,1.4,1.03,1.51,1.95c0.5,0.77,0,1.18-0.66,1.5 c-0.47,0.23-0.23-0.17-0.85,0.06c-0.06,0.03-0.96,0.51-1.01,0.54c-1.64,0.7-3.51,1.59-3.51,1.59s1.04,0.19,1.43,0.85 c0.56,0.5,1.05,0.88,0.58,1.25c-0.22,0.17-0.54,0.26-0.82,0.46c-0.56,0.45-1.68,0.83-2.89,1.5c-2.35,1.31-4.96,1.51-7.2,2.49 c-1.81,0.79-4.92,1.36-7.18,1.81c-0.15,0.03-0.4,0.05-0.53,0.08l1.13,7.09l0.05-0.01l1.44,9.98c0.27,1.66,1.27,3.31,2.45,4.04 l2.93,1.4l0,0L5.58,632.02z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M-10.84,589.57c0.3,0.01,0.66,0,1.06-0.01l-0.19-1.33c0,0,0,0-0.02,0l0.18,1.29 C-10.19,589.55-10.53,589.56-10.84,589.57z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M0.68,605.99c2.24-0.99,5.12-1.59,7.47-2.9c1.21-0.67,2.09-1.11,2.65-1.55c0.11-0.08,2.06-0.76,0.65-2.3 c-0.39-0.65-1.26-0.81-1.26-0.81l0.16,0.08c0,0-6.43,2.48-8.18,2.86c-1.75,0.38-5.96,1.47-8.23,1.98 c-0.9,0.2-1.42,0.47-1.72,0.71c-0.46,0.36-0.42,0.64-0.43,0.43c-0.01-0.14,0.14-0.37,0.41-0.63c0.41-0.38,1.1-0.81,2.01-1.01 c1.52-0.34,6.88-1.57,9.24-2.41c2.36-0.84,6.75-2.02,6.75-2.02s1.91-0.42,3.58-1.05c3.49-1.3,1.98-2.18,2.1-2.98 c0.13-0.8-0.81-1.66-1.98-1.67c-2.49-0.03-12.86,2.63-15.82,3.23c-2.05,0.41-5.13,0.74-6.55,0.77c-0.14,0-0.25,0-0.36,0 c-0.37-0.01-0.52-0.06-0.31-0.16c0,0,0.1-0.02,0.28-0.06c0.1-0.02,0.21-0.05,0.34-0.08c0.54-0.12,1.4-0.31,2.42-0.54 c4.56-1,12.23-2.63,14.65-3.11c1.83-0.37,3.52-0.89,4.59-1.59c2.22-1.18,0.56-2.69,0.55-3.04c-0.81-1.04-3.45-1.16-7.39-0.56 c-4.77,0.72-15.06,1.93-15.06,1.93c-0.36,0.02-0.69,0.03-1,0.04c-0.4,0.01-0.76,0.01-1.06,0.01c-2.23,0.06-2.08-0.21-0.53-1.07 c0.6-0.34,0.99-0.56,1.25-0.7c0.3-0.17,0.4-0.24,0.4-0.24s4.42-2.31,8.17-4.05c2.86-1.33,6.32-2.15,7.46-3.54 c0.95-0.55,0.23-2.27-0.25-2.45c-1.48-1.56-5.12-1.75-8.41-0.55c-1.76,0.64-5.12,1.84-8.26,2.95l-0.62-2.59l-0.08-0.35 c-0.96,0.48-4.91,4.26-6,5.31c-0.35,0.12-0.55,0.19-0.55,0.19c-0.43,0.17-0.79,0.36-1.11,0.56c0,0,0,0,0,0 c-0.15,0.1-0.3,0.19-0.43,0.29c0,0,0,0,0,0c-0.39,0.29-0.7,0.6-0.94,0.91c-0.44,0.56-0.67,1.13-0.87,1.64 c-0.03,0.08-0.06,0.16-0.09,0.24c-0.03,0.07-0.04,0.15-0.06,0.22c-1.21,0.02-3.34,0.76-5.05,5.12c-0.7,1.8-0.59,3.93,0.14,6.02 c-0.11-0.36-0.14-0.56-0.14-0.56s0.8,4.69,6.06,8.08c5.25,3.37,8.5,1.66,8.41,1.54c-0.03-0.04-0.03-0.04,0,0 c0.05,0.07,0.1,0.14,0.16,0.21c0.81,1,2.27,1.82,4.01,1.59c0.27-0.04,0.61-0.09,0.98-0.16c0.14-0.03,0.28-0.05,0.42-0.08 C-4.51,607.67-1.13,606.79,0.68,605.99z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M-10.84,589.57c0.3-0.01,0.65-0.02,1.04-0.04l-0.18-1.29l-0.06-0.42c0,0,0-0.01-0.08,0.03 c-0.12,0.05-0.44,0.21-1.25,0.66C-12.91,589.36-13.07,589.63-10.84,589.57z"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M93.29,607.65L77.18,578.9c2.15-0.13,5.91-0.88,6.16-1.05c0.85-0.47,1.9-0.57,2.66-1.21 c3.2-2.72,0.76-3.42,0.76-3.42s5.81-0.84,2.61-3.93c-3.2-3.09-6.23-6.11-9.07-8.48c-2.83-2.37-4.62-3.66-5.68-5.07 c-1.06-1.41-2.08-3.48-4.35-3.11c0,0-0.46-0.95-1.48-1.63c-1.02-0.68-2.82-0.74-4.32,0.16c-1.5,0.9-6.66,3.65-9.7,4.88 c-3.04,1.24-4.37,2.29-6.41,3.72c-2.05,1.42-4.19,2.45-6.44,3.31c-1.15,0.44-2.47,0.83-3.4,1.33c-0.76,0.35-1.32,0.74-1.22,1.21 c0.01,0.07,0.03,0.14,0.05,0.21c0,0.14,0.02,0.29,0.09,0.45c0,0,1.02,3.76,5.8,2.18c3.04-1,10.35-4.09,10.35-4.09l0.07,0.77 c0-0.01,0.01-0.02,0.01-0.03c-0.03,0.13-0.06,0.26-0.09,0.41c-0.19,0.91,0.09,1.84,0.73,2.82c0,0-1.43,0.82-2.27,1.85 c-0.43,0.53-0.64,1.47-0.52,2.35c0,0.08,0.01,0.16,0.01,0.25c0.23,2.2,2.07,1.99,3.37,2.72c1.3,0.73,2.91,1.79,4.03,2.13 c0.97,0.29,1.64-0.59,2.03-1.6c0.24,0.13,0.46,0.23,0.65,0.32c0,0.01-0.01,0.01-0.01,0.02l0.47,0.18 c0.14,0.06,0.23,0.08,0.23,0.08s-0.65,1.43,1.21,2.55c1.86,1.12,3.63,1.92,4.53,1.95c0.9,0.03,2.56-1.04,2.56-1.04 s1.24-0.95,2.97-1.27c1.35,0.95,8.63,12.65,12.1,17.83C91.19,604.89,93.29,607.65,93.29,607.65z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M59.82,561.75c0.7-0.47,2.37-1.83,4.13-2.95c1.22-0.78,2.58-1.36,3.08-1.74 c1.21-0.91,2.33-4.04,1.59-3.66c-0.74,0.38-1.16-0.23-1.01-0.56c0,0-1.92,1-3.86,2.29s-4.26,3.04-5.5,3.71 c-1.2,0.66-3.27,1.8-4.55,0.34c-0.05-0.08-0.09-0.15-0.13-0.23c-0.61,0.54-1.44,1.33-1.76,1.95c-0.31,0.59-1.59-0.4-1.83,1.46 c-0.01,0.08-0.02,0.16-0.03,0.25c-0.15,2.2,1.71,2.31,2.86,3.24c1.16,0.94,2.57,2.25,3.62,2.77c0.91,0.45,1.72-0.31,2.27-1.23 C58.08,566.93,58.63,562.54,59.82,561.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M43.64,555.82c2.43-0.44,7.87-1.19,10.28-1.96s8-4.36,9.41-5.08c1.42-0.71,2.37-0.95,1.56-0.41 c-0.82,0.55-1.74,1.02-5.01,2.69c-3.23,1.65-5.94,3.47-6.54,4.34c-0.05,0.12-0.11,0.25-0.16,0.39c-0.34,0.87-0.22,1.82,0.25,2.9 c0,0-1.54,0.57-2.54,1.44c-0.51,0.45-0.88,1.34-0.91,2.22c0.24-1.85,1.52-0.86,1.83-1.46c0.32-0.61,1.15-1.41,1.76-1.95 c0.04,0.08,0.09,0.15,0.13,0.23c1.28,1.45,3.19,1.28,4.39,0.62c1.24-0.67,4.15-2.32,6.1-3.62c1.95-1.29,2.85-2.59,2.85-2.59 c-0.15,0.33-0.45,0.88,0.29,0.5c0.74-0.38-0.1,0.34-1.3,1.25c-0.49,0.37-1.6,1.1-2.82,1.88c-1.76,1.12-3.74,2.36-4.44,2.83 c-1.19,0.8-1.81,1.01-2.52,2.53c0,0,0-0.01,0-0.02c-0.12,0.39-0.21,0.94-0.09,1.56c-0.54-0.91-1.1-1.25-1.72-0.71 c-0.72,0.63-0.72,2.58,0.07,3.22c0.8,0.63,1.16,1.82,1.73,1.55c0.53-0.24,0.73-1.67,0.43-2.87c0.02,0.03,0.03,0.05,0.05,0.08 c0.61,0.85,1.37,1.53,1.99,2.01c0.22,0.17,0.42,0.31,0.59,0.43c0.9-1.17,3.38-2.22,5.66-3.47c2.29-1.25,3.66-3.08,3.66-3.08 c-0.57,1.97-3.04,3.32-4.9,4.33c-1.86,1.01-3.36,2.01-3.79,2.61c0,0-0.88,1.3,0.76,2.71c1.65,1.42,3.25,2.5,4.14,2.68 c0.88,0.18,2.7-0.6,2.7-0.6s0.37-0.14,0.6-0.63s0.91-0.37,0.91-0.37s0.4,1.32,1.48-1.05c0,0,0.59,1.47,2.09,1.58 c1.5,0.11,2.31-0.77,2.95-1.34c0.64-0.57,0.83,2.93,3.51,4.39c2.68,1.46,4.43,2.53,4.43,2.53s-0.01,0.01-0.04,0.02 c0.92-0.32,1.84-0.73,2.7-1.23c3.61-2.14,5.35-5.88,5.35-5.88s-1.02-1.93-3.66-5.52c-2.64-3.58-5.12-7.06-7.52-9.88 c-2.4-2.81-3.94-4.38-4.75-5.95c-0.81-1.57-1.47-3.78-3.76-3.79c0,0-0.3-1.02-1.19-1.86c-0.89-0.84-2.66-1.2-4.29-0.56 c-1.63,0.64-7.18,2.48-10.38,3.19c-3.2,0.71-4.69,1.53-6.94,2.59c-2.25,1.06-4.55,1.71-6.9,2.18c-1.21,0.24-2.57,0.41-3.57,0.74 c0.33-0.09-1.31,1.84-1.39,1.2c-0.02,0.14-0.02,0.29,0.01,0.46C38.16,556.53,42.13,556.1,43.64,555.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M59.93,568.22l-0.21-0.12C59.85,568.18,59.93,568.22,59.93,568.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M79.45,574.46c-2.68-1.46-2.28-5.54-2.93-4.97c-0.64,0.57-2.74,2.13-4.23,2.02 c-1.5-0.11-1.88-2.36-1.88-2.36c-1.08,2.38-3.38,3.22-3.38,3.22s1.33-0.49,1.1,0.01s-0.6,0.63-0.6,0.63s2.42,1.02,4.39,1.23 c1.28,0.13,2.22,1.02,3.25,2.24c1.03,1.22,2.1,2.56,2.1,2.56c3.2,0.41,5.85-0.74,6.19-0.9c0.02-0.01,0.04-0.02,0.04-0.02 S82.13,575.93,79.45,574.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M63.71,565.61c1.86-1.01,4.33-2.36,4.9-4.33c0,0-1.37,1.82-3.66,3.08c-2.28,1.25-4.76,2.3-5.66,3.47 c0,0.01-0.01,0.01-0.01,0.02l0.44,0.25l0.21,0.12C60.35,567.62,61.86,566.63,63.71,565.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M42.49,556.96c3.16-0.48,10.89-2.3,10.89-2.3l-0.06,0.77c0.01-0.01,0.01-0.02,0.02-0.03 c0.6-0.88,3.3-2.69,6.54-4.34c3.27-1.67,4.19-2.14,5.01-2.69c0.82-0.55-0.14-0.31-1.56,0.41c-1.42,0.71-7.51,3.75-9.92,4.52 s-7.36,1.56-9.79,2c-1.51,0.27-5.47,1.22-6.49-1.47C37.14,553.84,37.51,557.72,42.49,556.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M38.85,554.64c1.45-0.01,3.24-0.92,2.83-1.95c-0.41-1.03-0.86-1.14-2.11-0.88 c-0.36,0.08-0.72,0.16-1.05,0.25c-0.81,0.22-1.43,0.51-1.41,0.99c0,0.07,0.01,0.14,0.02,0.21 C37.21,553.9,37.54,554.65,38.85,554.64z"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M89.07,567.14c0,0,4.96-0.79,2.54,4.06L89.07,567.14z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M99.63,445.33c1.04,0,1.56-0.72,1.08-0.76c-1.4-0.12-2.44,0.28-2.92,0.84 C97.31,445.97,98.59,445.33,99.63,445.33z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M98.21,446.37c-1.01,0.11-2.58-0.12-2.46-1.99C95.67,445.36,95.72,447.64,98.21,446.37z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M91.53,452.66c0.02-0.34,0.14-0.7,0.24-1.02c0.53-1.73,2.51-5.35,2.51-5.35 c0.02-0.14-3.75,5.86-4.83,10.19c-0.86,3.47,0.44-1.08,1.51-2.16c0.02,0.01,0.03,0.02,0.04,0.03c0,0,2.66,3.75,5.98,5.11 c0,0,1.55-1.34-0.45-2.91c-0.69-0.54-0.84-0.71-2.05-1.54c-0.79-0.42-1.8-1.06-1.73-1.52c0-0.03-0.01,0.03,0,0 c0.73-0.01,1.61-0.2,2.42-0.43c0.29-0.08,0.57-0.18,0.84-0.3c0,0,4.05-1.43,2.23-3.82c-0.03-0.03-0.05-0.07-0.08-0.1 C98.17,448.75,94.71,451.48,91.53,452.66z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M73.86,468.2c-7.88-2.63-10.16-3.88-12.22-8.33c0,0,3.27,6.96,5.44,10.84c2.17,3.88,3.78,6.8,3.67,10.91 c0,0,2.23-9.63,7.07-9.98c6.93-0.51,13.31-0.98,13.31-0.98c-0.14-0.02-0.28-0.03-0.42-0.05 C84.53,469.88,81.57,470.77,73.86,468.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M86.07,429.25c-0.4,0.16-0.84,0.68-1.68,0.72C84.4,429.97,85.78,430.35,86.07,429.25z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M85.2,429.22c0.51-0.25,0.59-0.37,0.59-0.37c-0.92,0.12-1.44-0.08-1.6-0.2 C84.04,428.53,84.48,429.57,85.2,429.22z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M86.8,427.62"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.19,426.34v0.06C95.22,426.37,95.22,426.35,95.19,426.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M91.68,427.07c-0.01,0.04-0.01,0.07-0.02,0.11c0,0,0,0,0,0l0,0C91.67,427.13,91.68,427.1,91.68,427.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M93.99,422.05c-0.57-0.5-2.86,3.75-2.84,4.65c0,0-1.46,2.65-1.46,3.81c0,0.1-0.19,0.47-0.18,0.55 c-1.25,0.04-0.86,1.28-0.88,1.44c-0.77,6.23,4.92,10.97,7.25,2.29C98.05,426.72,95.3,423.2,93.99,422.05z M95.19,426.34 c0.03,0.01,0.04,0.03,0,0.06V426.34z"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M89.68,427.95c0-0.03,0-0.08,0-0.15c0,0-0.04-0.01-0.09-0.01c-1.39,0-2.81,0.89-3.38,1.12 c0,0,0.26-0.05,0.68-0.12c0.63-0.11,1.82-0.35,2.79-0.54C89.69,428.1,89.69,428.1,89.68,427.95z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M89.68,427.8c-0.03,0-0.05-0.01-0.09-0.01c-1.35,0.42-2.58,0.82-3.16,1.06c0,0,0.26-0.05,0.68-0.12 c0.63-0.11,1.6-0.29,2.57-0.48C89.69,428.1,89.69,427.95,89.68,427.8z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M92.91,419.53c-2.92-0.58-5.26,2.34-7.01,4.38c-0.37,0.43-0.66,0.77-0.89,1.04 c0.13-0.01,0.26-0.01,0.39-0.02c1.59-1.26,4.33-3.27,5.9-3.5c1.1-0.16,2,0.17,2.68,0.62c0.41,0.09,0.61,0.48,0.81,0.67 c0.41,0.39,0.51,0.66,0.52,0.76c0-0.03,0.1-0.13,0.15-0.1C95.96,422.52,95.71,420.09,92.91,419.53z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M96.26,430.34c0.02-0.02,0.04-0.03,0.06-0.05c-0.04-0.12-0.07-0.23-0.11-0.33 c-0.13,0.15-0.24,0.28-0.34,0.4C96.01,430.36,96.13,430.35,96.26,430.34z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M97.02,421.85c3.11-16.79-2.33-15.5-2.86-15.33c-0.03,0.01-0.04,0.01-0.04,0.01 c2.43,5.62,2.88,10.89,2.93,13.53c-0.04,0.78-0.11,1.57-0.19,2.36c-0.14,0.43-0.36,0.95-0.65,1.04c-0.07,0.02-0.14,0.03-0.2,0.03 c-0.04,0-0.07,0-0.11,0c-0.03,0-0.07-0.01-0.1-0.01c-0.03-0.01-0.05-0.01-0.07-0.02c-0.12-0.03-0.21-0.08-0.27-0.1 c-0.03-0.01-0.05-0.02-0.06-0.02c-0.01,0-0.02,0-0.02,0.02c0-0.01,0-0.02,0-0.03c-0.01-0.06-0.02-0.17-0.08-0.31 c-0.01-0.02-0.01-0.03-0.02-0.05c-0.01-0.03-0.02-0.05-0.04-0.08c-0.01-0.03-0.03-0.06-0.05-0.09c-0.02-0.03-0.03-0.05-0.05-0.08 c-0.01-0.02-0.14-0.16-0.14-0.17c-0.03-0.03-0.07-0.07-0.11-0.1c-0.2-0.17-0.49-0.33-0.9-0.42c-0.12-0.03-0.25-0.05-0.39-0.06 c-1.22-0.12-2.57,1.06-3.55,1.99c-0.21,0.2-0.33,0.44-0.4,0.72c-0.72,0.04-2.24,0.12-4.25,0.24c-0.13,0.01-0.26,0.01-0.39,0.02 c-0.29,0.02-0.58,0.03-0.88,0.05c-0.46,0.84-0.95,1.7-1.48,2.56c0.93,0,1.89,0.01,2.88,0.02c0.47,0.01,0.89,0.01,1.28,0.03 c0.06,0,0.12,0,0.18,0.01c1.33,0.04,2.15,0.11,2.62,0.17c0.03,0,0.06,0.01,0.09,0.01c0,0.15,0,0.3,0,0.45 c-0.01,0.29-0.02,0.59-0.06,0.89c-0.02,0.16-0.04,0.35-0.06,0.56c-0.23,2.87-0.07,10.13,2.78,9.64c3.07-0.53,3.25-8.19,3.45-9.61 c0.07-0.5,0.23-0.28,0.41,0.23c0.04,0.1,0.07,0.21,0.11,0.33c0.29,0.96,0.59,2.4,0.59,2.4s0.02-0.04,0.05-0.17 c0.08-0.31,0.25-1.14,0.46-3.08c0.03-0.31,0.07-0.66,0.11-1.03c0.11-1.07,0.22-2.39,0.35-4.03c0.02-0.31,0.03-0.58,0.03-0.82 C97.92,421.29,97.02,421.85,97.02,421.85z M94.46,434.55c-1.54,8.22-3.2,3.33-3.15-2.91c0-0.41,0.01-0.8,0.03-1.18 c0.01-0.14,0.01-0.26,0.02-0.39c0.06-1.1,0.16-2.06,0.31-2.89c0.5-2.96,1.43-4.22,2-4.43C95.3,422.15,95.99,426.33,94.46,434.55z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M92.41,431.07l0.04,0c0,0,0.02-0.06,0.05-0.15c0.03-0.11,0.08-0.28,0.12-0.5 c0.13-0.67,0.24-1.74-0.13-2.76c0,0,1.3-0.43,2.59-1.19c0.68-0.39-1.2,0.06-3.42,0.7c-0.14,0.82-0.25,1.78-0.31,2.89 c0.02,0.16,0.05,0.31,0.1,0.45C91.78,430.68,92.1,430.87,92.41,431.07z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CFBEB0",
    points: "63.2,445.77 83.28,458.07 85.01,459.11 84.4,460.25 82.98,460.41 81.2,459.62 62.09,447.47 "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M58.44,442.6c-0.31,0.66-0.71,1.26-1.19,1.79c1.06,0.68,2.77,1.76,4.84,3.08l0,0 c3.38,2.15,7.73,4.92,11.83,7.53c0.13,0.08,0.27,0.17,0.4,0.25c0.51,0.33,1.02,0.65,1.52,0.97c0.51,0.32,1.01,0.64,1.5,0.95 c0.08,0.05,0.15,0.1,0.23,0.15c0.56,0.36,1.11,0.71,1.64,1.05c0.51,0.32,1.01,0.64,1.48,0.94c0.18,0.11,0.35,0.21,0.51,0.3l0,0 c3.4,1.89,4.5-0.36,1.67-1.78c-1.63-0.82-2.71-1.57-6.83-3.99c-4.1-2.4-9.01-5.56-12.84-8.08 C61.24,444.48,59.57,443.36,58.44,442.6z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M32.72,454.6c0.71,2.48,1.3,5.01,1.67,7.47c0.07,0.4,0.13,0.76,0.18,1.11l0,0c0,0,0.34,1.29,0.4,3.06 c0.14-0.02,3.21-0.53,6.39-2.03c0-0.33,0-0.67-0.02-1.01c-0.48-8.72-11.82-21.58-15.92-27.44c0.15,0.36,0.31,0.7,0.48,1.04 C29.25,443.48,31.38,449.65,32.72,454.6z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M31.18,474.45c-0.39,0.09-0.85,0.15-1.4,0.19c-0.12,0.01-0.26,0.02-0.4,0.03c-1,0.1-2.09,0.16-3.26,0.21 c-0.25,0.02-0.49,0.03-0.71,0.03c-0.01,0-0.01,0-0.02,0c-1.93,0.07-4.04,0.12-6.26,0.19c0,0,0,0,0,0 c5.79,2.16,10.55,2.21,14.15,0.9c-0.68-0.57-1.35-1.09-2.03-1.57C31.25,474.44,31.21,474.45,31.18,474.45z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M3.98,577.14c-0.97,0.21-1.73,0.47-2.26,0.7c-0.52,0.22-0.73,0.84-0.45,1.34 c0.37,0.65,0.86,1.49,1.12,1.91c0.46,0.73,2.44-0.46,3.52-1.11c0.01,0,0.01-0.01,0.02-0.01c0.72-0.43,0.54-1.74-0.27-2.43 C5.25,577.18,4.68,576.99,3.98,577.14z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M9.56,588.85c-0.21,0.71,0.26,1.65,0.55,2.46c0.24,0.67,1.81,0.27,3.02-0.12 c0.25-0.08,0.48-0.16,0.69-0.23c0.93-0.32,1.04-2.06-0.14-2.81c-0.31-0.2-0.69-0.35-1.17-0.35 C10.36,587.79,9.77,588.14,9.56,588.85z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M13.98,593.56c-2.14,0.26-2.67,0.67-2.8,1.4c-0.12,0.73,0.46,1.61,0.84,2.38 c0.23,0.45,1.04,0.29,1.9-0.03c0.62-0.23,1.26-0.54,1.73-0.76c0.66-0.32,0.7-1.37,0.2-2.14 C15.51,593.86,14.87,593.45,13.98,593.56z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M9.83,598.95c-1.59,0.53-1.93,0.94-1.91,1.51c0.02,0.57,0.6,1.15,1.02,1.68c0.3,0.38,1.13-0.09,1.86-0.6 c0.29-0.2,0.56-0.41,0.78-0.58c0.47-0.36,0.31-1.22-0.25-1.72C10.97,598.92,10.45,598.75,9.83,598.95z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M-12.22,607.03c0.02-0.01,0.08-0.21,0.05-0.25c-0.74-1.14-2.11-2.07-3.17-3.4 c-1.06-1.33-0.84-2.98-1.62-3.63c-0.5-0.41-1.08-1.04-1.49-1.87c-1.46-0.56-3.33-1.01-5.15-0.68c-2.58,0.47-3,0.27-3,0.27 s0.03,0.2,0.14,0.56c0.26,0.86,0.98,2.65,2.86,4.91C-21.05,606-14.89,608.16-12.22,607.03z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M39.57,551.93c-0.36,0.08-0.72,0.16-1.05,0.25c-0.81,0.22-1.43,0.51-1.41,0.99"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "223.03,573.64 223.03,573.64 223.03,573.64  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M163.87,529.9c0,0,0.01,0.02,0.04,0.06c-0.01-0.03-0.02-0.06-0.04-0.1 C163.87,529.89,163.87,529.9,163.87,529.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M228.93,598.54c-0.65,0.39-1.49,0.84-2.16,1.26C227.52,599.39,228.25,599.03,228.93,598.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M224.71,563.29c-0.18,0.55-2.98,3.14-2.98,3.14c-3.12,3.44-3.7,6.54-4.9,12.33 c-1.21,5.79-3.78,9.39-2,13.01s1.57,4.61-2.88,6.26c-1.98,0.73-3.32,3.09-4.59,4.15c1.4,1.36,2.87,2.91,4.11,4.47 c0.4-0.23,1.57-0.31,2.08-0.6c4.24-2.38,10.36-5.67,13.59-7.28c3.22-1.61,2.75-2.63,5.38-5.09c2.63-2.46,3.37-3.94,4.01-4.32 c0.64-0.38,0.44-3,0.65-3.77c0.21-0.76,0,0,0.21-0.76l1.15-2.38c0,0-0.03,0.08-0.09,0.22c0.07-0.16,0.14-0.31,0.2-0.46 c0.38-0.84-1.52-3.05-3.81-0.23c-2.29,2.82-2.21,4.34-3.5,5.33c-1.3,0.99-3.28,2.74-3.73,3.12c-0.24,0.2-1.43,0.46-2.82,0.76 c-0.31-0.15-1.55-0.73-2.67-0.8c-0.65-0.04-1.36,0.03-1.84-1.2c-0.18-0.42-0.25-0.94-0.14-1.55c0.3-1.68-0.38-4.8,0.61-7.47 c0.06-0.17,0.12-0.34,0.18-0.52c0.05,0.03,2.01,0.25,2.07,0.28c-0.05-0.05-0.63-0.69-0.63-0.69l-0.42-1.11l0,0l1.05-1.51 c0,0,0.9,0.05,1.83,0.31c0.93,0.25,1.45,1.36,2.34,1.79c0.89,0.42,1.73-0.37,1.73-0.37s-0.04,0.21-0.16,0.45 c0.18-0.29,0.22-0.61,0.09-0.82c-0.34-0.52-1.09-1.31-1.75-1.75c-0.66-0.44-1.16-1.44-2.16-1.94c-0.63-0.32-1.13-0.56-1.77-0.68 c-0.05,0.01-0.1,0.01-0.15,0.02c0,0,0.01-0.01,0.02-0.04c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.35,1.4-2.08,1.8-2.83 c0,0.93,0.83,0.99,1.5,1.35c1.42,0.74,3.87,1.17,4.06-0.22c0,0,0,0.03-0.02,0.09c0.57-1.31-0.85-1.85-1.68-2.01 c-0.89-0.17-1-1.05-1.99-1.16c-0.28-0.03-0.55-0.08-0.88-0.13c0.29-0.44,0.6-0.85,0.95-1.24c1.3-1.45,3.77-5.48,1.75-6.55 c-1.3-0.69-2.97,1.14-3.58,1.68C224.3,563.7,224.93,562.6,224.71,563.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M204.75,596.66c-0.28,0.62-0.71,1.37-1.12,2.05c0.02,0.02,0.05,0.04,0.07,0.06 C204.07,598.16,204.45,597.43,204.75,596.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M216.48,571.09c1.25-0.61,1.71-0.94,2.29-2.81c-0.75,0.16-1.32,0.46-1.78,0.84 C215.47,571.02,215.72,571.91,216.48,571.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M225.99,578.99c-1.19-0.66-2.32-1.64-2.32-1.64S224.75,578.34,225.99,578.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M224.62,580.08c0,0-0.01,0.19-0.12,0.38c0.22-0.27,0.3-0.6,0.21-0.75c-0.19-0.34-1.05-1.16-1.61-1.65 c-0.18-0.15-0.37-0.31-0.57-0.45l-0.18,0.04C223.11,578.45,224.41,579.84,224.62,580.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M222.99,580.75c0.35,0.14,0.64,0.15,0.89,0.09C223.66,580.88,223.37,580.86,222.99,580.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M217.12,568.92c0.02-0.02,0.04-0.04,0.06-0.06C217.18,568.86,217.15,568.88,217.12,568.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M217.08,568.96c0.01-0.02,0.03-0.03,0.04-0.04C217.11,568.94,217.09,568.95,217.08,568.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M227.46,577.92c-0.89-0.42-1.61-1.48-2.54-1.74c-0.93-0.25-2.88-0.21-2.88-0.21l-0.47,1.87l0,0 l-0.55,1.87c0,0,0.02,0.03,0.07,0.08c0.17,0.18,0.67,0.61,1.91,0.97c0.38,0.11,0.66,0.13,0.89,0.09 c0.34-0.05,0.52-0.22,0.62-0.39c0.11-0.19,0.12-0.38,0.12-0.38c-0.21-0.24-1.5-1.63-2.26-2.43l0.18-0.04l1.13-0.26 c0,0,1.13,0.99,2.32,1.64c0.4,0.22,0.8,0.4,1.18,0.5c0.92,0.24,1.37-0.25,1.58-0.65c0.12-0.24,0.16-0.45,0.16-0.45 S228.35,578.34,227.46,577.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M223.6,591.4c-0.13,0.02-0.27,0.05-0.4,0.1C223.89,591.35,224.39,591.31,223.6,591.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M187.38,608.02c5.55-4.49,11.24-8.83,14.55-10.62C198.81,599,193.41,603.08,187.38,608.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.8,619.01c0,0.04,0.01,0.08,0.01,0.12C324.81,619.08,324.81,619.05,324.8,619.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.73,618.69C324.73,618.69,324.73,618.69,324.73,618.69C324.73,618.69,324.73,618.69,324.73,618.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.77,618.83c0.01,0.02,0.01,0.04,0.01,0.06C324.78,618.87,324.78,618.85,324.77,618.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M318.33,627.22c-3.38,1.92-10.09,5.34-13.65,6.92l0,0.01C308.23,632.57,314.95,629.16,318.33,627.22 c3.38-1.92,5.09-5.44,6.12-6.97c0.12-0.18,0.21-0.36,0.27-0.53c-0.06,0.17-0.14,0.35-0.27,0.53 C323.43,621.78,321.71,625.3,318.33,627.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.81,619.21c0,0.07-0.01,0.15-0.02,0.22C324.8,619.36,324.81,619.28,324.81,619.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.78,619.47c-0.01,0.07-0.03,0.14-0.06,0.22C324.75,619.61,324.77,619.54,324.78,619.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M324.56,618.36C324.56,618.36,324.56,618.37,324.56,618.36c0.45-0.54,1-1.23,1.65-2.06 c0.43-0.55,0.63-1.01,0.7-1.41c-0.07,0.39-0.28,0.86-0.7,1.4C325.57,617.12,325.01,617.82,324.56,618.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M302.62,634.71c-2.31,0.58-11.59,3.57-14.12,3.99c-2.53,0.42-3.6,0.31-6.45,1.39 c-2.86,1.09-3,1.2-4.11,2.03c-0.41,0.31-1.48,1.2-2.68,2.19c0,0,0,0.01,0,0.01c1.2-0.99,2.27-1.88,2.68-2.19 c1.11-0.83,1.25-0.95,4.11-2.03c2.86-1.09,3.93-0.97,6.45-1.39C291.02,638.29,300.31,635.3,302.62,634.71 c0.88-0.21,1.55-0.44,2.11-0.7l0-0.01C304.17,634.26,303.5,634.49,302.62,634.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M272.38,628.74c0.2,0.1,0.36,0.29,0.49,0.58c0.25,0.56,0.46,1.11,0.67,1.67 c2.76-0.31,7.29-1.55,10.71-8.83c4.35-9.25,22.57-5.1,26.67-7.12c3.54-1.75,6.92-3.76,12.67-6.41 c-1.94,0.25-4.72,1.28-5.63,1.47c-1.38,0.3-5.31,1.84-5.31,1.84s-6.73,0.88-10.33,0.93c-3,0.05-7.08,0.71-7.97,0.62 c-0.02,0.1-0.03,0.16-0.03,0.16s-0.82,0.06,0.01-1.82c0.82-1.88,2.38-3.53,4.07-4.58c1.69-1.05,2.26-1.25,4.63-2.39 s2.02-3.35,2.21-4.01c0.01,0.01,0.01,0.01,0.02,0.02c-0.51-0.78-1.48-1.04-2.02-0.71c-1.14,0.71-3.44,1.67-5.34,2.44 c-1.9,0.78-3.67,1.72-5.56,3.1s-4.85,1.83-6.98,3.26c-2.13,1.43-3.09,2.37-4.88,4.14c-1.78,1.77-4,2.66-5.28,6.08 c-1.28,3.42-2.09,3.86-3.26,4.87c-0.36,0.31-1.05,0.85-1.9,1.51C270.84,626.2,271.66,627.18,272.38,628.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M326.11,613.17c0.56-0.81,0.81-1.47,0.87-2C326.93,611.7,326.68,612.36,326.11,613.17 C326.11,613.17,326.11,613.17,326.11,613.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M326.11,613.17C326.11,613.17,326.11,613.17,326.11,613.17c0.56-0.81,0.81-1.47,0.87-2 c0.18-1.6-1.39-2.05-1.39-2.05c-0.61-0.8-1.54-0.98-2.54-0.85c-0.01,0-0.02,0.01-0.03,0.01c-5.75,2.65-8.96,3.61-12.5,5.36 c-4.1,2.02-23.07-1.82-27.42,7.43c-3.42,7.27-6.82,9.6-9.58,9.91c0.54,1.47,0.09,3.44,0.38,4.86c0.31,1.55-0.02,3.36,0.05,4.78 c0.09,1.61,1.4,2.31,1.29,3.69c1.2-0.99,2.27-1.88,2.68-2.19c1.11-0.83,1.25-0.95,4.11-2.03c2.86-1.09,3.93-0.97,6.45-1.39 c2.53-0.42,11.82-3.41,14.12-3.99c0.88-0.22,1.55-0.45,2.11-0.71l0,0.01l-0.05,0.13c0,0,0,0,0,0 c3.56-1.58,10.27-4.99,13.65-6.92c3.38-1.92,5.09-5.44,6.12-6.98c0.12-0.18,0.21-0.36,0.27-0.53c0-0.01,0.01-0.02,0.01-0.03 c0.02-0.07,0.04-0.15,0.06-0.22c0-0.01,0.01-0.02,0.01-0.03c0.01-0.08,0.02-0.15,0.02-0.22c0-0.03,0-0.06,0-0.09 c0-0.04,0-0.08-0.01-0.12c0-0.04-0.01-0.08-0.02-0.12c0-0.02-0.01-0.04-0.01-0.06c-0.01-0.05-0.02-0.09-0.04-0.14c0,0,0,0,0,0 c-0.04-0.12-0.1-0.22-0.16-0.32c0,0,0,0,0,0c0.44-0.55,1-1.24,1.65-2.07c0.42-0.54,0.63-1.01,0.7-1.4 C327.12,613.73,326.14,613.18,326.11,613.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M126.49,602c4.23-0.28,10.51-1.94,15.72-2.83c-1.42-4.74-5.01-16.73-2.37-20.54 c-0.12,0.08,7.1-5.05,12.62-3.21c-0.4-0.01,3.85,0.41,5.82,0.63c3.62,0.4,6.12-2.68,6.58-6.43c0.56-4.58-0.92-5.58,0.71-7.3 c0.58-0.61,1.25-1.24,1.45-1.95c-0.05,0.1-0.1,0.19-0.16,0.28c0,0-1.52-5.26-1.3-5.53c1.3-1.57,2.04-2.85,2.21-3.15 c-0.11-0.18-0.25-0.37-0.42-0.58c-1.24-1.51-1.21-3.32-0.99-4.46c0.48-2.48,3.01-3.02,4.19-3.07c0.03,0,0.07-0.02,0.09-0.03 c1.35-0.96,1.15-2.26-1.31-5.53c-2.35-3.14-4.73-7.13-5.29-8.08c-0.08-0.13-0.09-0.29-0.04-0.43l-0.04-2.44l1.54-1.69l0,0 c-0.74-1.71-2.06-3.48-1.72-4.5c0.07-0.21,0.12-0.44,0.14-0.69c-0.01,0.03-0.01,0.04-0.01,0.04c-0.28-0.28-0.57-0.55-0.91-0.71 c0,0,0,0-0.01,0c-0.52,0.47-0.89,0.72-0.98,0.77c-0.01,0.01-0.02,0.01-0.03,0c-0.07-0.08-0.37-0.41-1.06-0.42c0,0,0,0,0,0 c-0.28,0.19-0.58,0.44-0.91,0.77c0,0,0.13-0.3,0.35-0.72c-0.42,0.09-0.94,0.28-1.56,0.64c-1.88,1.09-4.83,1.49-7.08,1.67 c-0.56,0.05-1.08,0.08-1.53,0.11c-0.14,0.03-0.28,0.06-0.51,0.07c-0.04,0-0.08,0.01-0.12,0.02c-0.05,0.01-0.09,0.02-0.14,0.04 c-0.01,0-0.01,0-0.02,0c-0.01,0-0.02,0.01-0.03,0.01c-0.31,0.12-0.65,0.36-0.75,0.62c-0.57,0.99-1.64,2.95-2.48,5.13 c-0.38,1.04-0.71,2.13-0.89,3.18c-0.16,0.94-0.46,1.76-0.83,2.48c-0.04,0.07-0.07,0.15-0.11,0.22 c-0.04,0.07-0.08,0.14-0.11,0.21c-1.47,2.65-3.97,4-3.97,4l0-9.14c-0.75,0.51-1.48,0.97-2.19,1.33c0,0,0.06-0.15,0.14-0.35 c0,0-0.01,0-0.01,0.01c0,0,0.04-0.09,0.1-0.24c0.19-0.52,0.39-1.21,0.16-1.21c-0.17,0-0.65,0.41-1.28,0.99 c-0.2,0.18-1.86,1.73-2.1,1.95c-0.2,0.18-0.4,0.35-0.59,0.52c0,0,0.1-0.17,0.2-0.4c-0.02,0.02,0.02-0.1,0.12-0.31 c0.07-0.22,0.11-0.44,0.07-0.61c-0.17-0.08-0.21-0.2-0.39-0.24c-0.13-0.03-0.39,0.02-0.51,0.03c-0.24,0.07-0.53,0.2-0.89,0.39 c-0.18,0.09-0.34,0.17-0.47,0.22c-0.02,0.02-0.04,0.04-0.06,0.05c-0.45,0.39-1.11-0.16-0.78-0.66c0.01-0.01,0.01-0.02,0.02-0.03 c0.03-0.04,0.05-0.09,0.06-0.14c0.27-1.07,1.06-2.9,0.85-4.57c0,0-1.59,0.19-3.25,4.54c-1.66,4.35-5.3,21.38-8.84,29.74 c-2.09,4.95-7.53,9.87-20.21,7.91c0,0,0,0,0,0c-0.3,12.3-6.25,19.09-8.88,21.5C93.48,591.85,101.94,602.43,126.49,602z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M169.68,544.37c0.06-0.03,0.12-0.06,0.18-0.09c-0.32,0.14-0.62,0.28-0.88,0.41 C169.2,544.59,169.43,544.48,169.68,544.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M140.51,556c0-0.12,0-0.18,0-0.18S140.51,555.89,140.51,556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M166.7,526.53l0.12,0.09C166.82,526.62,166.78,526.58,166.7,526.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M194.57,701.25c0.04-0.06,0.08-0.13,0.12-0.19c-1.02-0.36-2.07-0.77-3.14-1.22 C193.48,700.76,194.57,701.25,194.57,701.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M180.12,694.19c-3.88-2.07-8.29-4.48-13.47-7.19C171.57,689.73,176.15,692.15,180.12,694.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M57.25,794.16c0.39,0.36,0.79,0.72,1.19,1.07c-0.39-0.48-0.75-0.97-1.09-1.47 C57.28,794.02,57.25,794.16,57.25,794.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M67.52,703.19c0.05,0.26,0.09,0.52,0.14,0.79c-1.7-12.63-4.11-22.12-6.26-31.95 C63.32,682.04,65.54,692.55,67.52,703.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M68.49,711.1c1.76,24.6-5.73,60.09-9.36,75.47C62.93,771.65,70.97,736.13,68.49,711.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M57.2,645.78c-0.37-4.29-0.63-8.93-0.73-14.08C56.4,636.08,56.68,640.8,57.2,645.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M107.2,809.09c13.09,0.52,26.41-0.3,37.69-1.47C134.67,808.58,120.9,809.46,107.2,809.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M152.19,712.79c2.05,20.84,6.88,33.84,6.21,48.34c-1.02,21.82-8.57,25.84-0.68,45.06 c8.07-1.22,16.64-2.94,16.64-2.94s-15.08-52.35-12.28-118.68c-0.7-0.4-1.36-0.82-1.97-1.24 C160.11,683.34,149.28,683.3,152.19,712.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M195.55,701.35c-0.12-0.04-0.24-0.08-0.36-0.12C195.31,701.27,195.43,701.31,195.55,701.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M273.53,630.98c-0.2-0.55-0.42-1.11-0.67-1.67c-0.13-0.29-0.29-0.47-0.49-0.58 c-2.71-1.38-14.57,11.11-29.48,28.76c-16,18.95-20.98,5.5-23.51,2.98c-2.53-2.53-6.91-3.63-6.49-2.37 c0.42,1.26-5.42-2.35-5.42,3.13c0,5.47-4.81-2.9-4.81-2.9s0.66,13.67-10.53,5.57c-8.73-6.31-16.72-22.42-16.72-22.42 c-6.44-13.89-25.7-44.19-43.79-43.24c-1.65,0.09-3.24,0.14-4.76,0.17c-24.55,0.43-33.38-6.58-35.37-8.55 c-0.33-0.32-0.47-0.51-0.47-0.51c-19,4.92-34.82,19.75-34.56,40.76c0.01,0.53,0.02,1.06,0.03,1.58 c0.1,5.14,0.35,9.79,0.73,14.08c0.89,10.18,2.45,18.32,4.19,26.25c2.15,9.82,4.56,19.32,6.26,31.95 c0.29,2.15,0.56,4.38,0.8,6.72c0.01,0.13,0.03,0.27,0.04,0.4c1.05,28.76-6.02,60.79-9.36,75.47c-1.01,4.44-1.88,7.03-1.88,7.03 c0.03,0.05,0.07,0.1,0.11,0.16c0.33,0.51,0.7,1,1.09,1.47c8.2,9.98,28.4,13.31,48.76,13.87c13.7,0.37,27.47-0.51,37.69-1.47 c9.86-0.93,16.41-1.92,16.41-1.92c-0.02-0.06-0.05-0.11-0.07-0.17c-7.89-19.22-0.9-22.73,0.11-44.55 c0.68-14.5-3.84-27.71-5.9-48.54c-2.9-29.48,4.65-29.11,4.65-29.11c0.62,0.42,1.27,0.84,1.97,1.24c0.5,0.29,1.01,0.58,1.55,0.85 c1.04,0.53,2.04,1.06,3.02,1.57c5.18,2.71,9.59,5.12,13.47,7.19c4.35,2.32,8.04,4.22,11.43,5.65c1.07,0.45,2.12,0.86,3.14,1.22 c0.17,0.06,0.34,0.12,0.5,0.17c0.12,0.04,0.24,0.08,0.36,0.12c7.01,2.29,13.23,2.24,22.37-0.66 c14.03-4.45,24.49-19.28,36.99-30.37c13.64-12.1,18.87-18.55,18.87-18.55s1.1-2.99,1.47-7.45c0,0,0-0.01,0-0.01 C275.55,640.6,275.33,635.87,273.53,630.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M191.22,645.51c0.7-3.63,4.37-9.42,5.65-13.18c2.08-6.11,5.51-12.17,7.88-17.15 c2.25-4.74,3.19-8.87,3.58-11.19c0.21-1.26-0.84-1.41-0.84-1.41c-0.4-0.48,0.35-1.51,0.06-1.94c-0.75-1.1-1.25-2-1.97-2.62 c-0.02-0.02-1.92,0.7-1.94,0.68c-1.04-0.88-1.7-1.3-1.7-1.3c-3.3,1.78-9,6.13-14.55,10.62c-7.87,6.36-15.43,13.01-15.43,13.01 c0.03,0.03-0.03,1.25,0,1.28c0.83,0.83,1.25,1.91,2.37,3.16c3.19,3.56,6.65,10.29,9.87,14.2 C187.3,643.42,191.22,645.51,191.22,645.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0948F",
    d: "M126.86,598.42c1.54-0.1,3.13-0.24,4.8-0.41c-1.01-10.68,3.41-16.4,8.16-19.35 c2.08-1.28,4.22-2.04,6-2.45c2.85-0.65,4.65-0.81,6.25-0.76c0.16,0,0.32,0.01,0.47,0.02c1.7,0.1,3.26,0.41,5.74,0.58 c1.65,0.11,2.86-0.42,3.59-0.9c0.54-0.35,0.82-0.67,0.82-0.67c-0.02,0.01-0.04,0.02-0.07,0.03c-8,3.8-4.77-12.12-5.16-20.92 c-0.36-7.99-1.34-10.52-3.34-15.74c-1.99-5.19-4.93-11.66-3.25-15.27c-0.24,0.02-0.47,0.03-0.68,0.04 c-0.14,0.03-0.28,0.06-0.51,0.07c-0.04,0-0.08,0.01-0.12,0.02c-0.05,0.01-0.09,0.02-0.14,0.04c-0.01,0-0.01,0-0.02,0 c-0.01,0-0.02,0.01-0.03,0.01c-0.31,0.12-0.65,0.36-0.75,0.62c-0.57,0.99-1.64,2.95-2.48,5.13c-0.38,1.04-0.71,2.13-0.89,3.18 c-0.16,0.94-0.46,1.76-0.83,2.48c-0.04,0.07-0.07,0.15-0.11,0.22c-0.04,0.07-0.08,0.14-0.11,0.21c-1.47,2.65-3.97,4-3.97,4 l0-9.14c-0.75,0.51-1.48,0.97-2.19,1.33c0,0,0.06-0.15,0.14-0.35c0,0-0.01,0-0.01,0.01c0,0,0.04-0.09,0.1-0.24 c0.19-0.52,0.39-1.21,0.16-1.21c-0.38,0-2.3,2.05-3.97,3.46c0,0,0.1-0.17,0.2-0.4c-0.02,0.02-0.04,0.04-0.06,0.06 c0,0,0.09-0.16,0.18-0.37c0.21-0.67,0.17-1.42-1.72-0.44c-2.94,1.54,0-2.05-0.38-5.12c0,0-1.59,0.19-3.26,4.54 c-1.66,4.35-5.3,21.38-8.84,29.74c-2.1,4.97-7.57,9.92-20.37,7.88c0.04,0.98,0.09,1.93-0.01,2.84 c-0.74,6.29-3.31,12.28-5.89,15.57c-1.08,1.37-2.09,2.41-2.83,3.1C93.43,591.81,102.25,598.86,126.86,598.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M325.75,609.56c-0.22,0.84-1.33,1.81-1.33,1.81s-1.08-0.33-0.64-1.2c0.47-0.93,0.91-1.25,0.91-1.25 s-1.58,1.2-1.24,2.02c0.34,0.82,0.64,0.7,0.64,0.7s-0.72,1.05-1.8,1.76c-1.08,0.71-1.35,0.42-1.35,0.42s-0.3,0.79-2.46,2.25 c-1.21,0.82-1.88,1.3-2.57,1.68c-0.38,0.12-0.61-0.24-0.61-0.24s0.17,0.46-0.37,0.71c0,0-0.13,0.08-0.94,0.36 c-1.9,0.66-6.54,2.15-8.7,2.79c-1.19,0.35-1.68,0.16-1.85,0.03c0.01,0.03,0.03,0.06,0.05,0.11c0.03,0.07,0.07,0.16,0.12,0.27 c0.3,0.3,0.64,0.68,1,1.15c-0.13-0.5-0.17-0.96,0.1-1.01c0.62-0.11,5.58-1.69,7.92-2.44c2.34-0.74,3.14-0.87,3.92-1.61 c0.78-0.74,4.22-2.8,5.31-3.63s2.15-1.76,2.98-2.63C325.66,610.72,325.9,608.98,325.75,609.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M326.92,610.68c0,0-0.03,1.23-0.9,2.31c-0.45,0.56-0.82,0.85-1.06,1c-0.17-0.14-0.55-0.56-0.23-1.2 c0.4-0.79,1.43-2.28,1.43-2.28s-1.11,1.55-1.66,2.27c-0.53,0.69,0,0.93,0.02,1.58c-0.16,0.38-0.56,1.26-1.41,2.86 c-0.08,0.16-0.18,0.3-0.27,0.44c-0.39,0.26-0.63-0.31-0.67-0.03c-0.03,0.25-0.04,0.65-0.08,1.02c-0.86,0.97-1.88,1.68-2.87,2.56 c-0.19,0.17-0.38,0.33-0.57,0.48c-0.23,0.11-0.37,0.03-0.45-0.09c0.03,0.15,0.05,0.31-0.01,0.44c-1.16,0.84-2.39,1.49-3.36,1.88 c-1.28,0.52-3.65,1.48-5.44,2.37c-1.33,0.66-2.22,0.37-2.59,0.18c0.17,0.34,0.33,0.7,0.5,1.07l0.34,0.58c0,0,0-0.47,3.19-2 c3.18-1.53,4.32-1.98,6.31-2.99c1.99-1.01,4.6-3.59,5.34-4.68c0.73-1.1,1.66-2.87,2.01-3.54c0.36-0.67,1.63-1.76,1.63-1.76 s0-0.01,0-0.01c0.01-0.01,0.03-0.04,0.06-0.09C326.38,612.73,327.07,611.5,326.92,610.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A0D",
    d: "M96.71,806.34c25.63-1.22,34.19-7.63,3.48-12.37c-43.75-6.75-30.94-10.91-16.9-17.32 c14.28-6.53-10.93-3.88-2.03-29.29c5.45-15.57-2.13-32.72-8.54-49.63c-4.18-11.01-8.09-21.85-11.12-31.09 c-3.07-17.61-5.42-39.19,2.29-52.66c9.59-16.75,18.46-19.15,27.13-24.62c0,0-1.85,0.31-4.86,1.5 c-5.56,2.21-15.09,7.44-24.32,19.39c-0.29,0.38-0.57,0.79-0.83,1.21c-1.13,1.77-2.01,3.87-2.68,6.22 c-1.32,4.64-1.82,10.27-1.79,16.31c0.02,2.95,0.16,6.01,0.41,9.09c0.15,1.86,0.33,3.73,0.54,5.6c0.32,2.83,0.37,6.15,1.8,12.79 c0.11,0.5,0.22,1.01,0.33,1.53c0.43,2.41,0.88,4.73,1.34,6.94c0.19,0.94,0.39,1.86,0.58,2.76c0.24,1.13,0.49,2.23,0.72,3.28 c0.47,2.42,0.91,4.94,1.41,7.49c3.86,19.7,4.54,29.03,4.77,39.07c0.53,23-11.18,71.6-11.18,71.6s1.51,2.96,5.11,4.73 C69.22,802.27,81.78,807.06,96.71,806.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B5743",
    d: "M160.11,683.34L160.11,683.34L160.11,683.34c0,0-7.56-0.37-4.65,29.11c2.05,20.84,6.57,34.04,5.9,48.54 c-0.9,19.34-6.49,24.29-2.25,38.56c0.12,0.29,0.17,0.46,0.17,0.46s6.22-22.14,0.14-75.92 C156.11,694.83,160.74,686.73,160.11,683.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M325.52,616.98c-0.14-0.23-0.5-0.86-0.29-1.23c0.25-0.45,1.32-1.51,1.32-1.51 c-0.48,0.44-1.12,0.9-1.44,1.36c-0.1,0.15-0.16,0.46-0.13,0.59c0.11,0.43,0.31,0.8,0.4,0.93c-0.86,0.92-1.33,1.68-2.57,3.06 c-0.28,0.31-0.62,0.68-0.98,1.08c-1.69,1.84-4,4.29-4.58,4.93c-0.71,0.78-8.58,5.04-8.58,5.04l0,0c0,0,7.48-3.62,9.01-4.68 c0.77-0.54,4.84-5.41,5.75-6.8l0.71-0.87c-0.39,0.55-0.59,1.02-0.38,1.32c0.19,0.28,0.35,0.43,0.42,0.49c0,0,0,0,0,0 c0.02,0.01,0.03,0.02,0.03,0.02l0.08-0.19c0,0,0,0-0.01,0c0,0,0,0,0,0c-0.04-0.03-0.41-0.26-0.34-0.74 c0.06-0.43,0.32-0.98,0.41-1.17l1.65-2.04l0.22-0.27l0,0c0,0,0,0,0,0c-0.01,0.01-0.01,0.01-0.02,0.02 C325.94,616.56,325.72,616.77,325.52,616.98z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M163.15,527.99c-0.25,0.29-0.45,0.52-0.61,0.7c-0.49,0.47-0.72,0.66-1.24,1.35 c-0.39,0.51,0.53-0.49,1.11-0.77c0.13,0.02,0.29,0.06,0.51,0.11c0.62,0.14,0.86,0.35,0.94,0.48c0.03,0.04,0.04,0.07,0.04,0.1 c0.01,0.03,0.01,0.05,0.01,0.05s0.01-0.01,0.01-0.01c0.05-0.08,0.59-0.95,0.47-2.62l0.53-0.83c0.9-0.45,1.53-0.17,1.78-0.01 l-1.2-0.88l0,0C165.5,525.65,164.35,526.62,163.15,527.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M161.03,530.56c-0.11,0.64-1.61,1.82-1.61,1.82C160.76,531.9,160.94,531.6,161.03,530.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M160.23,530.56c0,0-0.8,0.54-1.45,0.48C158.78,531.05,159.64,531.85,160.23,530.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M167.83,544.11c-1.69,0.3-1.57-0.48-2-1.88c-0.42-1.39-1.15-4.66-1.33-4.66c-0.18,0,1.27,4.46,1.92,8.75 c0.01,0.1,0.03,0.19,0.04,0.29c0,0,0-0.74,2.5-1.98c0.26-0.13,0.56-0.27,0.88-0.41c0.13-0.06,0.26-0.12,0.4-0.17 c0.23-0.1,0.31-0.16,0.27-0.2C170.39,543.73,169.11,543.88,167.83,544.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M165.01,555.81c-0.3-0.26,1.04-4.25,0.69-3.38c-0.75,1.84-2.27,5.15-2.53,6.13 c-0.26,0.99,0.38-1.54,1.29-1.71c1.87,0.62,2.41,3.8,2.41,3.8c0.07-0.09,0.12-0.19,0.16-0.28c0.76-1.52-0.76-3.58-1.37-4.3 c0.32-0.22,0.68-0.49,1.04-0.82c1.27-1.15,1.88-2.19,1.1-3.36c0,0-0.01,0.02-0.04,0.07c-0.17,0.3-0.91,1.58-2.21,3.15 C165.34,555.39,165.16,555.61,165.01,555.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M152.46,575.42c-5.52-1.84-8.28-4.41-10.12-10.3c-1.6-5.11-1.81-8.35-1.84-9.12 c0.04,1.78,0.36,16.36-0.84,22.75c0,0,0.06-0.04,0.18-0.12c0.88-0.57,5.06-3.06,11.44-3.21 C151.67,575.42,152.06,575.41,152.46,575.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M138.83,543.64c-1.02-1.93-0.34-2.38,0.14-3.43c0.48-1.05-0.04-1.3-0.04-1.3 c-1.01,1.59-2.4,1.11-3.05,1.87c-0.65,0.76,1.16,3.62,2.11,4.75C138.94,546.65,139.85,545.56,138.83,543.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M137.57,531.37c-0.19-0.32-0.45-0.7-0.78-1.04c-0.12,0.12-2.01-1.35-2.01-1.35s-1.36,0.67-1.4,0.68 c-0.04,0.01-1.01,1.17-1.01,1.17s-0.63,0.3-0.56,0c-0.76,1.09-1.07,2.59-1.38,3.77c0,0,0.89-2.02,2.15-3.07 c-0.15,0.06,1.37-0.88,1.37-0.88s0.15,0.22,0,0.27c0.12-0.01,0.25,0,0.38,0.03c0.18,0.04,0.36,0.1,0.52,0.18 c-0.01-0.07,0.68,0,0.68,0l0.26,0.13c-0.11,0.1-0.22,0.21-0.33,0.31c0.79,0.79,1.08,2.16,0.06,3.4 c-1.42,1.73-1.93,2.48-2.24,3.81c-0.31,1.33,0.64,2.56,0.64,2.56s0.2-1.02,0.52-2.26c0.32-1.23,1.82,0.45,3.26-1.08 C139.15,536.47,138.15,532.33,137.57,531.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M136.56,548.86c0,0-5.1-5.5-5.51-10.3C131.06,538.56,131.63,547.06,136.56,548.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M120.58,560.46c3.54-8.36,7.18-25.38,8.84-29.74c1.66-4.35,3.26-4.54,3.26-4.54 c0.21,1.72-0.61,3.59-0.87,4.65c-0.17,0.72-0.08,1.05,0.78,0.7c0.14-0.06,0.29-0.13,0.47-0.22c0.36-0.19,0.66-0.31,0.89-0.39 c0.6-0.19,0.84-0.05,0.9,0.21c0.04,0.17,0,0.4-0.07,0.61c-0.03,0.11-0.08,0.22-0.12,0.31c-0.1,0.23-0.2,0.4-0.2,0.4 c0.33-0.28,0.66-0.58,1-0.88c0.46-0.42,0.91-0.85,1.33-1.24c0.8-0.75,1.44-1.33,1.65-1.33c0.24,0,0.03,0.69-0.16,1.21 c-0.03,0.08-0.06,0.16-0.09,0.23c-0.08,0.21-0.14,0.35-0.14,0.35c0.7-0.36,1.44-0.82,2.19-1.33l0,9.14c0,0,2.5-1.35,3.97-4 c0.04-0.07,0.08-0.14,0.11-0.21c0.04-0.07,0.08-0.14,0.11-0.22c0.31-0.64,0.56-1.35,0.7-2.13c0.2-1.17,0.58-2.37,1.02-3.52 c0.84-2.18,1.91-4.14,2.48-5.13c0.1-0.25,0.44-0.5,0.75-0.62c0.01,0,0.02-0.01,0.03-0.01c0.01,0,0.01,0,0.02,0 c0.05-0.02,0.1-0.03,0.14-0.04c0.04-0.01,0.08-0.02,0.12-0.02c0.23-0.01,0.36-0.04,0.51-0.07c0.17-0.04,0.35-0.08,0.71-0.11 c0.05-0.09,0.1-0.19,0.15-0.28c2.85-16.55,0.5-22.8,0.5-22.8c2.57,5.39,1.99,13.96,1.46,18.32c5.14-14.71-2.12-28.13-2.12-28.13 c8.02,11.52,3.51,29.18,3.51,29.18c8.39-23.3-8.52-36.32-8.52-36.32c10.52,6.89,13.03,20.67,13.03,20.67 c-1.01-17.87-16.55-25.05-19.72-26.33c-15.64-2.6-31.73,1.57-31.73,1.57s-2.58,0.21-5.2,1.69l0.32-0.45l0.19-0.27 c0,0-10.75,3.74-19.16,12.62c0,0,4.31-3.49,9.56-6.12c0.55-0.28,1.11-0.54,1.68-0.8c-5.5,3.41-12.43,8.02-17.09,17.96 c-2.04,4.36-2.92,8.2-3.09,11.51c0,0.01,0,0.02,0,0.03c0,0.07,0,0.13-0.01,0.2c-0.11,2.45,0.17,4.61,0.64,6.44 c1.27,5.89,4.65,13.51,11.25,22.05c0,0-3-5.28-4.89-11.45c-0.01-0.02-0.01-0.04-0.02-0.06c0.18,0.24,0.36,0.48,0.53,0.72 c1.32,1.81,2.39,3.36,2.39,3.36s1.66,2.16,5.63,7.92c3.97,5.76,6.62,10.63,6.62,10.63c3.8,7.95,3.31,13.97,3.38,13.98 c0.07,0.01,0.13,0.02,0.2,0.03C113.05,570.34,118.49,565.41,120.58,560.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M150.9,522.51c0,0,6.34-0.09,9.46-2.31c3.12-2.22,4.12-5.56,4.12-5.56l1.42-17.83 c0,0-5.16-7.94-5.68-9.47c-0.51-1.53-4.07-4.17-4.07-4.17l-10.09-4.07L150.9,522.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M107.45,478.37c0,0,16.09-4.17,31.73-1.57c3.17,1.28,18.71,8.46,19.72,26.33c0,0-2.5-13.78-13.03-20.67 c0,0,16.91,13.03,8.52,36.32c0,0,4.51-17.66-3.51-29.18c0,0,7.27,13.42,2.12,28.13c0.53-4.36,1.11-12.93-1.46-18.32 c0,0,2.36,6.26-0.5,22.8c-0.05,0.09-0.1,0.19-0.15,0.28c-0.36,0.03-0.54,0.07-0.71,0.11c0.45-0.03,0.96-0.06,1.53-0.11 c2.25-0.18,5.25-0.67,7.24-1.53c0.93-0.4,0.95-0.49,1.4-0.78c-0.22,0.41-0.35,0.72-0.35,0.72c0.33-0.33,0.63-0.58,0.91-0.77 c0.78,0.01,1.07,0.44,1.07,0.44s0.4-0.25,1-0.79c0.34,0.17,0.64,0.43,0.92,0.71c0,0,0-0.02,0.01-0.04 c0.05-0.19,0.22-0.98,0.04-1.64c2.27-2.51,5.49-7.86,3.68-16.97c-0.82-4.15-2.2-7.66-3.99-10.64c4.54,5.58,5.1,10.82,5.17,12.03 c-0.52-17.17-17.4-23.44-21.03-24.59c-2.75-1.01-5.61-1.72-8.49-2.2c-15.64-2.6-31.73,1.57-31.73,1.57s-2.46,0.2-5.02,1.59 l-0.32,0.45C104.87,478.58,107.45,478.37,107.45,478.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M226.48,570.92c-0.76,0.04-1.19-0.34-1.19-1.27c-0.4,0.76-2.07,3.64-2.27,3.99c0,0,0,0,0,0 c-0.01,0.02-0.02,0.04-0.02,0.04c0.05,0,0.1-0.01,0.15-0.02c1.81-0.19,2.82-0.76,2.82-0.76c3.69,1.38,4.31-0.44,4.4-0.87 c0.01-0.05,0.02-0.09,0.02-0.09C229.5,572.49,227.25,570.88,226.48,570.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M220.76,592.72c0.04,0.61,1.28-0.8,2.44-1.21c-0.41,0.1-0.89,0.23-1.21,0.41 c-0.85,0.47,0.21-0.68,0.76-0.98s-0.85,0.55-1.44-0.17c-0.31-0.38-0.59-0.81-0.78-1.12c-0.17-0.29-0.28-0.49-0.28-0.49 c0.01,0.02,0.01,0.04,0.02,0.06C220.76,590.44,220.72,592.05,220.76,592.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M131.62,598.26c18.09-0.96,34.9,30.23,41.34,44.12c0,0,9.84,17.35,18.56,23.66 c11.2,8.09,11.37-6.16,11.37-6.16s3.37,2.95,3.79,8.42c0.42,5.47,0,8.84,0,8.84s2.11-9.27,2.11-14.74c0-5.47,2.11-1.68,2.53,3.37 c0.42,5.05,2.11-5.05,1.68-6.32c-0.42-1.26,2.53,0,5.05,2.53c2.53,2.53,11.3,17.21,27.3-1.74c14.91-17.65,24.31-32.89,27.02-31.5 c-0.71-1.56-1.54-2.54-2.35-3.17c-0.13-0.1-0.26-0.19-0.38-0.28c-3.29-2.16-8.21,1.04-10.12,2.24 c-35,22.08-49.38,28.64-51.85,29.71c-1.85-0.26-6.18-2.06-14.2-11.32c11.58-16.87,20.71-34.76,20.71-34.76 c-0.17-0.48-0.41-0.98-0.68-1.48c0.38-0.57,0.75-1.1,0.98-1.39c0.5-0.63,1.85-1.8,2.94-2.67c0.38-0.3,1.27-0.92,1.54-1.12 c1.06-0.76,3.83-2.1,4.68-2.66c0.28-0.18,0.57-0.37,0.86-0.55c0.57-0.36,1.16-0.74,1.81-1.19c0.14-0.1,0.29-0.19,0.45-0.3 c0.67-0.42,1.5-0.86,2.16-1.26c0.32-0.19,0.59-0.37,0.78-0.52c0.62-0.5,1.37-1.53,2.21-2.7c0.08-0.12,0.17-0.24,0.25-0.36 c0.93-1.31,3.22-3.6,3.99-4.54c0.01-0.01,0.02-0.02,0.02-0.03c0.74-0.91,0.83-1.48,1.08-3.45c0.21-1.64,0.93-3.62,1.18-4.27 c0.05-0.14,0.09-0.22,0.09-0.22l-1.15,2.38c-0.42-0.3-0.72-0.59-0.51-1.31c0.21-0.72,0.64-1.57,1.23-2.04 c0,0-1.27,1.02-1.53,2.12c-0.25,1.1,0.81,1.23,0.59,1.99c-0.21,0.76-0.42,3.27-1.06,3.65c-0.64,0.38-1.4,1.78-4.03,4.24 c-2.63,2.46-2.29,3.44-5.51,5.05s-9.5,4.96-13.74,7.34c-0.52,0.29-0.97,0.55-1.37,0.79c-1.24-1.57-2.7-3.11-4.11-4.47 c1.27-1.06,2.96-2.21,4.94-2.95c4.45-1.65,5.97-3.78,4.18-7.4s0.25-7.06,1.46-12.85c1.21-5.79,1.21-8.97,4.33-12.41 c0,0,2.04-2.87,2.44-3.28s1.93,0.66,3.79-1.81c0.12-0.16-2.32,2.22-3.57,1.12c0,0-3.81,3.33-5.53,5.05 c-0.23,0.23-0.45,0.44-0.64,0.62c-1.22,1.17-1.68,1.49-2.29,2.81c0,0,0.14-1.32,0.51-1.97c0.03-0.06,0.06-0.11,0.1-0.16 c-0.06,0.07-0.15,0.16-0.26,0.3c-0.52,0.61-1.56,1.91-2.64,3.74c-0.44,0.76-0.9,1.43-1.36,2.05c-1.14,1.51-2.37,2.68-3.86,3.8 c-2.1,1.59-2.54,1.78-2.54,5.47s-0.88,10.23-1.68,12.34c-0.29,0.77-0.68,1.5-1.05,2.11c1,0.85,2.34,2.12,3.78,3.82 c0,0-13.03,22.51-16.56,40.68c0,0-13.39-16.63-18.87-22.14c-0.06,0.05-0.12,0.11-0.18,0.16c-17.55-17.73-30.05-24.71-30.05-24.71 c-0.28,0.05-0.55,0.09-0.82,0.14c-5.21,0.88-9.91,1.43-14.13,1.71C128.39,598.4,129.97,598.34,131.62,598.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M302.76,604.19c-2.37,1.14-3.64-0.98-3.64-0.98s0.47,2.36-1.22,3.41c-1.69,1.05-3.36,3.09-4.19,4.96 c-0.82,1.88-1.28,1.94-3.64,1.96c-0.51,0-0.91,0-1.2-0.02c0.2,0.02,0.43,0.06,0.71,0.11c1.82,0.31-0.8,0.63-2.58,1.4 c0.92-0.31,7.3-1.39,7.3-1.39s0.01-0.06,0.03-0.16c0.02-0.1,0.06-0.24,0.13-0.41c0.11-0.29,0.29-0.66,0.59-1.05 c0.13-0.16,0.27-0.33,0.44-0.49c0.25-0.24,0.58-0.47,0.96-0.72c1.26-0.81,3.09-1.69,4.59-2.77c0.47-0.34,0.87-0.64,1.23-0.91 c1.12-0.86,1.77-1.5,2.49-2.62c0.94-1.46,1.46-2.63,0.48-3.64c-0.01-0.01-0.01-0.01-0.02-0.02 C305.04,601.5,305.13,603.04,302.76,604.19z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 10 168.8479)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "promised"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 35 226.1699)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "We aim to reduce "), /*#__PURE__*/React.createElement("tspan", {
    x: 133.89,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "23px"
  }, "CO2-EMISSIONS"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "17px"
  }, "per vehicle produced.")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 944 168.8477)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "50px",
    letterSpacing: -1
  }, "delivered")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.83368e6c.svg";
export { ForwardRef as ReactComponent };